// - DONE BY DART
// - edited by Christian Lie 2025-07-03
// - reapplied on top of EN version by nekear 2025-08-15
const translationEN = {
  navbar: {
    home: "Hjem",
    product: "Produkt",
    pricing: "Prissetting",
    partners: "Partnere",
    about_us: "Om oss",
    support: "Support",
    news: "Nyheter",
    login: "Logg Inn"
  },
  footer: {
    desc: "\n            Strømlinjeform ditt lager med skybaserte Suppli lagerstyringssystem. Hold deg oppdatert og ha full kontroll på lageret ditt slik at kundene dine er fornøyde og du kan selv fokusere på verdiskapning og vekst.\n        ",
    copyright: "Copyright 2025, By Suppli",
    company: {
      title: "Firmanavn"
    },
    product: {
      title: "Produkt",
      links: {
        1: "Start gratis prøveperiode",
        2: "FAQ"
      }
    },
    followUs: "Følg oss"
  },
  homePage: {
    welcomeBlock: {
      main: "Få full kontroll på lageret ditt",
      desc: "Med Suppli vil du ha full kontroll over dine varer, innkjøp, salgsordre, leveringer, og varemottak.",
      btnText: "Kom igang"
    },
    whyUsBlock: {
      preTitle: "Hvorfor velge oss?",
      title: "Fordeler med et lagerstyringssystem",
      cards: {
        organize: {
          main: "Organiser",
          desc: "Organiser og hold orden på inventaret på en enkel måte"
        },
        reports: {
          main: "Rapporter",
          desc: "Gå aldri tom for varer ved hjelp av varsler og rapporter"
        },
        manageSales: {
          main: "Organiser salg",
          desc: "Organiser salget ditt med et smartere lagerstyringssystem"
        },
        control: {
          main: "Kontroll",
          desc: "Total kontroll og synlighet på lageret i sanntid"
        },
        integrations: {
          main: "Integrasjoner",
          desc: "Integrasjoner med regnskapssystemet, nettbutikken, og fraktssystemet"
        }
      }
    },
    productBlock: {
      preTitle: "Suppli",
      title: "Produkt",
      descriptions: {
        1: "\n                    er et skybasert lagersystem som gir deg full kontroll over produkter, \n\t\t\t\t\tinnkjøp,\n\t\t\t\t\tsalgsordrer, levering, lagerflyt og varetelling.\n                     .\n                ",
        2: "\n                    Suppli optimerer ditt lager slik at du får full oversikt over avgjørende\n\t\t\t\t\tfaktorer som lager, leveringsplaner og ordrestørrelser..\n                ",
        3: "\n                    Logger all aktivitet på produktene dine, slik at det er enkelt å se hele \n\t\t\t\t\thistorien til hver vare.. For\n                    eksempel, når ble det solgt sist, om det har blitt flyttet til en annen \n                    lokasjon, brekkasje, om det er noen ordre og om det har bidratt til endringer i systemet og hvem som har gjort disse endringene.\n                ",
        4: "\n                    kan integreres med forskjellige systemer og kommuniserer i sanntid\n                    . Denne kommunkasjonen gjør at systemet oppdateres med lagerverdi,\n\t\t\t\t\tfakturagrunnlag, online lagerstatus og automatisk webordrehenting.                    \n                "
      },
      productFooter: {
        btnMain: "Se mer",
        videoBtn: "Se Video"
      }
    },
    pricingBlock: {
      preTitle: "Kom igang raskt og enkelt",
      title: "Priser",
      desc: "\n                For å kunne bruke Suppli som en kunde trenger du en obligatorisk startpakke \n\t\t\t\t, en premium lisens, og en av brukerstøttepakkene.\n                \n            ",
      pricingItems: {
        1: {
          title: "Startpakke",
          features: {
            1: "Suppli programvare",
            2: "3 timers nettbasert opplæring av ansatte i bruk av Suppli*",
            3: "Oppsett av Suppli-konto",
            4: "Importer produkter, kunder og leverandører",
            5: "Oppsett av integrasjoner"
          },
          price: "Kr 15 000, -",
          btn: "Kjøp nå",
          footnotes: {
            1: "\n                        *Våre konsulenter kan komme fysisk eller gjennomføre opplæring på med skjermdeling. Kontakt oss for pristilbud.\n                        ",
            2: "\n                            **Opptil tre importfiler. Filene må være i korrekt format. Vennligst se vår eksempelmal.\n                        ",
            3: "\n                            ***Opptil tre integrasjoner. Integrasjonen må være i vår portefølje.\n                        "
          }
        },
        2: {
          title: "Lisens",
          premium: {
            title: "Premium",
            features: {
              1: "Full tilgang til programmet"
            },
            price: "Kr 990/måned pr bruker"
          },
          warehouse: {
            title: "Lager",
            features: {
              1: "\n                                Tilgang til levering, lagerflyt, forsendelse, varelager telling og \n                                produktskanning.\n                            "
            },
            price: "Kr 490/Måned pr bruker"
          },
          accounting: {
            title: "Regnskap",
            features: {
              1: "\n                                Tilgang til lagerverdi, salgsstatistikk, og \n                                varelagertelling\n                            "
            },
            price: "Kr 290/Måned pr bruker"
          },
          businessP1: {
            title: "Bedriftspakke 1",
            features: {
              1: "5 premium lisenser, 5 lager lisenser, 1 regnskap"
            },
            price: "Kr 4990/Måned"
          },
          businessP2: {
            title: "Bedriftspakke 2",
            features: {
              1: "10 premium lisenser, 10 lager lisenser, 3 regnskap"
            },
            price: "Kr 9990/Måned"
          },
          btn: "Kjøp nå"
        },
        3: {
          title: "Support",
          gold: {
            title: "Gull (alt inkludert)",
            features: {
              1: "10 timers telefonstøtte månedlig.",
              2: "Hjelp med import av produkter, kunder og leverandører.",
              3: "Hjelp med prisjusteringer.",
              4: "Ekstra treningsøkter i bruk av Suppli.",
              5: "Gratis e-post og chat-støtte."
            },
            price: "Kr 2999/Måned"
          },
          silver: {
            title: "Sølv",
            features: {
              1: "3 timers telefonstøtte månedlig.",
              2: "Gratis e-post og chat-støtte"
            },
            price: "Kr 1499/Måned"
          },
          bronze: {
            title: "Bronse",
            features: {
              1: "1 time telefonstøtte månedlig",
              2: "Gratis e-post og chat-støtte"
            },
            price: "Kr 999/Måned"
          },
          btn: "Kjøp nå",
          footnotes: {
            1: "\n                            *Importfiler må være i korrekt format. Se vår eksempel fil. Arbeidstimer knyttet til import av filer blir trukket fra de inkluderte support timene i pakken din.\n                        "
          }
        }
      },
      note: "*Alle priser er ekskl. mva",
      footerTexts: {
        1: "\n                    Om dere trenger konsulenthjelp i forbindelse med oppstart eller eller hvis du trenger hjelp til å planlegge og tilpasse en lagerplan for din virksomhet, vennligst kontakt oss..\n                ",
        2: "\n                    Vi er lokalisert i Larvik. Kostnader i forbindelse med reise som hotellovernatting,\n\t\t\t\t\tdrivstoffutgifter, flybilletter og konsulenttimer faktureres.\n\t\t\t\t\tMerk at vi fakturerer halv pris for konsulenttimer for slike avtaler. Kontakt oss for priser..\n                ",
        3: "\n                    Vi har også alt utstyr du trenger for lagerstyring som skannere, bærbare datamaskiner,\n\t\t\t\t\tmobile enheter, Ipads, skrivere, strekkodeskannere, RFID-skannere..\n                "
      }
    },
    pricingBlockUSD: {
      preTitle: "Kom igang raskt og enkelt",
      title: "Priser",
      desc: "\n                For å kunne bruke Suppli som en kunde trenger du en obligatorisk startpakke \n\t\t\t\t, en premium lisens, og en av brukerstøttepakkene.\n\t\t\t\t\n            ",
      pricingItems: {
        1: {
          title: "Startpakke",
          features: {
            1: "Suppli programvare",
            2: "3 timers nettbasert opplæring av ansatte i bruk av Suppli*",
            3: "Oppsett av Suppli-konto",
            4: "Importer produkter, kunder og leverandører",
            5: "Oppsett av integrasjoner"
          },
          price: "USD 99, -",
          btn: "Kjøp nå",
          footnotes: {
            1: "\n                        *Hvis du vil at vi skal komme ha opplæring i \n                        bruken av Suppli, kontakt oss for priser.\n                        ",
            2: "\n                            ** Opptil tre importfiler. Filene må være i korrekt format. Vennligst se vår eksempelmal.\n                        ",
            3: "\n                            ***Opptil tre integrasjoner. Integrasjonen må være i vår portefølje.\n                        "
          }
        },
        2: {
          title: "Lisens",
          premium: {
            title: "Premium",
            features: {
              1: "Full tilgang til programmet"
            },
            price: "USD 99/Måned pr bruker"
          },
          warehouse: {
            title: "Lager",
            features: {
              1: "\n                                Tilgang til levering, lagerflyt, forsendelse, varetelling og \n                                produktskanning.\n                            "
            },
            price: "USD 49/måned pr bruker"
          },
          accounting: {
            title: "Regnskap",
            features: {
              1: "\n                                Tilgang til lagerverdi, salgsstatistikk, og \n                                varetelling\n                            "
            },
            price: "USD 29/måned pr bruker"
          },
          businessP1: {
            title: "Bedriftspakke 1",
            features: {
              1: "5 premium lisenser, 5 lager lisenser, 1 regnskap"
            },
            price: "USD 499/måned"
          },
          businessP2: {
            title: "Bedriftspakke 2",
            features: {
              1: "10 premium lisenser, 10 lager lisenser, 3 regnskap"
            },
            price: "USD 999/måned"
          },
          btn: "Kjøp nå"
        },
        3: {
          title: "Support",
          gold: {
            title: "Gull (alt inkludert)",
            features: {
              1: "10 timers telefonstøtte månedlig.",
              2: "Hjelp med import av produkter, kunder og leverandører.",
              3: "Hjelp med prisjusteringer.",
              4: "Ekstra treningsøkter i bruk av Suppli.",
              5: "Gratis e-post og chat-støtte."
            },
            price: "USD 285/måned"
          },
          silver: {
            title: "Sølv",
            features: {
              1: "3 timers telefonstøtte månedlig.",
              2: "Gratis e-post og chat-støtte"
            },
            price: "USD 142/måned"
          },
          bronze: {
            title: "Bronse",
            features: {
              1: "1 time telefonstøtte månedlig",
              2: "Gratis e-post og chat-støtte"
            },
            price: "USD 96/måned"
          },
          btn: "Kjøp nå",
          footnotes: {
            1: "\n                            *Importfiler må være i korrekt format. Se vår eksempel fil. Arbeidstimer knyttet til import av filer blir trukket fra de inkluderte supporttimene i pakken din.\n                        "
          }
        }
      },
      note: "*Alle priser er ekskl. MVA",
      footerTexts: {
        1: "\n                   Om dere trenger konsulenthjelp i forbindelse med oppstart eller eller hvis du trenger hjelp til å planlegge og tilpasse en lagerplan for din virksomhet, vennligst kontakt oss.. \n                \n                ",
        2: "\n                    Vi er lokalisert i Larvik og vi vil fakturere reisekostnader som hotellovernatting,\n\t\t\t\t\tdrivstoffutgifter, flybilletter og konsulenttimer.\n\t\t\t\t\tMerk at vi fakturerer halv pris for konsulenttimer for slike avtaler. Kontakt oss for priser.\n                ",
        3: "\n                    Vi har også alt utstyr du trenger for lagerstyring som skannere, bærbare datamaskiner,\n\t\t\t\t\tmobile enheter, Ipads, skrivere, strekkodeskannere, RFID-skannere. \n                "
      }
    },
    aboutBlock: {
      preTitle: "Ansatte",
      title: "Om oss",
      descriptions: {
        1: "\n                   Suppli AS er et nytt norsk selskap som ble etablert i 2021.\n\t\t\t\t   Vårt hovedformål er å gi våre kunder de beste løsninger som\n\t\t\t\t   hjelper dem å løse problemer med lager og vareflyt.\n                ",
        2: "\n                    Vi holder til i Nansetgata 25 i Larvik, kun få minutter vekk fra E18 og jernbanestasjonen.\n\t\t\t\t\tDet beste vi vet er å få besøk av våre kunder der vi er mer enn tar deg gjerne med inn i \n\t\t\t\t\tdemorommet vårt.Her kan du teste maskinvare og se løsningene våre live. \n\t\t\t\t\tVår filosofi er det samspillet mellom mennesker og teknologi bør harmonisere. \n\t\t\t\t\tDerfor har vi valgt de samarbeidspartnerne vi har i dag.\n\t\t\t\t\tDe er fremtidsrettede, yter enestående service og har produkter som\n\t\t\t\t\thjelper våre kunder med effektivitet og fortjeneste. \n\t\t\t\t\t\n\t\t\t\t\tVi ser frem til å samarbeide med deg, så kontakt oss for en uforpliktende prat eller demo.\n                    \n                   \n                ",
        3: "\n                    .\n                "
      },
      team: {
        1: {
          position: "Utviklingssjef"
        },
        2: {
          position: "KAM Norden"
        },
        3: {
          position: "CEO"
        },
        4: {
          position: "CMO"
        },
        5: {
          position: "CFO"
        }
      }
    },
    supportBlock: {
      title: "Support",
      text1: "\n                Vårt supportteam er alltid klare for å hjelpe deg med dine problemer eller spørsmål.\n            ",
      text2: "For support kontakt oss på telefon",
      text3: "eller supportmail",
      text4: "\n                Du kan alltid bruke support chaten mens du er logget inn i systemet.\n                \n            ",
      postalAddress: "\n                Postadresse\n            ",
      info1: "Suppli AS",
      info2: "Nansetgata 25",
      info3: "3256 Larvik",
      info4: "Norge",
      text5: "SUPPORT ÅPNINGSTIDER",
      text6: "Mandag - fredag",
      text7: "Lørdag - søndag",
      text8: `
                Stengt (utenfor
                åpningstider, du vil bli fakturert Kr 1999/time
                uavhengig av avtale)
            `,
    },
  },
  productPage: {
    productsBlock: {
      header: "Suppli produkter",
      desc: "Jobb smartere og dekk din bedrifts behov med vårt brukervennlige og intuitive lagerstyringssystem"
    },
    productDesc: {
      1: {
        header: "Full kontroll",
        description: "Suppli er et skybasert lagersystem som gir deg full kontroll over produkter, innkjøp, salgsordrer, levering, lagerflyt og varetelling. Siden systemet er skybasert, kan du jobbe fra hvor som helst og på hvilken som helst enhet."
      },
      2: {
        header: "Ordrestyring",
        description: "Hold styr på alle bestillingene dine. Suppli optimerer ditt lager slik at du får full oversikt over avgjørende faktorer som lager, leveringsplaner og ordrestørrelser."
      },
      3: {
        header: "Inventar",
        description: "Logger all aktivitet på produktene dine, slik at det er enkelt å se hele historien til hver vare. Salgsstatistikk, plasseringsbevegelser, brekkasje, nye bestillinger og en hel masse andre funksjoner."
      },
      4: {
        header: "Integrasjoner",
        description: "Suppli elsker alle, så selvfølgelig har vi en åpen API. Vi har allerede integrasjoner med flere forskjellige systemer som nettbutikker og regnskapsprogramvare slik at du slipper å manuelt oppdatere lagerverdi, fakturagrunnlag, online lagerstatus og automatisk webordrehenting. "
      }
    }
  },
  pricingPage: {
    getStartedBlock: {
      title: {
        1: "Kom igang nå,",
        2: "Velg en plan"
      },
      description: "For å kunne bruke Suppli som en kunde trenger du en obligatorisk startpakke , en premium lisens, og en av brukerstøttepakkene."
    },
    pricingItems: {
      1: {
        title: "Startpakke",
        features: {
          1: "Suppli programvare",
          2: "3 timers nettbasert opplæring av ansatte i bruk av Suppli*",
          3: "Oppsett av Suppli-konto",
          4: "Importer produkter, kunder og leverandører",
          5: "Oppsett av integrasjoner"
        },
        price: "Kr 15 000, -",
        btn: "Kjøp nå",
        footnote: {
          1: "\n                        *Hvis du vil at vi skal komme og ha opplæring i \n                        bruken av Suppli, kontakt oss for priser.\n                        ",
          2: "\n                            ** Opptil tre importfiler. Filene må være i korrekt format. Vennligst se vår eksempelmal.\n                        ",
          3: "\n                            ***Opptil tre integrasjoner. Integrasjonen må være i vår portefølje.\n                    "
        }
      },
      2: {
        title: "Lisens",
        premium: {
          title: "Premium",
          features: {
            1: "Full tilgang til programmet"
          },
          price: "Kr 990",
          interval: "Måned pr bruker"
        },
        warehouse: {
          title: "Lager",
          features: {
            1: "\n                           Tilgang til levering, lagerflyt, forsendelse, varelager telling og \n                                produktskanning\n                        "
          },
          price: "Kr 490",
          interval: "Måned pr bruker"
        },
        accounting: {
          title: "Regnskap",
          features: {
            1: "\n                            Tilgang til lagerverdi, salgsstatistikk, og \n                                varetelling\n                        "
          },
          price: "Kr 290",
          interval: "Måned pr bruker"
        },
        businessP1: {
          title: "Bedriftspakke 1",
          features: {
            1: "5 premium lisenser, 5 lager lisenser, 1 regnskap"
          },
          price: "Kr 4990",
          interval: "Måned"
        },
        businessP2: {
          title: "Bedriftspakke 2",
          features: {
            1: "10 premium lisenser, 10 lager lisenser, 3 regnskap"
          },
          price: "Kr 9990",
          interval: "Måned"
        },
        btn: "Kjøp nå"
      },
      3: {
        title: "Support",
        gold: {
          title: "Gull (alt inkludert)",
          features: {
            1: "10 timers telefonstøtte månedlig.",
            2: "Hjelp med import av produkter, kunder og leverandører.",
            3: "Hjelp med prisjusteringer.",
            4: "Ekstra treningsøkter i bruk av Suppli.",
            5: "Gratis e-post og chat-støtte."
          },
          price: "Kr 2999",
          interval: "Måned"
        },
        silver: {
          title: "Sølv",
          features: {
            1: "3 timers telefonstøtte månedlig.",
            2: "Gratis e-post og chat-støtte"
          },
          price: "Kr 1499",
          interval: "Måned"
        },
        bronze: {
          title: "Bronse",
          features: {
            1: "1 time telefonstøtte månedlig.",
            2: "Gratis e-post og chat-støtte"
          },
          price: "Kr 999",
          interval: "Måned"
        },
        btn: "Kjøp nå",
        footnote: "\n                    *Importfiler må være i korrekt format. Se vår eksempel fil. Arbeidstimer knyttet til import av filer blir trukket fra de inkluderte supporttimene i pakken din.\n                "
      }
    },
    attendanceBlock: {
      preTitle: "Trenger du hjelp?",
      title: "Deltakelse",
      description: "Vi snakker gjerne med deg om hvilket som helst spørsmål eller saker for å kunne hjelpe deg med å jobbe raskere, og utvikle raskere.",
      card: {
        1: {
          title: "Kontakt oss",
          desc: "Eksisterende kunder kan ta kontakt med oss hvis de har behov for rådgivning med planlegging og tilpasning av lageret for deres bedrift."
        },
        2: {
          title: "Konsultasjonstimer",
          desc: "Vi er et selskap lokalisert i Larvik og vi vil fakturere reise kostnader som hotellovernatting, drivstoffutgifter, flybilletter og konsulenttimer. Merk at vi fakturerer halv pris for konsulenttimer for slike avtaler. Kontakt oss for priser"
        }
      }
    },
    equipmentBlock: {
      preTitle: "Hold deg oppdatert med innovasjon",
      title: "Utstyr",
      description: "Vi kan levere alt utstyret du trenger for lagerstyring som skannere, bærbare datamaskiner, mobile enheter, Ipads, skrivere, strekkodeskannere, RFID-skannere",
      items: [
        {
          header: "EA520",
          description: "Robust smarttelefon",
          longDesc: "Ved å introdusere EA520, leverer den banebrytende, robuste smarttelefonen på 5 tommer kraftig strekkodelesing, praktisk tilkobling, holdbar, men den lette designen som akkurat passer i håndflaten. Dette forbedrer servicenivået for ulike vertikale applikasjoner innen detaljhandel,servicenæringer og felttjenester.",
          features: [
            "5-tommers skjerm med 450 nits sollys lesbar",
            "Android 11 OS med GMS-sertifisering",
            "Støtter de fleste 1D / 2D-strekkoder på mobilskjermer, til og med DPM-strekkoder",
            "Lettvektsdesign som akkurat passer i håndflaten.",
            "Alt-i-ett-funksjonalitet: HF/NFC og 13 MP-kamera",
            "Robust: Corning® Gorilla® Glass 3 berøringsskjerm, IP67-klassifisert og 1,5 M fall (1,8 M med støvelveske)",
            "Langvarig avtakbart 4100mAh batteri",
            "Støtter Bluetooth® 5 / dual-band WLAN, rask roaming / 4G LTE",
            "Støtter MDM-programvareløsninger og verktøy som MoboLink.."
          ],
          price: "Kr 6990"
        },
        {
          header: "EA630",
          description: "Robust smarttelefon",
          longDesc: "Unitech EA630 er en 6-tommers robust mobil smarttelefon med 80 % skjerm-til-kroppsforhold, med allsidig funksjonalitet med kraftig datainnsamling. EA630 er spesialdesignet for bærbarhet og er kombinert med en kompakt og slitesterk design som gjør den til et ideelt verktøy for å øke effektiviteten for bruk innen detaljhandel, gjestfrihet og lette felttjenester.",
          features: [
            "6-tommers robust smarttelefon med et skjerm-til-kroppsforhold på over 80 %",
            "Android 10 OS med GMS- og AER-sertifisering",
            "Alt-i-ett-funksjonalitet: 2D-bildekamera, HF/NFC og 16 MP-kamera",
            "Robust: Corning® Gorilla® Glass 6 berøringsskjerm, IP65-klassifisert og 1,2M fall (1,5M med bagasjerom)",
            "Langtlevende avtakbart 4000mAh batteri (opptil 16 timers arbeidstid",
            "Støtter Bluetooth® 5 / dual-band WLAN, fast roaming / 4G LTE",
            "Støtter MDM-programvareløsninger og verktøy som AirWatch, SOTI, Ivanti Wavelink og MoboLink"
          ],
          price: "Kr 8990"
        },
        {
          header: "HT730",
          description: "4-tommers robust håndholdt terminal",
          longDesc: "Unitech HT730 er en ergonomisk enhåndsbetjening håndholdt terminal med tastatur og kraftige datainnsamlingsløsninger. Med Android 10 OS med GMS-sertifisering, er HT730 utstyrt med Qualcomm® Artificial Intelligence (AI) CPU for å gi brukere utmerket ytelse for smartere, mer intuitive interaksjoner som er egnet til å forbedre arbeidseffektiviteten din i en lang rekke applikasjoner innen lager, logistikk , og felttjeneste.",
          features: [
            "Android 10 OS med GMS-sertifisering",
            "Ergonomisk enhåndsbetjening",
            "Overlegen 2D-skanningsytelse: Støtt 30-graders skanning tilt ned",
            "Overlegen ytelse med skanningsområde opptil 20 meter unna",
            "Støtter IEEE 802.11a/b/g/n, 802.11ax-ready, 802.11ac Wave 2 med 2X2 MU-MIMO WLAN Standard",
            "6700mAh batteri for 20-26 timers drift",
            "Ekte Hot-swap batteridesign uten nedetid",
            "1,8M fallsikkert skall (2,4M med støtfanger)",
            "IP65/IP67 beskyttelse mot vann og støv",
            "Holdbart tastatur med bakgrunnsbelysning: 38/29 taster med 2,5 millioner levetidsklikk",
            "Støtter Bluetooth® 5.1",
            "Støtter MDM-programvare og verktøy som MoboLink, StageGo, Ivanti Wavelink og StayLinked"
          ],
          price: "Kr 17990"
        },
        {
          header: "TSP800II",
          description: "Multifunksjonell strekkode, etikett, kvittering og etikettskriver",
          longDesc: "TSP800II er en unik og allsidig termisk skriver som kan skrive ut på bredere enn gjennomsnittet media opptil 112 mm bred.  Kombinert med en unik A4-rasterdriver som er i stand til å skalere et A4-bilde til 112 mm bredt papir, kan TSP800II integreres som en kostnadseffektiv kvitterings-, billett- eller etikettskriver eller et brukervennlig og kompakt alternativ til standard A4-faktura- eller rapportskrivere i butikk- og gjestehusmiljøer med betydelige kostnadsbesparelser for papir og forbruksvarer . TSP800II har en svartmerkesensor og kan skrive ut på media opptil 150 g/m2, noe som gjør den til en ideell lavprisetikettskriver for hyllkantetiketter eller en pålitelig billettskriver av høy kvalitet for billetter i bredere format mark.",
          features: [],
          price: "Kr 7990"
        },
        {
          header: "MS340",
          description: "Håndholdt bildeskanner (1D)",
          longDesc: "MS340 er en langdistanseskanner, noe som betyr at du ikke trenger å ta kontakt med en strekkode for å lese den. Gi datainnsamlingsprosessen din større fleksibilitet og varig holdbarhet.",
          features: [
            "Langdistanseskanning: opptil 15 tommer",
            "Overlegen skanning: opptil 500 skanninger/sek",
            "Leser alle vanlige 1D-strekkoder inkludert GS1 DataBar og stablede koder",
            "Håndfri stativ tilgjengelig",
            "Tåler 5-fots fall til betong",
            "Grensesnittalternativer: USB, RS232, Keyboard Wedge",
            "Miljøtettet mot fukt og støv",
            "garanti: 5 år"
          ],
          price: "Kr 1290"
        },
        {
          header: "HT730UHF",
          description: "RFID robust håndholdt terminal",
          longDesc: "HT730 UHF er en rundstrålende RFID-terminal med 15M leseområde som leser 750 tagger+ per sekund for å gi kollegaer rask tilgang til data når de håndterer lager. Med den sofistikerte IMPINJ R2000 innebygde brikken er det aldri en plagsom oppgave å få klar synlighet av eiendeler og plassering. Det er ikke nødvendig å slå av enheten, så dine kollegaer kan fortsatt varmebytte 6700mAh batteri ved kontinuerlig arbeid. En ultra-kraftig RFID-leser med motstand mot støv og vann og som tåler 1,8 m fall passer best for lager, feltservice og transport og logistikk.",
          features: [
            "Bransjeledende 15M RFID leseområde",
            "Høy følsomhet og optimal brikke: IMPINJ R2000",
            "Smartbatteri som kan byttes med varig kapasitet på 6700mAh",
            "Utfør 750+ tag-lesninger per sekund",
            "Maksimal EIRP på 36 dBm",
            null,
            "Støtt Hot-Swap-funksjon, holder applikasjoner aktive i opptil 1 minutt",
            "Integrerte forskjellige WIFI-tilkoblinger: IEEE 802.11a/b/g/n, 802.11ax-ready, 802.11ac Wave 2 med 2X2 MU-MIMO WLAN Standard",
            "Koble trådløst med Bluetooth® 5.1",
            "Ultrasensitiv 4” skjerm berøringsskjerm",
            "Balansert, ergonomisk og robust pistolgrepsdesign",
            "Bedriftsbestandig beskyttelse med IP65-beskyttelse og 1,8 m fall til betong"
          ],
          price: "Kr 21990"
        }
      ]
    }
  },
  supportPage: {
    faqBlock: {
      preTitle: "Vanlige spørsmål",
      title: "Supportsenter",
      desc: "\n                Vi skal tilby god support til alle, for å sikre at du kan bruke Suppli så effektivt som mulig til å til enhver tid å ha kontroll på ditt lager og vareflyt.\n            ",
      article1: {
        boldTitle: "Hvordan få hjelp",
        desc1: "\n                    Suppli gir personlig hjelp som du trenger for å få konkurransefortrinn i din bransje. Uansett hva dine mål, problemer eller behov er, er vi alltid tilgjengelige for en grundig konsultasjon slik at du kan få mest mulig ut av investeringen din.  \n                ",
        desc2: "\n                    Du er også velkommen til å bruke de gratisressursene på denne siden for å få svar på spørsmålene dine så raskt som mulig. Hvis du ikke finner svaret du trenger eller ønsker å få en mer detaljert forklaring, ta gjerne kontakt på telefon nummer +47 33200955 eller supportmail post@suppli.no. Hvis du allerede er kunde av Suppli, kan du alltids bruke support chatten med en gang du er logget inn. Hos Suppli, har kundens suksess alltid topp prioritet!\n                ",
        desc3: "\n        Hvis du allerede er kunde hos Suppli, kan du alltid bruke supportchatten når du er logget inn. Hos Suppli er kundenes suksess topp prioritet!\n        "
      }
    },
    subscribeText: "Abonner på vårt nyhetsbrev og gå aldri glipp av de nyeste oppdateringene fra Suppli",
    contactBlock: {
      title: "Kontakt oss",
      subTitle: "Send oss en melding eller ring oss i vår åpningstid +47 332 00 955"
    },
    questionsBlock: {
      1: {
        q: "\n                    Hve er Suppli WMS (Lagerstyringssystem)? \n                ",
        a: "\n                    Suppli er et skybasert lagerstyringssystem som gir deg full kontroll over dine varer, kjøp, salgsordrer, leveranser, lagerbevegelser og lagertellinger. Med Suppli blir lagerstyringen din enklere, rimeligere og mer effektivt.\n                "
      },
      2: {
        q: "\n                Hvordan vet jeg at jeg trenger et WMS?\n                ",
        a: "\n                Hvis du vil ha full kontroll over virksomheten og inventaret og eliminere kostbare lagerfeil,\n\t\t\t\ttrenger du et WMS. Å ha et robust WMS vil hjelpe deg med å optimere lagerplass og automatisere operasjoner,\n\t\t\t\tfå bedre synlighet av inventaret ditt, administrere arbeidskraft mer effektivt, gi bedre kundeservice og skalere raskere.\n                "
      },
      3: {
        q: "\n                Hvorfor velge Suppli?\n                ",
        a: "\n                Suppli tilbyr en innovativ og brukervennlig løsning drevet av den beste teknologiske utviklingen. Dette vil gi deg en sjanse til å overvåke, spore og optimalisere driften din med full kontroll og letthet. Tilgjengelig og lett tilgjengelig på alle enheter, når som helst og hvor som helst.\n                "
      },
      4: {
        q: "\n                Hvilke typer selskaper er egnet for Suppli WMS?\n                ",
        a: "\n                Alle typer selskaper, fra små startups til store selskaper, vil dra nytte av funksjonene til Suppli WMS. Når det gjelder bransjer, fokuserer Suppli på å betjene følgende: detaljhandel, produksjon, engros, elektronikk, farmasøytisk, transport, tredjepartslogistikk (3PL), landbruk, mat og drikke, helse og skjønnhet og mange flere. \n                "
      },
      5: {
        q: "\n                Hvilke funksjoner tilbyr Suppli WMS?\n                ",
        a: "\n                Målet med Suppli er å sikre at du enkelt kan organisere og holde styr på varelageret ditt, det være seg innkjøp, salgsordrer eller lagerflyt. Du vil få full oversikt over avgjørende faktorer som lager, leveringsplaner og ordrestørrelser, samt få rapporter og advarsler angående varelageret. Suppli WMS integreres også enkelt med ERP, nettbutikk, økonomi, fraktsystemer m.m.\n                "
      },
      6: {
        q: "\n                Hvordan og i hvilke språk kan jeg få support?\n                ",
        a: "\n                Vi er her for deg 24/7 på telefon, e-post og chat. Primære telefonspråk er engelsk og norsk, men vi kan også tilby støtte på følgende språk: tysk, russisk, litauisk og svensk.\n                "
      },
      7: {
        q: "\n                Kan jeg få en demo for å teste Suppli WMS?\n                ",
        a: "\n                Absolutt! Vi lar deg mer enn gjerne teste ut maskinvaren og se løsningene våre live. For å lære mer om demoen, kontakt oss på telefon, e-post eller chat, eller treff oss personlig i Nansetgata 25 i Larvik.  \n                "
      }
    },
    subscribeBlock: {
      preTitle: "Abonnere",
      title: "Bli med 2000+ abonnenter",
      subscribeTextLeft: "Hold deg oppdatert med alt du trenger å vite.",
      subscribeTextRight1: "Vi bryr oss om dataene dine i vår",
      subscribeTextRight2: "personvernerklæring",
      subscribeBtn: "Abonnere",
      notifyBtn: "Gi meg beskjed",
      sendMessage: "Send Melding"
    }
  },
  loginPage: {
    loginMain: "Velkommen tilbake",
    googleBtn: "Fortsett med Google",
    orLabel: "ELLER",
    emailLabel: "E-post",
    passwordLabel: "Passord",
    rememberLabel: "Husk i 30 dager",
    forgotPasswordLabel: "Glemt passord?",
    logInBtn: "Logg inn",
    noAccountLabel: "Har ikke konto?",
    registerBtn: "Registrer deg",
    whatNewLabel: "Hva er nytt",
    // [+] Changed
    verification_status: {
      success: "Din epost har blitt bekreftet!",
      already_verified: "Din epost er allerede bekreftet!",
      not_found: "Verifiseringslinken er ugyldig!"
    }
  },
  verifyEmailPage: {
    heading: "Sjekk epost for å fullføre registreringen",
    resend: "Send epost på nytt",
    responses: {
      success: "Epost ble sendt",
      error: "En feil har oppstått. Vennligst prøv igjen senere."
    },
    timer: {
      wait: "Vennligst vent",
      beforeResend: "noen minutter før du sender på nytt"
    }
  },
  signupPage: {
    // [+] Changed
    responses: {
      error: "En feil har oppstått. Vennligst prøv igjen senere."
    },
    yourProfile: {
      heading: "1. Din profil",
      subheading: "Skriv brukernavn og passord til din konto",
      fields: {
        firstName: "Fornavn",
        lastName: "Etternavn",
        email: "Epost",
        phone: "Telefon",
        password: "Passord",
        confirmPassword: "Gjenta passord"
      },
      errors: {
        passwordLength: "Passordet må være minst 8 tegn",
        passwordMismatch: "Passordet må være korrekt gjentatt"
      },
      passwordRules: [
        "Passordet må være minst 8 tegns",
        "Passordet må inneholde minst en bokstav",
        "Passordet må inneholde minst et tall"
      ],
      button: "Neste"
    },
    companyInformation: {
      heading: "2. Firmainformasjon",
      subheading: "Skriv inn opplysninger om firma",
      fields: {
        companyName: "Firmanavn",
        registrationNumber: {
          label: "Organisasjonsnummer",
          validationRule: "Pegg til landkode før organisasjonsnummer (e.g. <b>NO</b>12345678)"
        },
        currency: "Valuta",
        country: "Land",
        street: "Gateadresse 1",
        street2: "Gateadresse 2",
        city: "Poststed",
        zipcode: "Postnummer"
      },
      checkboxes: {
        terms: "Jeg godkjennter <termsLink> salgsbetingelser </termsLink> og <policyLink> vår personvernerklæring</policyLink>",
        marketingInfo: "Jeg vil gjerne motta markedføring og nyheter fra Suppli"
      },
      errors: {
        termsAndConditions: "Du må akseptere våre salgsbetingelser og vår personvernerklæring"
      },
      buttons: {
        previous: "Tilbake til steg 1",
        createAccount: "Opprett konto"
      }
    },
    termsAndConditionsModal: {
      heading: "Salgsbetingelser",
      buttons: {
        decline: "Avslå",
        accept: "Aksepter"
      }
    },
    signupMain: "Kom igang",
    googleBtn: "Fortsett with Google",
    orLabel: "ELLER",
    emailLabel: "Epost",
    passwordLabel: "Passord",
    showPasswordLabel: "Vis passord",
    signupBtn: "Registrer deg",
    alreadyHaveLabel: "Har allerede konto?",
    loginLabel: "Logg inn",
    registerTestemonial: "“Å bytte til Suppli har forbedret lagerdriften vår enormt. Det er den mest brukervennlige og intuitive løsningen jeg noen gang har brukt, og overgår langt alle andre WMS når det gjelder funksjonalitet”",
    clickHereToLogIn: "Klikk her for å logge inn",
    p1: "Administrer lageret",
    p2: "ditt enkelt og nøyaktig.",
    step: "Steg",
    receivePromotions: "Jeg vil gjerne motta markedsføringsinformasjon og nyheter om Suppli.",
    first_name: "Fornavn *",
    last_name: "Etternavn *",
    registration_number: "Registration number *",
    company_name: "Firmanavn *",
    country: "Land *",
    street: "Gate",
    street2: "Gate 2",
    city: "Poststed",
    zipcode: "Postnummer",
    phone_number: "Telefon",
    website: "Website *",
    email: "E-postadresse *",
    job_role: "Stilling",
    base_currency: "Grunnvaluta",
    BusinessOwner: "Bedriftseier",
    InventoryOperations: "Lagerhåndtering",
    ProductionAndManufacturing: "Produksjon og bearbeiding",
    PurchasingOrProcurement: "Innkjøp eller anskaffelse",
    FinanceOrOfficeAdministration: "Økonomi eller kontoradministrasjon",
    SalesMarketing: "Salg og markedsføring",
    Consultant: "Konsulent",
    WholesaleOrDistribution: "Engros eller distribusjon",
    Ecommerce: "Netthandel",
    ManufacturingOrAssembly: "Produksjon eller montering",
    ConstructionOrJobsites: "Bygg eller arbeidsplasser",
    Retail: "Detaljhandel",
    OfficeSuppliesOrInternalInventory: "Kontorrekvisita eller intern lagerbeholdning",
    Other: "Annet",
    CreateNewCompany: "Opprett nytt selskap",
    LetsGetToKnowYou: "La oss bli kjent med deg",
    WhatBestFitsYourBusiness: "Hva passer best for din bedrift?",
    AlmostReady: "Nesten klar!",
    Continue: "Fortsett",
    CreateCompany: "Opprett selskap",
    ActivateAccount: "Aktiver konto",
    letsPassword: "La oss opprette passordet ditt",
    termsAgree: "Jeg godtar vilkårene og betingelsene",
    password: "Passord",
    confirmPassword: "Bekreft passord"
  },
  invitationPage: {
    heading: "Velkommen til Suppli",
    subheading: {
      default: "Du har blitt invitert til å bli en del av <bold>{{company}}</bold> teamet hos Suppli. Kontoen din er nesten klar. ",
      nonExistingUser: "Vennligst fyll ut følgende felt og bruk e-post <bold>{{email}}</bold> for å begynne å bruke systemet.",
      existingUser: "Godta invitasjonen og bruk e-post."
    },
    fields: {
      firstName: "Fornavn",
      lastName: "Etternavn",
      password: "Passord",
      confirmPassword: "Bekreft passord",
    },
    checkboxes: {
      terms: "Jeg godtar <termsLink>Vilkår og betingelser</termsLink> og <policyLink>Privatlivspolitikk</policyLink>",
      marketingInfo: "Jeg vil gjerne motta markedsføringsinformasjon og nyheter om Suppli"
    },
    buttons: {
      accept: "Godta invitasjon",
      createAccount: "Opprett konto",
    },
    invalidInvitation: {
      1: "Invitasjonslenken du har brukt, er ikke lenger gyldig eller har utløpt.",
      2: "For å fortsette, vennligst kontakt din Suppli-representant for å be om en ny lenke."
    }
  },
  forgotPassword: {
    emailInputPage: {
      stage1: {
        heading: "Glemt passord?",
        subheading: "Vi sender deg instruksjoner for tilbakbestilling av passord",
        button: "Tilbakestill passord",
        return: "Tilbake til innlogging"
      },
      stage2: {
        heading: "Sjekk eposten din",
        subheading: "Vi sendte en lenke til tilbakestilling av passord til",
        didntReceive: "Har du ikke mottatt eposten? Klikk for å sende på nytt",
        button: "Send e-post igjen",
        return: "Tilbake til innlogging"
      }
    },
    resetPage: {
      stage1: {
        heading: "Sett nytt passord",
        subheading: "Ditt nye passord må være forskjellig fra tidligere brukte passord",
        inputs: {
          original: {
            title: "Passord",
            restriction: "Må være på minst 8 tegn"
          },
          confirmation: {
            title: "Bekreft passord"
          }
        },
        action: "Tilbakestille passord"
      },
      stage2: {
        heading: "Nytt passord er lagret",
        subheading: [
          "Passordet ditt har blitt tilbakestilt.",
          "Klikk nedenfor for å logge på."
        ],
        action: "Logg inn"
      }
    }
  },
  partnersPage: {
    welcomeBlock: {
      heading: "Vi skaper endringer sammen",
      subheading: "Løsninger som utgjør en forskjell krever de beste hodene. Det er derfor vi samarbeider med ledende selskaper i ulike bransjer for å dele vår ekspertise, lære av hverandre, og skape innovative produkter som hjelper deg som våre kunder å lykkes.",
      cta_1: "Bli partner",
      cta_2: "Se partnere"
    },
    partnersPopup: {
      lets: "La oss samarbeide",
      companyName: "Firmanavn",
      email: "Epost",
      phone: "Telefon",
      contactPerson: "Kontaktperson",
      getStarted: "Kom i gang"
    },
    whyPartners: {
      heading: "Nøkkelen til å gjøre en forskjell",
      subheading: "Hos Suppli vet vi at vår suksess kun er mulig gjennom de sterke relasjonene vi har med våre partnere. Med det erfarne og kunnskapsrike fellesskapet av eksperter vi har, kan du være trygg på at alle områder av virksomheten din vil se en forbedring."
    },
    advantages: {
      first: {
        heading: "Strategisk partnerskap",
        subheading: "Våre partnerskap er opprettet med ett mål i tankene: å komme våre kunder til gode. Vi ønsker å hjelpe deg med å nå dine mål, og vi er her for å hjelpe deg hvert steg på veien."
      },
      second: {
        heading: "Omfattende løsninger",
        subheading: "Forhold til internasjonale selskaper gjør at vi kan tilby våre kunder et enda bredere spekter av løsninger med mer funksjonalitet."
      },
      third: {
        heading: "Inngående kunnskap",
        subheading: "Med våre partnere får vi tilgang til et bredere spekter av ekspertise, ideer og nye perspektiver på gamle problemer.."
      },
      fourth: {
        heading: "Eksklusive fordeler og merverdi",
        subheading: "Våre partnerskap hjelper deg med å spare penger og reinvestere tilbake i virksomheten din samtidig som du tjener mer."
      }
    },
    companies: {
      heading_1: "Partnere",
      heading_2: "Regnskapssførere",
      dropdown: {
        heading: "Partnere etter land",
        option_all: "Alle"
      },
      list: {
        woocommerce: {
          heading: "WooCommerce",
          subheadings: [
            "WooCommerce er en flott e-handelsplattform som lar deg raskt sette opp en nettbutikk og kan tilpasses for å passe de spesifikke behovene til enhver bedrift.",
            "Å integrere WooCommerce-butikken din med Suppli WMS vil bidra til å ta gjettingen ut av lagerkontroll og ordreoppfyllelse ved å automatisk synkronisere produkter i sanntid",
            "Når en kunde legger inn en bestilling, sendes den umiddelbart til lageret hvor den klargjøres og sendes så snart som mulig. Hvis en vare er utsolgt i WMS, vil den vises som ikke på lager på hjemmesiden din - Det betyr ikke flere overraskelser for kundene (eller deg selv!)."
          ]
        },
        hubspot: {
          heading: "Hubspot",
          subheadings: [
            "Hubspot gir en utmerket CRM-plattform for salgsteam, med automatisering, rapportering og salgsforløpsdministrasjonsverktøy.",
            "Å integrere Suppli WMS med Hubspot CRM vil holde bedriften et skritt foran ved å automatisere repeterende manuelle prosesser, forbedre responstidene og gjøre teamet ditt mer effektivt. Dessuten vil du kunne holde styr på hver kundeinteraksjon og bruke disse dataene til å forbedre forretningsprosessene dine. ",
            "De to systemene som samarbeider vil tillate deg å tilby et høyere servicenivå og ta mer informerte beslutninger om virksomheten din."
          ]
        },
        poweroffice_go: {
          heading: "PowerOffice GO",
          subheadings: [
            "PowerOffice Go er et komplett regnskapssystem som tilbyr alle funksjonene og funksjonaliteten du trenger for å administrere virksomhetens økonomi (salg og utgifter, fakturaer og estimater, rapporter og mer).",
            "Å ha Suppli WMS integrert med PowerOffice GO regnskapsprogramvare er en fin måte å strømlinjeforme driften og unngå menneskelige feil. ",
            "Vi mener at du som kunde ikke trenger å kaste bort tid på å manuelt legge inn informasjon som kunder, produkter, beløp og priser - som alle finnes i WMS. Når du trykker \"complete\""
          ]
        },
        rivals: {
          heading: "Rivals Software",
          subheadings: [
            "Rivals Software is an innovative software development company that specializes in developing ready-to-deploy and customized software solutions, as well as state-of-the-art websites. The company serves a wide range of industries, including healthcare, finance, education, and retail, among others.",
            "Rivals Software's mission is to help businesses improve their operations and increase their productivity through the use of cutting-edge software technologies. The company has a team of highly skilled software developers and engineers dedicated to providing effective solutions to businesses of all sizes.",
            ""
          ]
        }
      }
    },
    footerCTA: {
      heading: "Klar til å koble til?",
      subheading: "Vi er spente på å se hvordan vi kan hjelpe deg med å lykkes",
      cta: "Koble til teamet vårt"
    }
  },
  dashboard: {
    sidebar: {
      dashboard: "Kontrollpanel",
      calendar: "Kalender",
      products: "Produkter",
      allProducts: "Alle produkter",
      productionOrder: "Stykklister",
      purchasing: "Innkjøp",
      purchases: "Innkjøpsordre",
      receive: "Motta",
      picking: "Plukking",
      inventory: "Inventar",
      quickPurchaseOrder: "Rask kjøpsordre",
      stock: "Lageroversikt",
      adjustments: "Lagerendringer",
      collections: "Samlinger",
      transfers: "Lageroverføring",
      sales: "Salg",
      orders: "Ordre",
      placeInOrder: "Plasser i rekkefølge",
      customers: "Kunder",
      newCustomer: "Ny kunde",
      customerList: "Kundeliste",
      customerGroup: "Kundegruppe",
      suppliers: "Leverandører",
      userLogs: "Brukerlogger",
      settings: "Innstillinger"
    },
    navbar: {
      languages: {
        english: "Engelsk",
        norwegian: "Norsk"
      },
      // [+] Changed
      totalStat: {
        totalRevenue: "Brutto inntekt",
        totalInStock: "Antall på lager",
        thisMonth: "Denne måneden"
      },
      notifications: {
        yourNotifications: "Dine varsler"
      },
      userMenu: {
        myAccount: "Min konto",
        companyInfo: "Firmainformasjon",
        subscription: "Abonnement",
        action: "Logg ut"
      }
    },
    dashboard: {
      stats: {
        revenue: {
          heading: "Inntekter",
          chart: {
            expenses: "Utgifter",
            income: "Inntekt"
          },
          tabs: ["Månedlig", "Ukentlig", "Idag"],
        },
        bestSellingProducts: {
          heading: "Bestselgende produkter",
          chip: "denne måned",
          // [+] Changed
          notFound: "Ingen data funnet"
        },
        feed: {
          heading: "Oppdateringsflyt",
          // [+] Changed
          actionConnector: "har blitt",
          actions: {
            view: "endret",
            edit: "redigert",
            price: "oppdatert pris",
            create: "opprettet",
            delete: "slettet",
            receive: "mottatt",
            adjustment: "justert",
            transfer: "overført",
            update_selling_price: "oppdatert (salgspris)"
          }
        },
        restocking: {
          heading: "Lagerpåfylling",
          columns: [
            "Produkt",
            "Stk."
          ],
          orderButton: "Bestill nå",
          // [+] Changed
          notFound: "Ingenting å fylle på lager"
        }
      },
      upcomingShipments: {
        heading: "Kommende forsendelser",
        orderNaming: "Ordre",
        orderDatePrefix: "I dag",
        orderTimePrefix: "ved",
        dropdownNaming: "Alle lokasjoner",
        // [+] Changed
        tooltip: "Begynn å motta",
        noUpcomingShipmentsFound: "Du har ingen kommende forsendelser"
      }
    }
  },
  bom: {
    produceModal: {
      heading: "Produsér",
      quantityCanProduced: "Antall som kan produseres",
      of: "av",
      table: {
        components: "Komponenter",
        columns: [
          "ID",
          "Navn",
          "Antall",
          "Utgående lokasjon",
          "Brukt mengde",
          "Handling"
        ],
        noComponents: "Ingen komponenter"
      },
      shortcuts: {
        heading: "Snarveier",
        buttons: {
          setQuantity: {
            value: "Fyll ut antall automatisk",
            disabledTooltip: "Antallet må være større enn 0"
          },
          setLocations: {
            value: "Fyll ut lokasjoner automatisk",
            modal: {
              heading: "Velg lokasjon",
              subheading: "Angitt lokasjon vil automatisk settes for alle komponenter som er tilgjengelige på denne lokasjonen. Antallsverdi vil være tom.",
              location: {
                label: "Lokasjon",
                placeholder: "Velg lokasjon"
              },
              buttons: {
                cancel: "Avbryt",
                confirm: "Bekreft"
              }
            }
          }
        }
      },
      actions: {
        addLocation: "Legg til lokasjon"
      },
      fields: {
        quantity: "Antall"
      },
      dropdowns: {
        location: {
          label: "Legg produsert til",
          placeholder: "Velg lokasjon"
        }
      },
      responses: {
        error: "En feil oppstod under produksjon av produkt."
      },
      buttons: {
        continue: "Produser",
        cancel: "Avbryt",
        addSerialNumbers: "Legg til serienumre",
        addBatchNumbers: "Legg til batchnumre"
      },
      validationErrors: {
        maxAvailableInStock: "Den angitte mengden overstiger maksimalt antall enheter på lager. Maksimalt er",
        maxProducible: "Den angitte mengden overstiger det maksimale antallet som kan produseres basert på komponentlageret. Maksimalt er",
        serialNumbersRequired: "Serienumre er påkrevd",
        serialNumbersMatchQuantity: "Antall serienumre må samsvare med produsert antall",
        serialNumbersCount: "Antall serienumre kan ikke overstige produsert antall",
        batchNumbersRequired: "Batchnumre er påkrevd",
        batchNumbersCount: "Antall batchnumre kan ikke overstige produsert antall"
      },
      modals: {
        serialNumbersModal: {
          heading: "Serienumre",
          buttons: {
            addSerialNumber: "Legg til serienummer",
            cancel: "Avbryt",
            attach: "Legg ved"
          },
          fields: {
            serialNumber: {
              placeholder: "Serienummer"
            }
          }
        },
        batchNumbersModal: {
          heading: "Batchnumre",
          buttons: {
            addBatchNumber: "Legg til batchnummer",
            cancel: "Avbryt",
            attach: "Legg ved"
          },
          fields: {
            batchNumber: {
              placeholder: "Batchnummer"
            },
            expirationDate: {
              placeholder: "Utløpsdato"
            }
          }
        }
      }
    },
    produceModalSuccess: {
      heading: "Vellykket",
      subheading: "Produktene dine er ferdig produsert.",
      button: "Fortsett"
    },
    createPOModal: {
      title: "Rask bestillingsordre",
      components: "Komponenter",
      fields: {
        bomName: "BOM Name",
        quantity: "Antall"
      },
      buttons: {
        continue: "Fortsett"
      }
    },
    mutation: {
      modals: {
        selectComponent: "Velg komponent",
        editComponent: "Rediger komponent",
        addNewComponent: "Legg til ny komponent",
        component: {
          label: "Komponent",
          placeholder: "Velg komponent"
        },
        quantity: "Antall",
        buttons: {
          save: "Lagre",
          cancel: "Avbryt"
        },
        errors: {
          duplicateComponents: "Duplikate komponenter er ikke tillatt"
        }
      },
      addComponents: "Legg til komponenter",
      componentName: "Komponent navn",
      purchasePrice: "Anskaffelsespris",
      totalPrice: "Totalpris",
      quantityCanProduced: "Antall som kan produseres",
      inStock: "På lager",
      action: "Handling",
      selectProduct: "Velg produkt",
      fields: {
        bomName: "BOM-navn"
      },
      dropdowns: {
        productName: {
          label: "Produktnavn",
          placeholder: "Velg produkt"
        }
      },
      table: {
        components: "Komponenter",
        addNewComponent: "Legg til ny komponent",
        columns: {
          name: "Navn",
          quantity: "Antall",
          purchasePrice: "Anskaffelsespris",
          totalPrice: "Totalpris",
          inStock: "På lager",
          action: "Handling"
        },
        noComponents: "Ingen komponenter",
        notAComponent: "Ikke en komponent"
      },
      validationErrors: {
        zeroComponents: "Du må legge til minst én komponent"
      },
      buttons: {
        create: "Opprett BOM",
        save: "Lagre"
      }
    },
    creation: {
      heading: "Opprett ny BOM",
      copySuffix: "kopier",
      responses: {
        success: "Stykkliste er opprettet.",
        error: "Det oppstod en feil under opprettelsen av stykkliste."
      },
      buttons: {
        create: "Opprett BOM"
      }
    },
    editing: {
      heading: "Rediger",
      responses: {
        success: "Stykkliste er oppdatert.",
        error: "En feil oppstod ved oppdatering av stykkliste."
      },
      buttons: {
        save: "Lagre"
      }
    },
    details: {
      actions: {
        produce: "Produser",
        edit: "Rediger",
        delete: "Slett",
        copy: "Kopier"
      },
      producingHistory: {
        heading: "Produksjonshistorikk",
        table: {
          columns: [
            "Lokasjon",
            "Antall produsert",
            "Dato",
            "Serial/Batchnumre"
          ],
          subtable: {
            columns: [
              "Komponent",
              "Brukt mengde",
              "Utsendelseslokasjon"
            ]
          },
          buttons: {
            sn: "SN",
            bn: "BN"
          }
        },
        tip: {
          noHistoryFound: "Ingen produksjonshistorikk funnet"
        }
      }
    },
    main: {
      All: "Alle",
      // [+] Changed
      ComponentName: "Component Name / ID",
      producingHistory: "Produksjonshistorikk",
      table: {
        columns: [
          "BOM navn",
          "Produktnavn",
          "Kategori",
          "Komponenter",
          "På lager",
          "Produsert",
          "Handlinger"
        ],
        subtable: {
          columns: [
            "Komponent navn",
            "Antall",
            "Innkjøpspris",
            "Totalpris",
            "På lager"
          ]
        },
        titleDeclinations: [
          "vare",
          "varer",
          "varer"
        ],
        actions: {
          produce: "Produser",
          quickPurchase: "Hurtig innkjøpsordre",
          edit: "Rediger",
          delete: "Slett",
          copy: "Kopier"
        }
      },
      ImportSuccess: "Produktimport er fullført",
      ImportFailed: "Kunne ikke importere produkt:",
      ExportFailed: "Kunne ikke eksportere produkt:",
      ExportSuccess: "Produkteksport var vellykket",
      ConfirmDeletion: "Bekreft sletting",
      YouCannotChange: "Du kan ikke angre etter at slettingen er fullført.",
      Cancel: "Avbryt",
      Delete: "Slett",
      BOMS: "BOMs:",
      ExportComponents: "Eksporter komponenter",
      Export: "Eksport",
      Heading: "Tittel"
    },
    deletionModal: {
      heading: "Bekreft sletting",
      subheading: "Er du sikker på at du vil slette denne stykklisten?:",
      buttons: {
        cancel: "Avbryt",
        delete: "Slett"
      },
      responses: {
        success: "Stykkliste ble slettet.",
        error: "Det oppstod en feil under sletting av stykkliste."
      }
    },
    producingHistory: {
      heading: "Produksjonshistorikk",
      links: {
        bomList: "Liste over produkter i stykkliste"
      },
      table: {
        columns: [
          "BOM navn",
          "Produktnavn",
          "Antall produsert",
          "Lokasjon",
          "Dato",
          "Serial/Batchnumre"
        ],
        subtable: {
          columns: [
            "Komponent",
            "Antall brukt",
            "Utsendelseslokasjon "
          ]
        },
        buttons: {
          sn: "SN",
          bn: "BN"
        }
      }
    }
  },
  products: {
    allProducts: {
      table: {
        titleDeclinations: [
          "gjenstand",
          "gjenstander",
          "gjenstander"
        ],
        columns: [
          "Produktnavn",
          "Type",
          "Kategori",
          "Salgspris",
          "På lager",
          "Komponenter",
          "Handling"
        ],
        // [+] Changed
        isService: "Tjeneste",
        isProduct: "Produkter",
        isWeb: "Nettbutikk",
        copyProduct: "Lag kopi av produkt",
        isDeletable: "Produktet kan ikke slettes fordi det for øyeblikket er på lager",
        reservedTooltip: "Reservert: {{count}}"
      },
      subtable: {
        columns: [
          "Variant ID",
          "Variant navn",
          "Salgspris",
          "På lager"
        ]
      },
      modals: {
        deletion: {
          heading: "Bekreft sletting",
          subheading: "Du kan ikke andre når slettingen er fullført.",
          buttons: {
            cancel: "Avbryt",
            delete: "Slett"
          },
          responses: {
            success: "Produktet ble slettet..",
            error: "En feil oppstod ved sletting av produkt."
          }
        },
        exporting: {
          title: "Eksporter produkter",
          dropdown: {
            label: "Overskrift",
            options: {
              productName: "Produktnavn",
              productCode: "Varenummer",
              barcode: "Strekkode",
              unit: "Enhet",
              group: "Varegruppe",
              defaultLocation: "Standard lokasjon",
              primarySupplier: "Standard leverandør",
              defaultTax: "Standard MVA",
              purchasePrice: "Innkjøpspris",
              sellingPrice: "Salgspris",
              // [+] Changed
              extraCost: "Ekstra kost"
            }
          },
          okText: "Eksporter"
        },
        barcodeLabel: {
          heading: "Strekkode etikett",
          fields: {
            barcode: {
              label: "Strekkode",
              placeholder: "Skriv inn strekkode som skal brukes"
            },
            standard: {
              label: "Standard"
            },
            labelSize: {
              label: "Etikettstørrelse",
              options: {
                standard: "Standard (78×28mm)",
                mini: "Mini (50×15mm)"
              }
            }
          },
          // [+] Changed
          errors: {
            invalidStandard: "Kan ikke generere strekkode i den valgte standarden"
          },
          buttons: {
            cancel: "Avbryt",
            print: "Skriv ut"
          }
        }
      },
      filters: {
        import: {
          title: "Importer produkter"
        },
        dropdowns: {
          category: {
            label: "Kategori"
          },
          components: {
            label: "Komponenter",
            options: [
              "Nei",
              "Ja"
            ]
          },
          // [+] Changed
          types: {
            label: "Type",
            options: [
              "Produkter",
              "Tjeneste"
            ]
          }
        },
        ranges: {
          sellingPrice: "Salgspris",
          quantityInStock: "Antall på lager"
        }
      },
      toasts: {
        deletion: {
          success: "Slett produktet vellykket",
          error: "Kunne ikke slette produktet"
        },
        exporting: {
          success: "Eksporter produktet vellykket",
          error: "Kunne ikke eksportere produktet"
        }
      },
      // [+] Changed
      reconversion: {
        tooltip: "Omberedning",
        reconversionModal: {
          heading: "Rekalkulering av produkters pris",
          alerts: {
            reconversionInProgress: "Prisomregningen pågår. Du kan starte en ny rekalkulering etter at den nåværende er fullført."
          },
          productsAvailable: "Det er {{count}} produktpriser som kan omberegnes",
          noProductsAvailable: "Det er ingen produktpris som kan rekalkuleres",
          fields: {
            reportEmail: {
              label: "Rapport på epost",
              placeholder: "Skriv inn epost rapport skal sendes til"
            },
            excludeImported: {
              label: "Ekskluder importerte produkter",
              tooltip: "Ekskluder produkter som er importert fra fil"
            }
          },
          buttons: {
            startReconversion: "Start rekalkulering",
            cancel: "Avbryt"
          },
          responses: {
            success: "Rekalkulering av produktpriser har startet"
          }
        },
        reconversionIndicator: {
          states: {
            finishedSuccessfully: "Rekalkulering av produktpriser er fullført",
            finishedWithErrors: "Rekalkulering av produktpriser er fullført, men med feil",
            inProgress: "Rekalkulering av produktpriser behandles",
            reconverted: "Rekalkulering av produktpriser er fullført",
            error: {
              title: "Det oppsto en feil under rekalkulering av produktpris",
              message: "Rapporten har blitt sendt til din epost"
            }
          }
        }
      }
    },
    newProduct: {
      heading: "Lag nye produkter",
      templates: {
        dropdown: {
          default: "Maler",
          nothingFound: "Ingen maler"
        }
      },
      modals: {
        saveTemplate: {
          heading: "Lagre mal",
          fields: {
            name: "Navn på mal"
          },
          buttons: {
            save: "Lagre"
          }
        },
        // [+] Changed
        batchNumbers: {
          heading: "Legg inn batchnummer",
          fields: {
            batchNumber: {
              placeholder: "Batchnummer"
            },
            expirationDate: {
              placeholder: "Holdbar til"
            }
          },
          alerts: {
            overflowBatchNumbers: "Antall batchnumre kan ikke være større enn plukket antall"
          },
          buttons: {
            save: "Lagre",
            addBatchNumber: "Legg til batchnummer"
          }
        },
        serialNumbers: {
          heading: "Legg til serienummre",
          fields: {
            serialNumber: {
              placeholder: "Serienummer"
            }
          },
          alerts: {
            overflowSerialNumbers: "Antall batchnumre kan ikke være større enn plukket antall"
          },
          buttons: {
            save: "Lagre",
            addSerialNumber: "Legg til serienummer"
          }
        }
      }
    },
    // [+] Changed
    viewEditProduct: {
      heading: "Produktdetaljer",
      isService: "Tjeneste",
      isVariant: "Variant",
      copyProduct: "Lag kopi av produkt",
      isDeletable: "Produktet kan ikke slettes fordi det for øyeblikket er på lager",
      modals: {
        deletion: {
          heading: "Bekreft sletting",
          subheading: "Du kan ikke anre når slettingen er fullført.",
          buttons: {
            cancel: "Avbryt",
            delete: "Slett"
          },
          responses: {
            success: "Produktet ble slettet",
            error: "Det oppstod en feil ved sletting av produkt"
          }
        },
        webProduct: {
          heading: "Bekreft endring av nettbutikk",
          enableSubheading: "Vil du aktivere nettbutikksynkronisering for",
          disableSubheading: "Vil du deaktivere nettbutikksynkronisering for",
          buttons: {
            cancel: "Avbryt",
            enable: "Aktiver",
            disable: "Deaktiver"
          },
          responses: {
            success: "Nettbutikkstatus oppdatert",
            error: "Kunne ikke oppdatere nettbutikkstatus"
          }
        }
      },
      tabs: {
        information: {
          heading: "Informasjon"
        },
        translations: {
          heading: "Oversettelser",
          // [+] Changed
          table: {
            columns: [
              "Språk",
              "Oversatt navn",
              "Oversatt beskrivelse",
              "Handlinger"
            ],
            buttons: {
              addLanguage: "Lagg til språk"
            }
          },
          modals: {
            mutation: {
              editing: {
                heading: "Rediger oversettelse",
                responses: {
                  success: "Oversettelsen er redigert",
                  error: "Det oppsto en feil ved redigering av oversettelsen"
                }
              },
              addition: {
                heading: "Legg til oversettelse",
                responses: {
                  success: "Oversettelsen ble lagt til",
                  error: "Feil ved ny oversettelse"
                }
              },
              fields: {
                language: {
                  label: "Språk",
                  placeholder: "Velg språk"
                },
                name: {
                  label: "Oversatt navn",
                  placeholder: ""
                },
                description: {
                  label: "Oversatt beskrivelse",
                  placeholder: ""
                }
              },
              buttons: {
                save: "Lagre"
              }
            },
            deletion: {
              heading: "Bekreft sletting",
              subHeading: "Er du sikker på at du vil slette",
              buttons: {
                delete: "Slett",
                cancel: "aNDRE"
              },
              responses: {
                error: "Feil ved sletting",
                success: "Sletting fullført"
              }
            }
          }
        },
        // [+] Changed
        prices: {
          heading: "Pris",
          table: {
            columns: {
              purchasingPrice: "Innkjøpspris",
              sellingPrice: "Salgspris",
              date: "Dato",
              author: "Endret av",
              origin: "Opprinnelse"
            },
            authorUnknown: "Ukjent",
            origins: {
              adjustment: "Justering",
              purchase_order: "Innkjøpsordre",
              sale_order: "Salgsordre",
              product: "Produkt",
              manual: "Manuelt"
            }
          }
        },
        locations: {
          heading: "Lokasjoner",
          table: {
            columns: [
              "Lokasjon",
              "Antall på lager",
              "Min. antall på lager",
              "Min. salgs antall"
            ]
          },
          // [+] Changed
          tooltips: {
            cannotDeleteWithProducts: "Kan ikke slette stedet der produktene er på lager",
            makeDefault: "Sett til standardlokasjon"
          },
          buttons: {
            save: "Lagre endringer"
          },
          modals: {
            deletion: {
              heading: "Bekreft sletting",
              subHeading: "Er du sikker på at du vil slette",
              buttons: {
                delete: "Slett",
                cancel: "Avbryt"
              },
              responses: {
                error: "Det oppsto en feil under sletting av lokasjon...",
                success: "Lokasjon er slettet!"
              }
            }
          },
          responses: {
            save: {
              success: "Lokasjoner er oppdatert!",
              error: "En feil oppstod ved endring av lokasjoner..."
            }
          }
        },
        // [+] Changed
        numbers: {
          heading: "Serie/Batch",
          serialNumbers: {
            heading: "Serienumre",
            table: {
              columns: {
                number: "Nummer",
                date: "Dato",
                received: "Mottatt",
                dispatched: "Sendt",
                actions: "Handlinger"
              }
            },
            filters: {
              additionDate: {
                label: "Tilleggsdato",
                placeholder: "Velg dato"
              }
            },
            modals: {
              update: {
                heading: "Rediger serienummer",
                fields: {
                  serialNumber: {
                    label: "Serienummer",
                    placeholder: "Skriv serienummer"
                  }
                },
                buttons: {
                  cancel: "Angre",
                  save: "Lagre"
                },
                responses: {
                  success: "Serienummeret er oppdatert",
                  error: "Det oppsto en feil under oppdatering av serienummeret"
                }
              }
            }
          },
          batchNumbers: {
            heading: "Batchnumre",
            table: {
              columns: {
                number: "Nummer",
                date: "Dato",
                expirationDate: "Utløpsdato",
                received: "Mottatt",
                dispatched: "Sendt",
                actions: "Handlinger"
              }
            },
            filters: {
              additionDate: {
                label: "Tilleggsdato",
                placeholder: "Velg datointervall"
              },
              expirationDate: {
                label: "Utløpsdato",
                placeholder: "Velg datointervall"
              }
            },
            modals: {
              update: {
                heading: "Rediger batchnummer",
                fields: {
                  batchNumber: {
                    label: "Batchnummer",
                    placeholder: "Skriv batchnummer"
                  },
                  expirationDate: {
                    label: "Utløpsdato",
                    placeholder: "Velg utløpsdato"
                  }
                },
                buttons: {
                  cancel: "Andre",
                  save: "Lagre"
                },
                responses: {
                  success: "Batchnummeret er oppdatert",
                  error: "Det oppsto en feil under oppdatering av batchnummeret"
                }
              }
            }
          },
          header: {
            search: {
              placeholder: "Søk serienummer"
            },
            filters: {
              heading: "Filtre"
            }
          }
        },
        purchaseOrder: {
          heading: "Innkjøpsordre",
          // [+] Changed
          table: {
            columns: [
              "Ordre ID",
              "Leverandør",
              "Antall",
              "Motta",
              "Ordredato"
            ],
            receiveStatuses: {
              notReceived: "Ikke mottatt",
              partiallyReceived: "Delvis mottatt",
              received: "Mottatt"
            }
          }
        },
        // [+] Changed
        saleOrder: {
          heading: "Salgsordre",
          table: {
            columns: [
              "Ordre ID",
              "Kunde",
              "Antall",
              "Fakturering",
              "Ordredato",
              "Reservert"
            ],
            modals: {
              reservation: {
                heading: {
                  creation: "Ny produktreservasjon",
                  editing: "Rediger produktreservasjon"
                },
                subheading: {
                  order: "Ordre",
                  product: "Produkt"
                },
                fields: {
                  quantity: {
                    label: "Antall",
                    placeholder: "Skriv inn antall som skal reserveres"
                  }
                },
                previousValue: "Tidligere verdi: {{value}}",
                buttons: {
                  cancel: "Avbryt",
                  reserve: "Reserver"
                },
                responses: {
                  creation: {
                    success: "Reservasjon opprettet!"
                  },
                  editing: {
                    success: "Reservasjon oppdatert!"
                  },
                  deletion: {
                    success: "Reservasjon slettet!"
                  }
                }
              }
            },
            invoicingStatuses: {
              notInvoiced: "Ikke fakturert",
              invoiced: "Fakturert"
            }
          }
        }
      },
      notFound: "Produkt ikke funnet"
    },
    createEditProduct: {
      // [+] Changed
      disabledDueToService: "Tjeneste",
      responses: {
        creation: {
          success: "Produktet er opprettet",
          error: "Det oppsto en feil under oppretting av produktet"
        },
        update: {
          success: "Produktet er oppdatert",
          error: "Det oppsto en feil under oppdatering av produktet"
        }
      },
      validation: {
        serialNumbers: "Serienumrene er feil utfylt!",
        batchNumbers: "Batchnumrene er feil utfylt!"
      },
      variants: {
        imageUploading: {
          buttonText: "Legg til bilde"
        },
        fields: {
          name: {
            label: "Variant valg",
            placeholder: "Farge, størrelse"
          },
          value: {
            label: "Variant valg verdier"
          }
        },
        buttons: {
          addNewVariant: "Legg til variant"
        },
        notFound: "Ingen varianter lagt til"
      },
      additionalPrices: {
        fields: {
          sellingPrice: {
            label: "Salgspris"
          },
          priceList: {
            label: "Prisliste",
            placeholder: "Velg prisliste"
          }
        },
        buttons: {
          addNewPrice: "Legg til ny pris"
        },
        notFound: "Ingen ekstra priser ble lagt til"
      },
      attachment: {
        imagePrompt: "Dra bilde hit",
        defaultImage: "Standardbilde",
        setAsDefault: "Sett som standard"
      },
      modals: {
        // [+] Changed
        deletionVariant: {
          heading: "Bekreft sletting",
          subheading: "Er du sikker på at du vil slette denne varianten: ",
          buttons: {
            cancel: "Angre",
            delete: "Slett"
          }
        },
        variant: {
          heading: "Legg til ny variant",
          titles: {
            weightAndSize: "Vekt og mål",
            prices: "Priser",
            inventory: "Lager",
            options: "Alternativer",
            attachments: "Bilde og beskrivelse"
          },
          fields: {
            productName: "Produktnavn",
            productCode: "Produkt ID",
            inStock: "På lager",
            barcode: "Strekkode",
            purchasePrice: "Innkjøpspris",
            sellingPrice: "Salgspris",
            extraCost: "Ekstra kost",
            dynamicPricePrompt: "Etter opprettelse kan kjøpesummen kun endres gjennom bestillinger",
            minPurchaseQTY: "Min. kjøpsmengde",
            minSaleQTY: "Min. salgsmengde",
            weight: "Vekt",
            CBM: "CBM",
            width: "Bredde",
            height: "Høyde",
            length: "Lengde",
            description: "Beskrivelse"
          },
          dropdowns: {
            defaultLocation: {
              label: "Standard lokasjon",
              placeholder: "Velg lokasjon"
            },
            supplier: {
              label: "Leverandør",
              placeholder: "Velg leverandør"
            },
            tax: {
              label: "MVA",
              placeholder: "Velg MVA sats"
            }
          },
          checkboxes: {
            batchNumber: {
              label: "Batchnummer",
              tip: "Kryss av for dette alternativet hvis dette produktet produseres i batcher. Transaksjoner som varemottak og leveranser vil bli gjort i batcher.."
            },
            serialNumber: {
              label: "Serienummer",
              tip: "Kryss av for dette alternativet hvis dette produktet har serienumre. Transaksjoner som lagermottak og leveranser vil bli gjort med serienummer."
            },
            component: {
              label: "Komponent",
              tip: "Kan dette produktet brukes som en komponent?"
            }
          },
          buttons: {
            addSerialNumbers: "Legg til serienumre",
            addBatchNumbers: "Legg til batchnumre",
            create: "Opprett",
            save: "Lagre"
          }
        },
        unit: {
          createButton: "Opprett",
          creationModal: {
            heading: "Opprett enhet",
            nameField: {
              label: "Navn",
              placeholder: "Kg, stk, liter"
            },
            createButton: "Opprett og bekreft",
            responses: {
              success: "Enhet er opprettet",
              error: "En feil oppstod ved oppretting av enhet"
            }
          },
          deletionModal: {
            heading: "Bekreft sletting",
            subheading: "Er du sikker på at du vil slette denne enheten?",
            cancel: "Avbryt",
            delete: "Slett",
            responses: {
              success: "Enhet har blitt slettet",
              error: "En feil oppstod ved sletting av enhet"
            }
          }
        },
        category: {
          createButton: "Opprett",
          creationModal: {
            heading: "Opprett kategori",
            // [+] Changed
            fields: {
              code: {
                label: "ID"
              },
              name: {
                label: "Navn"
              },
              isService: {
                label: "Tjeneste"
              }
            },
            createButton: "Opprett og bekreft",
            responses: {
              success: "Kategorien ble opprettet",
              idNotUnique: "Kategori ID skal være unik",
              error: "En feil oppstod ved oppretting av enhet"
            }
          }
        },
        location: {
          createButton: "Opprett",
          creationModal: {
            heading: "Opprett lokasjon",
            locationField: {
              label: "Lokasjonsnavn"
            },
            sectionsCheckbox: {
              title: "Seksjoner",
              tip: "..."
            },
            sectionField: {
              label: "Seksjonsnavn"
            },
            createButton: "Opprett og bekreft",
            responses: {
              success: "Lokasjon er opprettet",
              error: "En feil oppstod ved opprettelse av lokasjon"
            }
          }
        },
        supplier: {
          createButton: "Opprett",
          creationModal: {
            heading: "Opprett leverandør",
            fields: {
              supplierName: "Leverandørnavn",
              supplierCode: "Leverandørnummer",
              // [+] Changed
              name: "Navn",
              country: "Land",
              street: "Gate",
              street2: "Gate 2",
              zipcode: "Postnummer",
              city: "Poststed",
              email: "Epost",
              phone: "Telefon"
            },
            dropdowns: {
              country: {
                label: "Land",
                placeholder: "Velg land"
              },
              group: {
                label: "Gruppe",
                placeholder: "Velg gruppe"
              },
              paymentTerm: {
                label: "Betalingsbetingelser",
                placeholder: "Velg betalingsbetingelse"
              },
              defaultCurrency: {
                label: "Standard valuta",
                placeholder: "Velg valuta"
              },
              shipmentTerm: {
                label: "Fraktbetingelser",
                placeholder: "Velg fraktbetingelse"
              },
              shipmentMethod: {
                label: "Fraktmetode",
                placeholder: "Velg fraktmetode"
              }
            },
            categories: {
              address: "Adresse",
              options: "Valg"
            },
            createButton: "Opprett og lagre",
            responses: {
              success: "Leverandør har blitt opprettet",
              error: "Det oppstod en feil ved opprettelse av leverandør"
            }
          }
        },
        priceList: {
          createButton: "Opprett",
          creationModal: {
            heading: "Opprett prisliste",
            fields: {
              name: {
                label: "Prislistenavn"
              },
              code: {
                label: "Prislistenummer"
              }
            },
            dropdowns: {
              currency: {
                label: "Valuta",
                placeholder: "Velg valuta"
              }
            },
            createButton: "Opprett og lagre",
            responses: {
              success: "Prislisten er opprettet",
              error: "En feil oppstod ved opprettelse av prisliste"
            }
          }
        },
        currency: {
          createButton: "Opprett",
          creationModal: {
            heading: "Opprett ny valuta",
            dropdowns: {
              code: {
                label: "Valutanummer",
                placeholder: "Velg valutanummer"
              }
            },
            symbol: {
              label: "Symbol"
            },
            createButton: "Opprett og lagre",
            responses: {
              success: "Valuta er lagt til",
              error: "En feil oppstod ved opprettelse av valuta"
            }
          }
        },
        imagesUploading: {
          heading: "Last opp bilde",
          addImage: "Legg til bilde",
          close: "Lukk"
        },
        templates: {
          buttons: {
            create: "Opprett produkt og lagre mal",
            manage: "Behandle maler",
            delete: "Slett mal",
            save: "Lagre endringer"
          },
          creationModal: {
            heading: "Lagre mal",
            fields: {
              name: "Navn på mal"
            },
            buttons: {
              save: "Lagre"
            },
            responses: {
              success: "Mal er opprettet og lagt til",
              error: "En feil oppstod ved lagring av mal"
            }
          },
          deletionModal: {
            heading: "Bekreft sletting",
            subheading: "Er du sikker på at du vil slette?",
            templateInterpretation: "Mal",
            buttons: {
              cancel: "Avbryt",
              delete: "Slett"
            },
            responses: {
              success: "Malen er slettet!",
              error: "En feil oppstod ved sletting av mal!"
            }
          },
          savingProcess: {
            responses: {
              success: "Malen er oppdatert!",
              error: "En feil oppstod ved oppdatering av mal!"
            }
          }
        },
        // [+] Changed
        tax: {
          dropdown: {
            label: "MVA-sats",
            placeholder: "Velg MVA-sats",
            buttons: {
              create: "Opprett"
            }
          },
          modals: {
            creation: {
              heading: "Opprett MVA-sats",
              taxName: {
                label: "MVA-sats navn"
              },
              taxRate: {
                label: "MVA-sats"
              },
              buttons: {
                create: "Opprett og legg til"
              },
              responses: {
                success: "MVA-sats er opprettet!",
                error: "Det oppsto en feil ved opprettelse av Mva sats..."
              }
            }
          }
        }
      },
      buttons: {
        create: "Opprett produkt",
        save: "Lagre",
        cancel: "Avbryt"
      }
    },
    // [+] Changed
    general: {
      categories: {
        options: "Alternativer",
        attachments: "Bildebeskrivelse",
        prices: "Priser",
        weights: "Vekt og størrelse",
        inventory: "Inventar",
        variants: "Varianter"
      },
      fields: {
        isService: {
          label: "Tjeneste",
          obtainedFromCategory: "Arve fra kategori"
        },
        isWebProduct: {
          label: "Nettbutikk",
          badge: "Nettbutikk",
          tip: "Produkter som er merket for nettbutikksynkronisering holdes oppdatert mot integrerte nettbutikker."
        },
        productName: "Produktnavn",
        productCode: "Produktkode",
        supplierProductCode: "Leverandørsproduktkode",
        barcode: "Strekkode",
        unit: {
          label: "Enhet",
          placeholder: "Velg enhet"
        },
        category: {
          label: "Kategori",
          placeholder: "Velg kategori",
          // [+] Changed
          serviceBadge: "Service"
        },
        defaultLocation: {
          label: "Standard plassering",
          placeholder: "Velg lokasjon"
        },
        primarySupplier: {
          label: "Primærleverandør",
          placeholder: "Velg leverandør"
        },
        defaultTax: {
          label: "Standard MVA",
          placeholder: "Velg MVA-sats"
        },
        attachmentDescription: "Beskrivelse",
        rfid: {
          title: "RFID",
          tip: "..."
        },
        batchNumber: {
          title: "Batchnummer",
          tip: "Merk av for dette alternativet hvis produktet har serienummer. Transaksjoner som varemottak og leveranser vil bli utført med serienummer."
        },
        serialNumber: {
          title: "Serienummer",
          tip: "Merk av for dette alternativet hvis produktet har serienummer. Transaksjoner som varemottak og leveranser vil bli utført med serienummer."
        },
        components: {
          title: "Komponenter",
          tip: "Har dette produktet komponenter?"
        },
        variants: {
          title: "Varianter",
          tip: "Har dette produktet varianter? Du vil ikke kunne legge til varianter senere hvis du ikke velger dette alternativet når du oppretter et nytt produkt."
        },
        purchasePrice: "Innkjøpspris",
        sellingPrice: "Salgspris",
        // [+] Changed
        extraCost: "Ekstra kost",
        dynamicPricePrompt: "Priser etter opprettelse kan kun endres gjennom bestillinger",
        noVariants: "Ingen varianter",
        addVariant: "Legg til variant",
        newVariant: "Ny",
        deletedVariant: "Slettet",
        currency: {
          label: "Valuta",
          placeholder: "Valg valuta"
        },
        weight: "Vekt",
        cbm: "CBM",
        width: "Bredde",
        height: "Høyde",
        length: "Lengde/dybde",
        inStock: "På lager",
        invQty: "Min. lagermengde",
        purchaseQty: "Min. Innkjøpsmengde",
        saleQty: "Min. salgsantall"
      },

      unitEquivalents: {
        header: "Ekvivalente enheter",
        button: "Legg til ekvivalent enhet",
        checkbox: "Vis med grunnenhet",
        inStockLabel: "På lager",
        save: "Lagre",
        delete: "Slett",
        cancel: "Avbryt",
      },

      // [+] Changed
      buttons: {
        addSerialNumbers: "Legg til serienumre",
        addBatchNumbers: "Legg til batchnumre"
      }
    },
    modals: {
      deletion: {
        heading: "Bekreft sletting",
        subheading: "Er du sikker på at du vil slette",
        buttons: {
          cancel: "Angre",
          delete: "Slett"
        },
        responses: {
          success: "Produktet er slettet!",
          error: "Det oppsto en feil under sletting av produktet!"
        }
      }
    }
  },
  inventory: {
    stock: {
      // [+] Changed
      redirect: "Lagertellingsrapport",
      table: {
        titleDeclinations: [
          "gjenstand",
          "gjenstander",
          "gjenstander"
        ],
        columns: {
          productName: "Produktnavn",
          category: "Kategori",
          purchasePrice: "Innkjøpspris",
          inStock: "På lager",
          totalValue: "Total verdi",
          actions: "Handlinger"
        }
      },
      subtable: {
        // [+] Changed
        columns: {
          locationName: "Lokasjon",
          sectionName: "Seksjon",
          sectionSector: "Sektor",
          sectionRow: "Rad",
          sectionShelfHeight: "Hylle",
          inStock: "Antall",
          projects: "Prosjekt"
        }
      },
      modals: {
        filter: {
          fields: {
            location: {
              label: "Lokasjon"
            },
            category: {
              label: "Kategori"
            },
            purchasePrice: {
              label: "Innkjøpspris"
            },
            inStock: {
              label: "På lager"
            },
            projects: {
              label: "Prosjekt",
              placeholder: "Velg prosjekt",
              noProjectsFound: "Ingen prosjekt funnet"
            }
          }
        },
        export: {
          title: "Eksporter lager",
          fields: {
            historyReversionDate: {
              label: "Få lagerbeholdning for en dato",
              placeholder: "Velg dato"
            },
            export: {
              label: "Eksport",
              dropdown: {
                chooseAll: "Alle",
                chooseCustom: "Egendefinert beløp",
                chooseSelected: "Valgt"
              }
            },
            customNumberField: {
              placeholder: "Legg antall produkter du ønsker å eksportere"
            },
            exportTo: {
              label: "Eksporter til",
              options: [
                "Excel",
                "PDF"
              ]
            }
          },
          exportButton: "Eksport"
        }
      }
    },
    // [+] Changed
    stockCount: {
      main: {
        redirect: "Produkter på lager",
        status: [
          "Ny",
          "Kansellert",
          "Avvist",
          "Bekreftet"
        ],
        table: {
          columns: {
            id: "Rapport id",
            location: "Lokasjon",
            date: "Dato",
            author: "Ansatt",
            status: "Status",
            rollback_file: "Tilbakefør fil"
          }
        },
        subtable: {
          columns: [
            "Produkt",
            "Lokasjon",
            "Antall på lager",
            "Faktisk mengde",
            "Differanse"
          ],
          buttons: {
            approve: "Godkjenn rapport",
            decline: "Avvis rapport"
          }
        },
        filters: {
          location: {
            label: "Lokasjon"
          },
          date: {
            label: "Dato",
            placeholder: "Velg periode"
          },
          worker: {
            label: "Ansatt"
          },
          status: {
            label: "Status"
          }
        },
        export: {
          columns: {
            stock_count_id: "Rapport id",
            worker_first_name: "Ansatt fornavn",
            worker_last_name: "Ansatt etternavn",
            store: "Lager",
            section: "Seksjon",
            status: "Status",
            decline_comment: "Avvis kommentar",
            cancel_comment: "Andre kommentar",
            date: "Dato",
            product_id: "Produkt ID",
            product_name: "Produkt navn",
            counted_quantity: "Telt mengde",
            system_quantity: "System mengde",
            reviewer_first_name: "Reviewer fornavn",
            reviewer_last_name: "Reviewer etternavn"
          },
          responses: {
            error: "Kan ikke eksportere lagertelling!"
          }
        }
      },
      modals: {
        approve: {
          heading: "Godkjenn lagertellingsrapport",
          subheading: "Er du sikker på at du vil godkjenne <badge>{{reportId}}</badge> av <bold>{{worker}}</bold>?",
          buttons: {
            cancel: "Anbryt",
            confirm: "Bekreft"
          },
          verificationWord: {
            label: "Skriv rapportkoden for å bekrefte godkjenningen"
          },
          email: {
            label: "Epost",
            placeholder: "Skriv inn din epost",
            tip: "Lagerrapporten vil bli sendt til denne e-postadressen, slik at du kan tilbakestille endringer om nødvendig"
          },
          zeroOutStock: {
            label: "Nullstill lagerbeholdningen for uopptellede varer"
          },
          responses: {
            success: "Godkjenning av lagertelling har startet!",
            error: "Det oppsto en feil under godkjenning av lagertelling!"
          },
          stockCountApprovalInProgressAlert: "Godkjenning av lagertelling er allerede i gang"
        },
        decline: {
          heading: "Avvis rapport fra lagertelling",
          subheading: "Er du sikker på at du vil avvise <bold>{{reportId}}</bold> av {{worker}}?",
          additionalText: "Vennligst beskriv årsaken under",
          placeholder: "Describe the reason",
          buttons: {
            cancel: "Avbryt",
            confirm: "Bekreft"
          },
          responses: {
            success: "Lagertellingen er avvist!",
            error: "Det oppsto en feil ved avvisning av lagertelling!"
          }
        },
        merge: {
          heading: "Slå sammen varetellinger",
          positive: {
            subheading: "Er du sikker på at du vil slå sammen <bold>{{reports}}</bold>?"
          },
          negative: {
            subheading: "Følgende rapporter <bold>({{reports}})</bold> har konflikt.",
            additionalText: "Vil du slå dem sammen?"
          },
          table: {
            columns: [
              "Rapport id",
              "Ansatt",
              "Antall på lager",
              "Telt mengde"
            ]
          },
          buttons: {
            cancel: "Avbryt",
            submit: "Bekreft"
          },
          responses: {
            success: "Lagertellinger er slått sammen!",
            error: "Det oppsto en feil under sammenslåing av lagertellinger!"
          }
        }
      },
      indicator: {
        states: {
          finishedSuccessfully: "Lagertellingen er utført",
          finishedWithErrors: "Lagertellingen er ikke brukt på grunn av feil",
          inProgress: "Lagernivåene oppdateres i henhold til lagertellingsrapporten",
          applied: "Lagerbeholdningen er oppdatert i henhold til den godkjente lagertellingsrapporten",
          error: {
            title: "Det oppsto en feil under opptelling av lagerbeholdning",
            message: "Rapporten er sendt til e-postadressen din"
          }
        }
      }
    },
    adjustments: {
      table: {
        titleDeclinations: [
          "gjenstand",
          "gjenstander",
          "gjenstander"
        ],
        columns: [
          "Produktnavn/Justerings-ID",
          "Lokasjon",
          "Bruker",
          "Tilpasninger",
          "Merknader",
          "Dato",
          "Handling",
          "Ordrereferanse"
        ],
        adjustmentTypes: {
          quantity: "Antall",
          costPrice: "Innkjøpspris"
        }
      },
      createViewEditAdjustments: {
        fieldsGeneral: {
          product: {
            label: "Produkt",
            placeholder: "Velg produkt"
          },
          location: {
            label: "Lokasjon",
            placeholder: "Velg lokasjon",
            disableReason: "Velg produkt først"
          },
          date: {
            label: "Dato"
          },
          adjustment: {
            label: "Lagerjusteringer",
            selectQuantity: "Antall",
            selectCostPrice: "Innkjøpspris"
          },
          remarks: {
            label: "Merknader"
          },
          // [+] Changed
          sellingPriceChange: {
            label: "Oppdatert salgspris"
          }
        },
        fieldsCreateQuantityAdjustment: {
          availableQuantity: {
            label: "Tilgjengelig antall"
          },
          actualQuantity: {
            label: "Faktisk mengde"
          },
          availableQuantityDifference: {
            label: "Tilgjengelig mengde (forskjell)"
          }
        },
        fieldsCreateCostPriceAdjustment: {
          costPrice: {
            label: "Innkjøpspris"
          },
          actualCostPrice: {
            label: "Faktisk kostpris"
          },
          actualCostPriceDifference: {
            label: "Faktisk kostpris (forskjell)"
          }
        }
      },
      createAdjustment: {
        heading: "Opprett ny lagerjustering",
        button: "Lagre",
        responses: {
          success: "Lagerjusteringen var velykket!",
          error: "Det oppstod en feil ved justering av lager!"
        }
      },
      editAdjustment: {
        heading: "Lagerjustering",
        button: "Lagre endringer",
        notFound: "Ingen lagerjustering funnet!",
        responses: {
          success: "Lagerjusteringen var velykket!",
          error: "En feil oppstod ved justering av lager!"
        }
      },
      viewAdjustment: {
        heading: "Lagerjustering"
      },
      notFound: "Ingen lagerjustering funnet",
      modals: {
        filter: {
          fields: {
            product: {
              label: "Produkt"
            },
            adjustment: {
              label: "Kjøpesum"
            },
            location: {
              label: "Kjøpesum"
            },
            user: {
              label: "Bruker"
            },
            date: {
              label: "Dato",
              placeholder: "Velg dato"
            }
          }
        },
        confirmDelete: {
          label: "Bekreft sletting",
          hint: "Er du sikker på at du vil slette",
          deletionItem: "Lagerjustering",
          buttons: {
            cancel: "Avbryt",
            delete: "Slett"
          },
          responses: {
            success: "Lagerjustering er slettet!",
            error: "En feil oppstod ved sletting av lagerjustering!"
          }
        },
        // [+] Changed
        sellingPriceSuggestion: {
          heading: "Oppdater salgspris",
          prompt: "Vil du også oppdatere salgsprisen etter at den nye kostprisen er lagret? <br/> <b>Du kan alltid oppdatere salgsprisen manuelt i produktkortet.</b>",
          currentSellingPrice: "Gjeldende salgspris: {{current}}",
          options: {
            addedPrice: "Oppdater salgspris basert på tillagt prisdifferanse",
            percent: "Oppdater salgspris basert på den justerte {{percent}}%"
          },
          newPrice: "Ny pris",
          buttons: {
            decline: "Avvis",
            update: "Oppdater"
          }
        }
      }
    },
    collections: {
      table: {
        titleDeclinations: [
          "gjenstand",
          "gjenstander",
          "gjenstander"
        ],
        columns: [
          "Samlings-ID",
          "Navn",
          "Produkter",
          "Handling"
        ]
      },
      subtable: {
        columns: [
          "ID",
          "Produkt",
          "Kvantitet"
        ]
      },
      // [+] Changed
      collectionMutation: {
        editing: {
          heading: "Rediger samling",
          responses: {
            success: "Samling ble oppdatert",
            error: "Feil ved oppdatering av samling"
          }
        },
        creation: {
          heading: "Opprett ny samling",
          responses: {
            success: "Samling ble opprettet",
            error: "Feil ved opprettelse av samling"
          }
        },
        modals: {
          mutateProduct: {
            editing: {
              heading: "Rediger produkt"
            },
            addition: {
              heading: "Legg til produkt"
            },
            fields: {
              product: {
                label: "Produkt",
                placeholder: "Velg produkt"
              },
              quantity: {
                label: "Antall",
                placeholder: "0.00"
              }
            },
            saveButton: "Lagre"
          }
        },
        fields: {
          code: {
            label: "Samlings ID",
            placeholder: "Skriv ID"
          },
          name: {
            label: "Navn",
            placeholder: "Skriv inn samlingens navn",
          },
          barcode: {
            label: "Strekkode",
            placeholder: "Skriv barcode"
          },
          products: {
            header: "Produkter",
            placeholder: "Ingen produkter",
            addButton: "Legg til produkt",
            validationErrors: {
              zeroProducts: "Ingen produkter ble lagt til"
            },
            table: {
              columns: [
                "ID",
                "Produktnavn",
                "Antall",
                "Handlinger"
              ]
            }
          }
        },
        saveButton: "Lagre"
      },
      modals: {
        deletion: {
          heading: "Bekreft sletting",
          subheading: "Er du sikker på at du vil slette samlingen",
          buttons: {
            cancel: "Avbryt",
            delete: "Slett"
          },
          responses: {
            success: "Samlingen ble slettet",
            error: "Feil ved sletting av samling"
          }
        }
      }
    },
    stockTransfers: {
      table: {
        titleDeclinations: [
          "gjenstand",
          "gjenstander",
          "gjenstander"
        ],
        columns: [
          "Produktnavn/overførings-ID",
          "Fra lokasjon",
          "Til lokasjon",
          "Bruker",
          "Merknader",
          "Dato",
          "Handling"
        ]
      },
      modals: {
        filter: {
          fields: {
            product: {
              label: "Produktnavn"
            },
            user: {
              label: "Bruker"
            },
            fromLocation: {
              label: "Fra lokasjon"
            },
            toLocation: {
              label: "Til lokasjon"
            },
            date: {
              label: "Merknader",
              placeholder: "Velg periode"
            }
          },
          productLabel: "Produkt",
          productDropdownOptions: {
            chooseAllLabel: "Alle"
          },
          adjustmentLabel: "Tilpasninger",
          locationLabel: "Lokasjon",
          locationDropdownOptions: {
            chooseAllLabel: "Alle"
          },
          userLabel: "Bruker",
          userDropdownOptions: {
            chooseAllLabel: "Alle"
          },
          dateLabel: "Dato",
          remarksLabel: "Merknader",
          remarksDropdownOptions: {
            chooseAllLabel: "Alle"
          }
        },
        confirmDelete: {
          heading: "Slett lageroverføring",
          subheading: "Er du sikker på at du vil slette?",
          deletionItem: "Lageroverføring",
          buttons: {
            cancel: "Avbryt",
            delete: "Slett"
          },
          responses: {
            success: "Lageroverføringen ble slettet!",
            error: "En feil oppstod ved sletting av lageroverføring..."
          }
        },
        // [+] Changed
        exporting: {
          dropdown: {
            label: "Tittel",
            options: {
              productName: "Produktnavn",
              fromLocation: "Fra lokasjon",
              toLocation: "Til lokasjon",
              user: "Bruker",
              remarks: "Merknader",
              date: "Dato"
            }
          }
        }
      },
      stockTransfer: {
        disables: {
          fromLocation: {
            noProduct: "Velg produkt først"
          },
          section: {
            noLocation: "Velg lokasjon først",
            noSection: "Lokasjonen har ingen seksjoner"
          },
          toLocation: {
            noFromLocation: "Velg fra lokasjon først",
            noFromSection: "Velg fra seksjon først"
          }
        },
        fields: {
          product: {
            label: "Produkt",
            placeholder: "Velg produkt"
          },
          fromLocation: {
            label: "Fra lokasjon",
            placeholder: "Velg lokasjon"
          },
          section: {
            label: "Seksjon",
            placeholder: "Velg seksjon"
          },
          toLocation: {
            label: "Til lokasjon",
            placeholder: "Velg lokasjon"
          },
          date: {
            label: "Etikett"
          },
          availableQuantity: {
            label: "Tilgjengelig mengde"
          },
          transferQuantity: {
            label: "Overføringsmengde"
          },
          remarks: {
            label: "Merknader"
          },
          upload: {
            label: "Last opp fil",
            button: "Klikk for å bla gjennom eller dra og slipp fil"
          },
          files: {
            label: "Filer"
          } 
        },
        saveButton: "Lagre",
        notFound: "Lageroverføring ble ikke funnet"
      },
      createTransfer: {
        heading: "Opprett ny lageroverføring",
        responses: {
          success: "Lageroverføringen ble opprettet!",
          error: "En feil oppstod ved opprettelse av lageroverføring..."
        }
      },
      viewEditTransfer: {
        heading: "Lageroverføring",
        responses: {
          success: "Lageroverføringen har blitt oppdatert!",
          error: "En feil oppstod ved oppdatering av lageroverføringen..."
        }
      },
      tooltip: "..."
    }
  },
  customers: {
    main: {
      table: {
        columns: {
          customerNameOrId: "Kundenavn / ID",
          customerType: "Kundetype",
          email: "E-post",
          phone: "Telefon",
          contactName: "Kontaktperson",
          action: "Handling"
        },
        titleDeclinations: [
          "kunde",
          "kunder",
          "kunder"
        ],
        // [+] Changed
        company: "Firma",
        person: "Person"
      },
      modals: {
        export: {
          heading: "Eksporter kunder",
          dropdown: {
            label: "Tittel",
            placeholder: "Velg tittel",
            options: {
              companyName: "Firmanavn",
              email: "Epost",
              phone: "Telefon",
              country: "Land",
              vat: "Organisasjonsnummer",
              contactPerson: "Kontaktperson",
              address: "Adresse",
              group: "Gruppe"
            }
          },
          buttons: {
            export: "Eksport"
          }
        }
      }
    },
    creation: {
      heading: "Opprett ny kunde",
      responses: {
        success: "Kunde er opprettet!",
        error: "En feil oppstod ved opprettelse av kunde..."
      }
    },
    editing: {
      responses: {
        success: "Kunde er oppdatert!",
        error: "En feil oppstod ved oppdatering av kunde..."
      }
    },
    // [+] Changed
    viewPage: {
      sideButtons: {
        createSalesOrder: "Opprett salgsordre",
        edit: "Rediger",
        delete: "Slett",
        sendEmail: "Send epost"
      }
    },
    general: {
      save: "Lagre",
      alerts: {
        formIsInvalid: "Noen felt er feil utfylt!"
      },
      modals: {
        deletion: {
          heading: "Bekreft sletting",
          subheading: "Er du sikker på at du vil slette",
          buttons: {
            cancel: "Avbryt",
            delete: "Slett"
          },
          responses: {
            success: "Kunde er slettet!",
            error: "En feil oppstod ved sletting av kunde..."
          }
        }
      },
      tabs: {
        general: {
          heading: "Generelt",
          categories: {
            contactInfo: "Kontaktinformasjon",
            additionalContactInfo: "Ekstra kontaktinformasjon"
          },
          fields: {
            customerName: {
              label: "Kundenavn"
            },
            customerCode: {
              label: "Kundenummer"
            },
            registrationNumber: {
              label: "Registration number"
            },
            contactName: {
              label: "Kontakt navn"
            },
            phone: {
              label: "Telefon"
            },
            email: {
              label: "Epost"
            }
          },
          // [+] Changed
          checkboxes: {
            isCompany: "Firma",
            isPerson: "Person"
          },
          buttons: {
            addContact: "Legg til ny kontakt",
            delete: "Slett",
            next: "Neste"
          }
        },
        pricesAndDiscounts: {
          heading: "Priser og rabatter",
          // [+] Changed
          table: {
            columns: [
              "Navn",
              "Pris",
              "Rabatt (%)",
              "Min. antall",
              "Gyldig fra",
              "Gyldig til",
              "Handling"
            ],
            noProduct: "Ingen produkter",
            buttons: {
              addProduct: "Legg til produkt"
            },
            categoryLabel: "Kategori",
            expiredLabel: "Expired",
            noExpiration: "No expiration date"
          },
          modals: {
            type: [
              "Produkter",
              "Kategori"
            ],
            heading: {
              addProduct: "Legg til produkt",
              editProduct: "Rediger produkt",
              addCategory: "Legg til kategori",
              editCategory: "Rediger kategori"
            },
            dropdowns: {
              product: {
                label: "Produkt",
                placeholder: "Velg produkt"
              },
              category: {
                label: "Kategori",
                placeholder: "Velg kategori"
              }
            },
            fields: {
              price: {
                label: "Pris"
              },
              discount: {
                label: "Rabatt (%)",
                placeholder: "0.00"
              },
              minQuantity: {
                label: "Min.antall"
              },
              validFrom: {
                label: "Gyldig fra",
                placeholder: "Velg dato"
              },
              validTill: {
                label: "Gyldig til",
                placeholder: "Velg dato",
                tip: "(eksklusiv)"
              }
            },
            buttons: {
              add: "Legg til",
              save: "Lagre"
            }
          },
          buttons: {
            prev: "Tilbake",
            next: "Neste"
          }
        },
        address: {
          heading: "Adresse",
          categories: {
            billing: "Fakturaadresse",
            delivery: "Leveringsadresse"
          },
          fields: {
            name: {
              label: "Navn"
            },
            street: {
              label: "Gate"
            },
            street2: {
              label: "Gate 2"
            },
            zipcode: {
              label: "Postnummer"
            },
            city: {
              label: "Poststed"
            },
            country: {
              label: "Land"
            },
            contact_person: {
              label: "Kontaktperson"
            },
            phone: {
              label: "Telefon"
            },
            email: {
              label: "Epost",
              // [+] Changed
              validation: {
                requiredByPOGO: "Påkrevd av PowerOffice GO"
              }
            }
          },
          checkboxes: {
            useForShipping: "Bruk denne adressen som leveringsadresse",
            useAsPrimary: "Bruk denne adressen som standard leveringsadresse"
          },
          buttons: {
            addDelivery: "Legg til ny leveringsadresse",
            delete: "Slett",
            prev: "Tilbake",
            next: "Lagre"
          },
          // [+] Changed
          warnings: {
            billingIsRecommendedByPOGO: "Faktureringsadressen er synkronisert med e-postadressen i PowerOffice GO, noe som er viktig for å få tilgang til de fleste funksjonene. Vennligst fyll ut denne informasjonen for å maksimere fordelene med integrasjonen din."
          }
        },
        settings: {
          heading: "Innstillinger",
          // [+] Changed
          fields: {
            discount: {
              label: "Rabatt(%)",
              placeholder: "Oppgi rabatt"
            }
          },
          dropdowns: {
            language: {
              label: "Språk",
              placeholder: "Velg språk"
            },
            taxRate: {
              label: "MVA-sats",
              placeholder: "Velg MVA-sats"
            },
            paymentTerms: {
              label: "Betalingsbetingelser",
              placeholder: "Velg betalingsbetingelser"
            },
            deliveryTerms: {
              label: "Leveringsbetingelser",
              placeholder: "Velg leveringsbetingelser"
            },
            reference: {
              label: "Referanse",
              placeholder: "Velg referanse"
            }
          },
          buttons: {
            prev: "Tilbake",
            save: "Lagre"
          }
        },
        salesOrders: {
          heading: "Salgsordre",
          columns: [
            "Salgsordre",
            "Fakturert",
            "Sendt",
            "Totalt",
            "Ordre dato"
          ],
          invoicedStatus: [
            "Ikke fakturert",
            "Fakturert"
          ],
          shippedStatus: [
            "Ikke sendt",
            "Klar",
            "Levert"
          ]
        },
        sideButtons: {
          createSalesOrder: "Opprett salgsordre",
          edit: "Rediger",
          delete: "Slett"
        }
      }
    }
  },
  customerGroups: {
    main: {
      table: {
        columns: [
          "Gruppe ID",
          "Gruppe navn",
          "Rabatt (%)",
          "Handling"
        ]
      }
    },
    creation: {
      heading: "Ny kundegruppe",
      responses: {
        success: "Kundegruppen er opprettet!",
        error: "Det oppsto en feil under oppretting av en kundegruppe..."
      }
    },
    editing: {
      responses: {
        success: "Kundegruppen er oppdatert!",
        error: "Det oppsto en feil under oppdatering av en kundegruppe..."
      }
    },
    viewPage: {
      sideButtons: {
        edit: "Rediger",
        delete: "Slett",
        sendEmail: "Send epost"
      }
    },
    mutation: {
      fields: {
        groupCode: {
          label: "Gruppe ID",
          placeholder: "Skriv ID"
        },
        groupName: {
          label: "Gruppe navn",
          placeholder: "Skriv name"
        },
        discount: {
          label: "Rabatt",
          placeholder: "Velg rabatt"
        }
      },
      dropdowns: {
        customer: {
          title: "Kunder",
          label: "Kunde",
          placeholder: "Velg kunde"
        }
      },
      table: {
        heading: "Produkter",
        noProduct: "Ingen Produkter",
        columns: [
          "Produkt ID",
          "Produkt navn",
          "Pris per enhet",
          "Gyldig fra",
          "Gyldig til",
          "Handling"
        ],
        expiredLabel: "Utløpt",
        noExpiration: "Ingen utløpsdato",
        buttons: {
          addProduct: "Legg til produkt"
        }
      },
      buttons: {
        save: "Lagre"
      },
      modals: {
        product: {
          addProduct: "Legg til produkt",
          editProduct: "Rediger produkt",
          fields: {
            unitPrice: {
              label: "Pris per enhet",
              placeholder: "Velg salgspris"
            },
            validFrom: {
              label: "Gyldig fra",
              placeholder: "Velg dato"
            },
            validTill: {
              label: "Gyldig til",
              placeholder: "Velg dato",
              tip: "(eksklusiv)"
            }
          },
          dropdowns: {
            product: {
              label: "Produkt",
              placeholder: "Velg produkt"
            }
          },
          buttons: {
            add: "Legg til",
            save: "Lagre"
          }
        },
        deletion: {
          heading: "Bekreft sletting",
          subheading: "Er du sikker på at du vil slette",
          buttons: {
            cancel: "Avbryt",
            delete: "Slett"
          },
          responses: {
            success: "Kundegruppen er slettet!",
            error: "Det oppsto en feil under sletting av kundegruppen..."
          }
        }
      }
    }
  },
  suppliers: {
    main: {
      table: {
        columns: [
          "Leverandørnavn",
          "Epost",
          "Telefon",
          "Kontakt navn",
          "Handling"
        ],
        titleDeclinations: [
          "leverandør",
          "leverandører",
          "leverandører"
        ]
      },
      modals: {
        export: {
          heading: "Eksporter leverandører",
          dropdown: {
            label: "Tittel",
            placeholder: "Velg tittel",
            options: {
              companyName: "Leverandørnavn",
              email: "Epost",
              phone: "Telefon",
              country: "Land",
              vat: "Organisasjonsnummer",
              contactPerson: "Kontaktperson",
              address: "Adresse"
            }
          },
          buttons: {
            export: "Eksporter"
          }
        }
      }
    },
    creation: {
      heading: "Opprett ny leverandør",
      responses: {
        success: "Leverandør ble opprettet!",
        error: "En feil oppstod ved opprettelse av leverandør..."
      }
    },
    editing: {
      responses: {
        success: "Leverandør er oppdatert!",
        error: "En feil oppstod ved oppdatering av leverandør..."
      }
    },
    // [+] Changed
    viewPage: {
      sideButtons: {
        createPurchase: "Opprett salgsordre",
        edit: "Rediger",
        delete: "Slett",
        sendEmail: "Send epost"
      }
    },
    general: {
      modals: {
        deletion: {
          heading: "Bekreft sletting",
          subheading: "Er du sikker på at du vil slette",
          buttons: {
            cancel: "Avbryt",
            delete: "Slett"
          },
          responses: {
            success: "Leverandør har blitt slettet!",
            error: "Det oppstod en feil ved sletting av leverandør..."
          }
        }
      },
      tabs: {
        // [+] Changed
        heading: "Opprett ny leverandør",
        create: "Opprett",
        save: "Lagre",
        alerts: {
          formIsInvalid: "Noen felt er feil utfyllt!"
        },
        general: {
          heading: "Generelt",
          categories: {
            contactInfo: "Kontaktinformasjon",
            additionalContactInfo: "Ekstra kontaktinformasjon"
          },
          fields: {
            supplierName: {
              label: "Leverandørnavn"
            },
            supplierCode: {
              label: "Leverandørnummer"
            },
            registrationNumber: {
              label: "Organisasjonsnummer"
            },
            contactName: {
              label: "Kontaktperson"
            },
            phone: {
              label: "Telefon"
            },
            email: {
              label: "Epost"
            }
          },
          buttons: {
            delete: "Slett",
            next: "Neste"
          }
        },
        address: {
          heading: "Adresse",
          categories: {
            billing: "Fakturaadresse",
            delivery: "Leveringsadresse"
          },
          fields: {
            name: {
              label: "Navn"
            },
            street: {
              label: "Gate"
            },
            street2: {
              label: "Gate 2"
            },
            zipcode: {
              label: "Postnummer"
            },
            city: {
              label: "Poststed"
            },
            country: {
              label: "Land"
            },
            contact_person: {
              label: "Kontaktperson"
            },
            phone: {
              label: "Telefon"
            },
            email: {
              label: "Epost"
            }
          },
          checkboxes: {
            useForReturn: "Bruk denne adressen som leveringsadresse",
            useAsPrimary: "Bruk denne adressen som standard leveringsadresse"
          },
          buttons: {
            delete: "Slett",
            prev: "Tilbake",
            next: "Lagre"
          },
        },
        // [+] Changed
        settings: {
          heading: "Innstillinger",
          dropdowns: {
            currency: {
              label: "Valuta",
              placeholder: "Velg valuta",
              base: "Base"
            },
            taxRate: {
              label: "MVA-sats",
              placeholder: "Velg MVA-sats"
            },
            paymentTerms: {
              label: "Betalingsbetingelser",
              placeholder: "Velg betalingsbetingelser"
            },
            deliveryTerms: {
              label: "Leveringsbetingelser",
              placeholder: "Velg leveringsbetingelser"
            },
            language: {
              label: "Språk",
              placeholder: "Velg språk"
            }
          },
          buttons: {
            prev: "Tilbake",
            save: "Lagre"
          }
        },
        purchaseOrders: {
          heading: "Innkjøpsordre",
          columns: [
            "Innkjøpsordre",
            "Fakturert",
            "Mottatt",
            "Totalt",
            "Ordredato"
          ],
          invoicedStatus: [
            "Ikke faktuert",
            "I prosess",
            "Faktuert"
          ],
          receivedStatus: [
            "Ikke mottatt",
            "I prosess",
            "Mottatt"
          ],
          startReceiving: "Start mottak"
        },
        receives: {
          heading: "Motta",
          columns: [
            "Mottak ID",
            "Innkjøpsordre",
            "Mottak dato"
          ]
        }
      }
    }
  },
  settings: {
    sidebarLinks: {
      general: {
        title: "Generelt",
        categories: {
          companyInformation: "Bedriftsinformasjon",
          defaults: "Standardinnstillinger",
          units: "Enheter",
          locations: "Lokasjoner",
          currencies: "Valutaer",
          paymentTerms: "Betalingsbetingelser",
          deliveryTerms: "Leveringsbetingelser",
          packaging: "Emballasje",
          languages: "Språk",
          taxRates: "MVA-satser",
          categories: "Kategorier",
          customFields: "Tilpassede felt",
          myAccount: "Min konto",
        }
      },
      integrations: {
        title: "Integrasjoner",
        categories: {
          integrations: "Integrasjoner",
        }
      }
    },
    general: {
      companyInformation: {
        tabs: {
          companyDetails: {
            title: "Firmadetaljer",
            logo: {
              label: "Logo",
              restriction: [
                "Denne logoen vil vises på transaksjoner og epostvarsler.",
                "Foretrukket bildestørrelse: 240px x 240px @ 72 DPI Maksimal størrelse på 1MB."
              ],
              prompt: "Dra bildet hit"
            },
            // [+] Changed
            fields: {
              companyName: "Selskapsnavn",
              street: "Gatenavn",
              street2: "Gatenavn 2",
              city: "Poststed",
              zipCode: "Postnummer",
              phone: "Telefonnummer",
              email: "Epost",
              website: "Nettside",
              registrationNumber: {
                label: "Organisasjonsnummer",
                validationRule: "Sett landskoden foran organisasjonsnummeret ditt (e.g. <b>NO</b>123456789)"
              },
              printerEmail: {
                label: "Skriver epost",
                caption: "Denne e-postadressen vil bli brukt til å sende fraktseddel til skriver."
              }
            },
            dropdowns: {
              industry: {
                label: "Bransje",
                placeholder: "Velg"
              },
              country: {
                label: "Land",
                placeholder: "Velg"
              },
              baseCurrency: {
                label: "Grunnvaluta",
                placeholder: "Velg",
                // [+] Changed
                caption: "Dette valget er endelig og kan ikke endres når selskapet er opprettet."
              },
              language: {
                label: "Språk",
                placeholder: "Velg"
              },
              timezone: {
                label: "Tidssone",
                placeholder: "Velg"
              }
            },
            actions: {
              createNewCompanyButton: "Legg til nytt selskap",
              createNewCompanyButtonDropdown: "Opprett ny",
              selectCompaniesDropdown: "Velg selskap"
            },
            // [+] Changed
            responses: {
              creation: {
                success: "Selskapet er opprettet!",
                error: "Det oppsto en feil under opprettelse av firmaet!"
              },
              update: {
                success: "Selskapet er oppdatert!",
                error: "Det oppsto en feil under oppdatering av selskapet!"
              },
              defaultUpdate: {
                error: "Kan ikke aktivere {{companyName}}!"
              },
              load: {
                error: "Kan ikke laste {{companyName}}!"
              }
            },
            buttons: {
              save: "Lagre",
              confirm: "Bekreft"
            }
          },
          address: {
            title: "Adresse",
            useThisAddressCheckbox: "Bruk denne adressen for levering",
            billingAddress: {
              heading: "Faktureringsadresse",
              fields: {
                name: "Navn",
                country: "Land",
                street: "Gatenavn",
                street2: "Adresselinje 2",
                zipCode: "Postnummer",
                city: "Poststed",
                email: "Epost",
                phone: "Telefonnummer",
                contactName: "Kontaktperson"
              }
            },
            deleteAddressButton: "Slett",
            modals: {
              deletion: {
                title: "Bekreft sletting",
                hintText: "Er du sikker på at du vil slette adressen?",
                cancelButton: "Avbryt",
                deleteButton: "Slett"
              }
            },
            deliveryAddress: {
              heading: "Leveringsadresse",
              fields: {
                name: "Navn",
                country: "Land",
                street: "Gatenavn",
                street2: "Adresselinje 2",
                zipCode: "Postnummer",
                city: "Poststed",
                email: "Epost",
                phone: "Telefonnummer",
                contactName: "Kontaktperson"
              },
              // [+] Changed
              checkboxes: {
                useAsPrimary: "Bruk som primær leveringsadresse"
              }
            },
            addNewDeliveryAddressButton: "Legg til ny leveringsadresse",
            // [+] Changed
            responses: {
              update: {
                success: "Adressene er oppdatert!",
                error: "Det oppsto en feil under oppdatering av selskapet!"
              }
            },
            buttons: {
              previous: "Tilbake",
              next: "Lagre",
              delete: "Slett"
            }
          },
          employees: {
            title: "Ansatte",
            table: {
              columns: [
                "ID Number",
                "Navn",
                "Jobbtittel",
                "Epost"
              ],
              buttons: {
                add: "Legg til ansatt"
              }
            },
            modals: {
              mutation: {
                codeAlreadyExists: "ID er allerede brukt!",
                creationHeading: "Opprett ny ansatt",
                fields: {
                  code: {
                    label: "ID nummer"
                  },
                  name: {
                    label: "Navn"
                  },
                  jobTitle: {
                    label: "Jobb tittel"
                  },
                  email: {
                    label: "Epost"
                  },
                  phone: {
                    label: "Telefon"
                  }
                },
                dropdowns: {
                  language: {
                    label: "Språk",
                    placeholder: "Velg"
                  }
                },
                responses: {
                  creation: {
                    success: "Ansatt er opprettet!",
                    duplicate: "Ansatt med dette ansattnummeret finnes allerede!",
                    error: "Det oppsto en feil under opprettelse av en ansatt!"
                  },
                  update: {
                    success: "Ansatt har blitt oppdatert!",
                    error: "Det oppsto en feil under oppdatering av den ansatte!"
                  }
                },
                buttons: {
                  save: "Lagre"
                }
              },
              deletion: {
                heading: "Bekreft sletting",
                subheading: "Er du sikker på at du vil slette den ansatte?",
                buttons: {
                  cancel: "Avbryt",
                  delete: "Slett"
                },
                responses: {
                  success: "Ansatt er slettet!",
                  error: "Det oppsto en feil under sletting av ansatt!"
                }
              }
            }
          },
          users: {
            title: "Brukere",
            heading: "Brukere",
            table: {
              columns: {
                fullName: "Fullt navn",
                role: "Rolle",
                status: "Status",
                lastLogin: "Siste pålogging"
              },
              buttons: {
                invite: "Inviter bruker"
              },
              userStatus: {
                active: "Aktiv",
                suspended: "Suspendert"
              },
              neverLoggedIn: "Aldri"
            },
            filters: {
              title: "Filter",
              fields: {
                status: {
                  label: "Status",
                  placeholder: "Velg status"
                },
                roles: {
                  label: "Roller",
                  placeholder: "Velg roller"
                }
              }
            },
            modals: {
              mutation: {
                creationHeading: "Inviter bruker",
                fields: {
                  firstName: {
                    label: "Fornavn",
                    placeholder: "Skriv fornavn"
                  },
                  lastName: {
                    label: "Etternavn",
                    placeholder: "Skriv etternavn"
                  },
                  email: {
                    label: "Epost",
                    placeholder: "Skriv epost"
                  },
                  password: {
                    label: "Passord",
                    placeholder: "Endre brukerens passord om nødvendig",
                    placeholderNew: "Skriv inn passordet til den nye kontoen"
                  }
                },
                dropdowns: {
                  role: {
                    label: "Rolle",
                    placeholder: "Velg rolle"
                  }
                },
                responses: {
                  passwordLength: "Passordet må være minst 8 tegn langt!",
                  invite: {
                    success: "Brukeren er invitert!",
                    error: "Det oppsto en feil under invitasjon av brukeren!",
                    noPassword: "Passord kreves!"
                  },
                  update: {
                    success: "Brukeren er oppdatert!",
                    error: "Det oppsto en feil under oppdatering av brukeren!"
                  }
                },
                buttons: {
                  invite: "Inviter",
                  save: "Lagre"
                }
              },
              deletion: {
                heading: "Bekreft sletting",
                subheading: "Er du sikker på at du vil slette brukeren",
                buttons: {
                  cancel: "Angre",
                  delete: "Slett"
                },
                responses: {
                  success: "Brukeren er slettet!",
                  error: "Det oppstod en feil under sletting av brukeren!"
                }
              },
              suspension: {
                heading: "Suspendere bruker?",
                subheading: "Er du sikker på at du vil suspendere brukeren",
                buttons: {
                  cancel: "Angre",
                  suspend: "Suspender"
                },
                responses: {
                  success: "Brukeren er suspendert!",
                  error: "Det oppstod en feil under suspendering av brukeren!"
                }
              },
              activation: {
                heading: "Aktiver bruker",
                subheading: "Er du sikker på at du vil aktivere brukeren",
                buttons: {
                  cancel: "Angre",
                  activate: "Aktiver"
                },
                responses: {
                  success: "Brukeren er aktivert!",
                  error: "Det oppstod en feil under aktivering av bruker!"
                }
              }
            }
          },
          roles: {
            title: "Roller",
            heading: "Roller",
            table: {
              columns: {
                name: "Navn",
                users: {
                  label: "Brukere",
                  prompt_one: "Se {{count}} bruker",
                  prompt_other: "Se {{count}} brukere"
                },
                actions: "Handlinger"
              },
              yourRole: "Din rolle",
              immutableTooltip: "Denne rollen ble opprettet av systemet og kan ikke endres.",
              actions: {
                edit: "Rediger",
                delete: "Slett",
                assignUser: "Tildel bruker",
                copy: "Kopier"
              },
              buttons: {
                add: "Opprett rolle"
              }
            },
            creation: {
              heading: "Opprett ny rolle",
              responses: {
                success: "Rollen er opprettet!",
                error: "Det oppsto en feil under oppretting av rollen!"
              }
            },
            editing: {
              responses: {
                success: "Rollen er oppdatert!",
                error: "Det oppsto en feil under oppdatering av rollen!"
              }
            },
            mutation: {
              fields: {
                roleName: {
                  label: "Navn",
                  placeholder: "Skriv inn rollenavn"
                },
                roleDescription: {
                  label: "Beskrivelse",
                  placeholder: "Skriv inn rollebeskrivelse"
                }
              },
              sections: {
                permissions: "Tillatelser"
              },
              collapseGroups: {
                orders: "Ordre",
                inventory: "Lager"
              },
              accessDenied: "Tilgang nektet",
              dependsOn: "Påkrevd",
              buttons: {
                save: "Lagre"
              }
            },
            modals: {
              deletion: {
                heading: "Bekreft sletting",
                subheading_one: "Når <badge>{{roleName}}</badge> slettes, vil {{usersCount}} bruker miste rollen sin.",
                subheading_other: "Når <badge>{{roleName}}</badge> slettes, vil {{usersCount}} brukere miste rollene sine.",
                subheading_prompt: "Vennligst velg en erstatningsrolle for eksisterende brukere.",
                fields: {
                  role_replacement: {
                    label: "Erstatningsrolle",
                    placeholder: "Velg rolle"
                  }
                },
                buttons: {
                  cancel: "Angre",
                  delete: "Slett"
                },
                responses: {
                  success: "Rollen er slettet!",
                  error: "Det oppsto en feil under sletting av rollen!"
                }
              },
              roleAssignment: {
                heading: "Tildel rolle",
                subheading: "Velg brukerne du vil tildele rollen <badge>{{roleName}}</badge>",
                fields: {
                  users: {
                    label: "Velg brukere til rollen",
                    placeholder: "Velg brukere"
                  }
                },
                buttons: {
                  cancel: "Angre",
                  confirm: "Bekreft"
                },
                responses: {
                  success: "Rollen er tildelt!"
                }
              },
              copying: {
                heading: "Kopier rolle",
                subheading: "Angi navn på den nye rollen og velg firmaet der du vil kopiere rollen <badge>{{roleName}}</badge>.",
                fields: {
                  name: {
                    label: "Navn",
                    placeholder: "Skriv inn rollenavn",
                    copy: "Kopier"
                  },
                  description: {
                    label: "Beskrivelse",
                    placeholder: "Skriv inn rollebeskrivelse"
                  },
                  company: {
                    label: "Copy role to",
                    placeholder: "Velg firma",
                    currentCompany: "current company"
                  }
                },
                buttons: {
                  cancel: "Angre",
                  confirm: "Copy"
                },
                responses: {
                  success: "Rollen er kopiert!"
                }
              }
            }
          },
          billing: {
            contactEmailDetails: {
              title: "Kontakt epost",
              accountEmail: "Send til min epostkonto",
              alternativeEmail: {
                title: "Send til en alternativ epostadresse",
                placeholder: "Skriv inn alternativ epostadresse"
              }
            },
            modals: {
              addNewPaymentDetails: {
                title: "Legg til ny betaling",
                fields: {
                  cardNumber: "Kortnummer",
                  expirationDate: "Utløpsdato",
                  CVCCode: "CVC/CVV",
                  cardholderName: "Kortholders navn"
                },
                addCard: "Legg til kort"
              }
            },
            cardDetails: {
              title: "Kortdetaljer",
              addNewPayment: "Legg til ny betaling"
            },
            paymentHistory: {
              title: "Betalingshistorikk",
              columns: [
                "Faktura",
                "PO",
                "Beløp",
                "Dato",
                "Status",
                "Handling"
              ],
              status: {
                paid: "Betalt"
              }
            }
          },
          notifications: {
            title: "Varsler",
            columns: [
              "Seksjon",
              "Handling",
              "Muliggjør"
            ],
            sections: {
              purchaseOrder: {
                title: "Bestilling",
                actions: {
                  placed: "Plassert",
                  completed: "Fullført",
                  cancelled: "Avbrutt"
                }
              },
              salesOrder: {
                title: "Salgsordre",
                actions: {
                  placed: "Plassert",
                  completed: "Fullført",
                  cancelled: "Avbrutt"
                }
              },
              shipment: {
                title: "Forsendelse",
                actions: {
                  shipped: "Sendes",
                  delivered: "Levert"
                }
              },
              receive: {
                title: "Motta",
                actions: {
                  inProgress: "I prosess",
                  received: "Mottatt"
                }
              }
            }
          }
        },
        // [+] Changed
        responses: {
          success: "Firmainformasjonen er oppdatert!",
          error: "Noe gikk galt. Vennligst prøv igjen senere.",
          activeChange: "Active company changed to"
        }
      },
      defaults: {
        heading: "Standardinnstillinger",
        settings: {
          reservations: {
            label: "Aktiver reservasjoner",
            description: "Reserver lager for spesifikke ordre og forhindre plukk av andre ordre før den reserverte ordren er fullført."
          }
        },
        buttons: {
          save: "Lagre"
        },
        responses: {
          success: "Standardinnstillinger er oppdatert!"
        }
      },
      locations: {
        table: {
          columns: {
            locationName: "Lokasjonsnavn",
            country: "Land",
            city: "By",
            sections: "Seksjoner",
            projects: "Prosjekter",
            actions: "Handling"
          }
        },
        // [+] Changed
        subtable: {
          rowHints: {
            name: "Seksjonsnavn",
            code: "Seksjons-ID",
            sector: "Sector",
            row: "Row",
            shelfHeight: "Shelf name"
          }
        },
        createEditLocation: {
          location: {
            fields: {
              locationName: {
                label: "Lokasjonsnavn"
              },
              country: {
                label: "Land",
                placeholder: "Velg land"
              },
              city: {
                label: "Poststed"
              },
              street: {
                label: "Gatenavn"
              },
              zipCode: {
                label: "Postnummer"
              },
              phoneNumber: {
                label: "Telefonnummer"
              },
              contactName: {
                label: "Kontaktnavn"
              },
              email: {
                label: "Epost"
              },
              options: {
                label: "Valg",
                sectionsOption: "Seksjoner",
                sectionsOptionDisabledHint: "Fjern alle seksjoner individuelt for å deaktivere dette valget"
              }
            }
          },
          sections: {
            title: "Seksjoner",
            fields: {
              name: {
                label: "Seksjonsnavn"
              },
              sector: {
                label: "Sektor"
              },
              // [+] Changed
              row: {
                label: "Row"
              },
              shelfHeight: {
                label: "Hyllehøyde"
              }
            },
            nothingFound: "Finner ingen seksjoner",
            button: "Legg til ny seksjon",
          }
        },
        createLocation: {
          heading: "Opprett ny lokasjon",
          button: "Opprett lokasjon",
          responses: {
            success: "Lokasjonen ble opprettet!",
            error: "En feil oppstod ved opprettelse av lokasjon!"
          }
        },
        editLocation: {
          button: "Lagre endringer",
          responses: {
            success: "Lokasjon ble oppdatert!",
            error: "En feil oppstod ved oppdatering av lokasjon!"
          }
        },
        // [+] Changed
        integrations: {
          powerOffice: {
            projects: {
              label: "Prosjekt",
              placeholder: "Velg prosjekt(er)"
            }
          },
          tripletex: {
            projects: {
              label: "Prosjekt",
              placeholder: "Velg prosjekt(er)",
              types: {
                closed: "Lukket"
              }
            }
          }
        },
        modals: {
          filter: {
            fields: {
              country: {
                label: "Land",
                placeholder: "Velg"
              },
              sections: {
                label: "Seksjoner"
              }
            }
          },
          confirmDelete: {
            label: "Bekreft sletting",
            hint: "Er du sikker på at du vil slette",
            sectionDeletionItem: "seksjon",
            cancelButton: "Avbryt",
            deleteButton: "Slett",
            responses: {
              location: {
                success: "Seksjon ble slettet!",
                error: "En feil oppstod ved sletting av seksjon!"
              }
            }
          }
        }
      },
      myAccount: {
        tabs: {
          profile: {
            title: "Profil",
            fields: {
              firstName: "Fornavn",
              lastName: "Etternavn",
              email: "Epost",
              phone: "Telefonnummer"
            },
            dropdowns: {
              country: {
                label: "Land",
                placeholder: "Velg"
              },
              language: {
                label: "Språk",
                placeholder: "Velg"
              }
            },
            // [+] Changed
            password: {
              title: "Passord",
              fields: {
                currentPassword: "Nåværende passord",
                newPassword: "Nytt passord",
                confirmPassword: "Bekreft passord"
              }
            },
            responses: {
              noChanges: "Ingen endringer oppdaget!",
              user: {
                success: "Brukeren er oppdatert!",
                error: "Det oppstod en feil under oppdatering av bruker!"
              },
              // [+] Changed
              password: {
                success: "Passordet er oppdatert!",
                notMatchError: "Passordene samsvarer ikke!",
                sameError: "Nytt passord kan ikke være likt det gamle!",
                incorrectError: "Feil nåværende passord!"
              }
            },
            save: "Lagre"
          },
          billing: {
            title: "Fakturering",
            contactEmailDetails: {
              title: "Kontakt epost",
              accountEmail: "Send til min konto epost",
              alternativeEmail: {
                title: "Send til en alternativ epostadresse",
                placeholder: "Skriv inn alternativ epostadresse"
              }
            },
            cardDetails: {
              title: "Kortdetaljer",
              addNewPayment: "Legg til ny betaling"
            },
            paymentHistory: {
              title: "Betalingshistorikk",
              columns: [
                "Faktura",
                "PO",
                "Beløp",
                "Dato",
                "Status",
                "Handling"
              ],
              status: {
                paid: "Betalt"
              }
            }
          },
          subscriptions: {
            title: "Abonnement",
            startPackage: {
              title: "Startpakke",
              setupAccount: "Opprett Suppli-konto",
              setupIntegrations: "Sett opp integrasjoner",
              software: "Suppli programvare",
              coaching: "3 timers nettbasert opplæring i bruk av Suppli",
              price: "Kr 15 000",
              buyButton: "Kjøp nå",
            },
            license: {
              title: "Lisens",
              premium: {
                title: "Premium",
                price: "Kr 990",
                timing: "Måned pr bruker",
              },
              warehouseAndScanning: {
                title: "Lager – og skanning av produkter",
                price: "Kr 490",
                timing: "Måned pr bruker",
              },
              accounting: {
                title: "Regnskap",
                price: "Kr 290",
                timing: "Måned pr bruker",
              },
              businessPackage1: {
                title: "Bedriftspakke 1",
                price: "Kr 4990",
                timing: "Måned",
              },
              businessPackage2: {
                title: "Bedriftspakke 2",
                price: "Kr 9990",
                timing: "Måned",
              },
            },
            support: {
              title: "Brukerstøtte",
              bronze: {
                title: "Bronse",
                price: "Kr 999",
                timing: "Måned",
              },
              silver: {
                title: "Sølv",
                price: "Kr 1499",
                timing: "Måned",
              },
              gold: {
                title: "Gull",
                price: "Kr 1499",
                timing: "Måned",
              },
            },
            latestPayment: {
              title: "Siste betaling",
              nextPayment: "Neste betaling",
              payNow: "Betal nå",
              paymentDate: "Betalingsdato",
              typeOfPlan: "Type plan",
              paymentMethod: "Betalingsmetode",
              totalPayment: "Full betaling",
            },
            // [+] Changed
            responses: {
              creation: {
                success: "Språk opprettet!",
                duplicate: "Dette språket er allerede valgt for selskapet.",
                error: "Noe gikk galt!"
              },
              update: {
                success: "Språk oppdatert!",
                error: "Noe gikk galt!"
              }
            },
            buttons: {
              save: "Lagre"
            }
          },
          deletion: {
            heading: "Bekreft sletting",
            subheading: "Du kan ikke angre når slettingen er fullført.",
            buttons: {
              cancel: "Angre",
              delete: "Slett"
            },
            responses: {
              success: "Språk er slettet!",
              error: "Det oppsto en feil under sletting av språket!"
            }
          }
        }
      },
      // [+] Changed
      currencies: {
        heading: "Valutaer",
        table: {
          columns: ["Navn", "Symbol", "Valutakurs"],
          buttons: {
            add: "Legg til valuta"
          },
          baseCurrency: "Base",
          tooltips: {
            unpin: "Lås opp og tilbakestill valutakurs",
            save: "Lagre og lås valutakurs",
          },
        },

        responses: {
          currencyRate: {
            update: {
              error: "Kan ikke oppdatere valutakurs!"
            }
          },
        },

        modals: {
          mutation: {
            creationHeading: "Legg til ny valuta",

            fields: {
              symbol: {
                label: "Symbol"
              }
            },

            dropdowns: {
              type: {
                label: "Navn",
                placeholder: "Velg"
              }
            },

            responses: {
              creation: {
                success: "Valuta er lagt til!",
                error: "Kan ikke legge til valutaen"
              },
            },

            buttons: {
              save: "Lagre"
            }
          },

          deletion: {
            heading: "Bekreft sletting",
            subheading: "Du kan ikke angre når slettingen er fullført",

            buttons: {
              cancel: "Angre",
              delete: "Slett"
            },

            responses: {
              success: "Valuta er slettet!",
              error: "Det oppstod en feil under sletting av valuta!"
            }
          }
        }
      },

      paymentTerms: {
        heading: "Betalingsbetingelser",
        table: {
          columns: ["Navn", "Dager", "Type"],
          buttons: {
            add: "Legg til betalingsbetingelser",
          }
        },

        modals: {
          mutation: {
            creationHeading: "Legg til nye betalingsbetingelser",

            fields: {
              name: {
                label: "Navn",
              },
              days: {
                label: "Dager",
              }
            },

            dropdowns: {
              type: {
                label: "Type",
                placeholder: "Velg"
              }
            },

            responses: {
              creation: {
                success: "Betalingsbetingelse opprettet!",
                error: "Noe gikk galt!"
              },
              update: {
                success: "Betalingsbetingelse oppdatert!",
                error: "Noe gikk galt!"
              }
            },

            buttons: {
              save: "Lagre"
            }
          },
          deletion: {
            heading: "Bekreft sletting",
            subheading: "Du kan ikke angre når slettingen er fullført",
            buttons: {
              cancel: "Angre",
              delete: "Slett"
            },
            responses: {
              success: "Betalingsbetingelse er slettet!",
              error: "Det oppstod en feil under sletting av leveringsbetingelse!"
            }
          }
        },

        paymentTypes: {
          daysAfter: "Dager etter",
          prepayment: "Forskuddsbetaling",
        },
      },

      deliveryTerms: {
        heading: "Leveringsbetingelser",
        table: {
          columns: ["Navn", "Beskrivelse"],
          buttons: {
            add: "Legg til leveringsbetingelse",
          }
        },

        modals: {
          mutation: {
            creationHeading: "Legg til ny leveringsbetingelse",

            fields: {
              name: {
                label: "Navn",
              },
              description: {
                label: "Beskrivelse",
              }
            },

            responses: {
              creation: {
                success: "Leveringsbetingelse opprettet!",
                error: "Noe gikk galt!"
              },
              update: {
                success: "Leveringsbetingelse oppdatert!",
                error: "Noe gikk galt!"
              }
            },

            buttons: {
              save: "Lagre"
            }
          },
          deletion: {
            heading: "Bekreft sletting",
            subheading: "Du kan ikke angre når slettingen er fullført",
            buttons: {
              cancel: "Angre",
              delete: "Slett"
            },
            responses: {
              success: "Leveringsbetingelse er slettet!",
              error: "Det oppstod en feil under sletting av leveringsbetingelse!"
            }
          }
        },
      },

      packaging: {
        heading: "Emballasje",
        table: {
          columns: ['Navn', "ID", "Bredde (cm)", "Lengde (cm)", "Høyde (cm)"],
          buttons: {
            add: "Legg til ny forsendelsesboks",
          }
        },
        modals: {
          mutation: {
            creationHeading: "Legg til forsendelsesboks",

            fields: {
              name: {
                label: "Navn",
              },
              code: {
                label: "ID",
              },
              width: {
                label: "Bredde (cm)",
              },
              length: {
                label: "Lengde (cm)",
              },
              height: {
                label: "Høyde (cm)",
              }
            },

            responses: {
              creation: {
                success: "Forsendelsesboks opprettet!",
                error: "Noe gikk galt!"
              },
              update: {
                success: "Forsendelsesboks oppdatert!",
                error: "Noe gikk galt!"
              },
              duplicateCode: "Denne ID-en er allerede i bruk."
            },

            buttons: {
              create: "Opprett",
              save: "Lagre"
            }
          },
          deletion: {
            heading: "Bekreft sletting",
            subheading: "Du kan ikke angre når slettingen er fullført",
            buttons: {
              cancel: "Angre",
              delete: "Slett"
            },
            responses: {
              success: "Forsendelsesboks er slettet!",
              error: "Det oppstod en feil under sletting av forsendelsesboks!"
            }
          }
        }
      },

      units : {
        heading: "Enheter",
        table: {
          columns: ['Enhetens navn', "Symbol", "Egendefinert navn"],
          buttons: {
            add: "Legg til ny enhet",
          }
        },
        modals : {
          mutation: {
            creationHeading: "Legg til enhet",
            editHeading: "Rediger enhet",
            fields : {
              name: {
                label: "Enhet"
              },
              symbol: {
                label: "Enhetssymbol"
              },
              customName : {
                label: "Egendefinert enhetsnavn (valgfritt)"
              }
            },
            responses: {
              creation: {
                success: "Enhet opprettet!",
                error: "Noe gikk galt!"
              },
              update: {
                success: "Enhet oppdatert!",
                error: "Noe gikk galt!"
              },

            },

            buttons: {
              save: "Lagre"
            }
          },

          deletion: {
            heading: "Bekreft sletting",
            subheading: "Du kan ikke angre når slettingen er fullført",
            buttons: {
              cancel: "Angre",
              delete: "Slett"
            },
            responses: {
              success: "Enhet er slettet!",
              error: "Det oppstod en feil under sletting av enhet!"
            }
          }
        }
      },
      languages: {
        heading: "Språk",
        table: {
          columns: ["Navn", "Språkkode"],
          buttons: {
            add: "Legg til nytt språk",
          }
        },
        modals: {
          mutation: {
            creationHeading: "Legg til nytt språk",

            fields: {
              name: {
                label: "Navn",
              },
              code: {
                label: "Språkkode",
              }
            },
            dropdowns: {
              language: {
                label: "Språk *",
                placeholder: "Velg"
              }
            },
            responses: {
              creation: {
                success: "Språk opprettet!",
                duplicate: "Dette språket er allerede valgt for selskapet.",
                error: "Noe gikk galt!"
              },
              update: {
                success: "Språk oppdatert!",
                error: "Noe gikk galt!"
              }
            },

            buttons: {
              save: "Lagre"
            }
          },
          deletion: {
            heading: "Bekreft sletting",
            subheading: "Du kan ikke angre når slettingen er fullført.",
            buttons: {
              cancel: "Angre",
              delete: "Slett"
            },
            responses: {
              success: "Språk er slettet!",
              error: "An error occurred while deleting the language!"
            }
          }
        }
      },
      taxRates: {
        heading: "MVA-satser",
        table: {
          columns: [
            "Avgiftsnavn",
            "Avgiftssats (%)",
            "Utgående MVA",
            "Inngående MVA"
          ],
          buttons: {
            add: "Legg til avgiftssats"
          }
        },
        modals: {
          mutation: {
            creationHeading: "Legg til ny avgiftssats",
            fields: {
              name: {
                label: "Navn"
              },
              rate: {
                label: "Sats"
              },
              salesTax: {
                label: "Utgående MVA"
              },
              purchaseTax: {
                label: "Inngående MVA"
              }
            },
            responses: {
              creation: {
                success: "Avgiftssats opprettet!",
                error: "Noe gikk galt!"
              },
              update: {
                success: "Avgiftssats oppdatert!",
                error: "Noe gikk galt!"
              }
            },
            buttons: {
              save: "Lagre"
            }
          },
          deletion: {
            heading: "Bekreft sletting",
            subheading: "Du kan ikke angre når slettingen er fullført",
            buttons: {
              cancel: "Angre",
              delete: "Slett"
            },
            responses: {
              success: "Avgiftssats er slettet!",
              error: "Det oppstod en feil under sletting av avgiftssats!"
            }
          }
        }
      },
      categories: {
        heading: "Kategorier",
        table: {
          columns: [
            "ID",
            "Navn",
            "Type"
          ],
          isService: "Tjeneste",
          buttons: {
            add: "Legg til ny kategori"
          }
        },
        modals: {
          mutation: {
            creationHeading: "Legg til ny kategori",
            fields: {
              number: {
                label: "ID"
              },
              name: {
                label: "Navn"
              },
              isService: {
                label: "Tjeneste"
              }
            },
            integrations: {
              poweroffice: {
                heading: "PowerOffice GO",
                salesAccount: {
                  label: "Salgskonto",
                  placeholder: "Velg"
                }
              },
              twentyFourSevenOffice: {
                salesAccount: {
                  label: "Salgskonto",
                  placeholder: "Velg"
                }
              }
            },
            responses: {
              creation: {
                success: "Kategori opprettet!",
                error: "Noe gikk galt!"
              },
              update: {
                success: "Kategori oppdatert!",
                error: "Noe gikk galt!"
              }
            },
            buttons: {
              create: "Opprett",
              save: "Lagre"
            }
          },
          deletion: {
            heading: "Bekreft sletting",
            subheading: "Du kan ikke angre når slettingen er fullført",
            buttons: {
              cancel: "Angre",
              delete: "Slett"
            },
            responses: {
              success: "Kategori er slettet!",
              error: "Det oppstod en feil under sletting av kategori!"
            }
          }
        }
      },
      customFields: {
        main: {
          heading: "Egendefinerte felt",
          table: {
            disabled: "Deaktivert",
            buttons: {
              add: "Legg til nytt egendefinert felt"
            },
            nothingFound: "Ingen egendefinerte felt er lagt til ennå"
          }
        },
        modals: {
          mutation: {
            creationHeading: "Nytt egendefinert felt",
            fields: {
              module: {
                label: "Modul",
                placeholder: "Velg modul"
              },
              label: {
                label: "Etikett",
                placeholder: "Skriv inn etikett"
              },
              placeholder: {
                label: "Plassholder",
                placeholder: "Skriv inn plassholder"
              }
            },
            buttons: {
              save: "Lagre"
            },
            responses: {
              creation: {
                success: "Egendefinert felt er opprettet!"
              },
              update: {
                success: "Egendefinert felt er oppdatert!"
              }
            }
          },
          // [+] Changed
          toggling: {
            enable: {
              heading: "Aktiver egendefinert felt",
              subheading: "Er du sikker på at du vil aktivere \"<b>{{field}}</b>\"?",
              buttons: {
                cancel: "Angre",
                action: "Aktiver"
              },
              responses: {
                success: "Egendefinert felt er aktivert!"
              }
            },
            disable: {
              heading: "Deaktiver egendefinert felt",
              subheading: "Er du sikker på at du vil deaktivere \"<b>{{field}}</b>\"?",
              tip: "Deaktiverte felt beholdes på gamle poster, men vises ikke på nye.",
              buttons: {
                cancel: "Angre",
                action: "Deaktiver"
              },
              responses: {
                success: "Egendefinert felt er deaktivert!"
              }
            }
          },
          deletion: {
            heading: "Slett egendefinert felt",
            subheading: "Er du sikker på at du vil slette \"<b>{{field}}</b>\"?",
            tip: "Slettede felt blir fjernet fra alle poster.",
            buttons: {
              cancel: "Angre",
              action: "Slett"
            },
            responses: {
              success: "Egendefinert felt er slettet!"
            }
          }
        },
        modules: {
          product: "Produkter",
          purchase_order: "Purchase orders"
        },
        inject: {
          title: "Custom fields",
          activateCustomFields: "Aktiver custom fields"
        }
      }
    },
    integrations: {
      thirdParty: {
        heading: "Integrasjoner",
        badge: "Integrert: {{count}} av {{limit}}",
        modals: {
          creation: {
            creationHeading: "Tilknytt {{type}} kontoen din",
            responses: {
              success: "Integrasjon konfigurert!",
              error: "Kunne ikke koble til integrasjonen!"
            },
            buttons: {
              save: "Tilknytt"
            }
          },
          mutation: {
            mutationHeading: "Rediger integrasjon",
            responses: {
              creation: {
                success: "Integrasjon konfigurert!",
                error: "Noe gikk galt."
              },
              update: {
                success: "Integrasjon er oppdatert!",
                error: "Noe gikk galt!"
              }
            },
            buttons: {
              save: "Oppdater"
            }
          },
          disable: {
            heading: "Deaktiver {{integrationName}}-kontoen din",
            subheading: "Er du sikker på at du vil deaktivere kontoen <strong>{{integrationName}}</strong>?",
            warning: "Dette vil fjerne alle data fra kontoen din",
            buttons: {
              cancel: "Angre",
              disable: "Deaktiver"
            },
            responses: {
              success: "Integrasjon er deaktivert!",
              error: "Det oppstod en feil under deaktivering av integrasjonen!"
            }
          }
        },
        integrationTypes: {
          all: "Alle",
          accounting: "Regnskap",
          shipping: "Frakt",
          integratedApps: "Integrerte apper"
        },
        buttons: {
          integrationsLimitReached: "Du har nådd grensen for tilkoblede integrasjoner. Deaktiver en av de eksisterende integrasjonene for å koble til en ny.",
          integrate: "Koble til",
          import: "Importer",
          disable: "Deaktiver",
          settings: "Innstillinger",
          export: "Eksporter"
        },
        integrations: {
          woocommerce: {
            integrationModal: {
              heading: "WooCommerce",
              connection: {
                consumer_key: {
                  label: "Forbrukernøkkel",
                  placeholder: "Skriv inn forbrukernøkkel"
                },
                consumer_secret: {
                  label: "Forbrukerhemmelighet",
                  placeholder: "Skriv inn forbrukerhemmelighet"
                },
                shop_url: {
                  label: "Butikk-URL",
                  placeholder: "Skriv inn butikk-URL"
                },
              },
              product_settings: {
                heading: "Produkter",
                product_categories: {
                  label: "Produktkategorier",
                  placeholder: "Velg produktkategorier"
                },
                product_for_fees: {
                  label: "Produkt for gebyrer",
                  placeholder: "Velg produkt for gebyrer",
                },
                product_for_shipping: {
                  label: "Produkt for frakt",
                  placeholder: "Velg produkt for frakt"
                },
                stock_status: {
                  label: "Lagerstatus for synkroniserte beholdninger",
                  value: "total lagerverdi per produkt"
                },
                sync_location: {
                  label: "Synkroniser kun lager fra spesifikk lokasjon",
                  value: "alle"
                },
                sales_price_from: {
                  label: "Hent salgspris fra",
                  value: "Salgspris"
                }
              },
              customers: {
                heading: "Kunder",
                standard_payment_term: {
                  label: "Standard betalingsbetingelse",
                  placeholder: "Velg standard betalingsbetingelse"
                },
                standard_customer_group: {
                  label: "Standard kundegruppe",
                  placeholder: "Velg standard kundegruppe"
                },
                standard_tax: {
                  label: "Standard mva",
                  placeholder: "Velg standard mva"
                }
              },
              orders: {
                heading: "Ordre",
                status_new_orders: {
                  label: "Status på nye ordre opprettet i Suppli",
                },
                status_woocommerce_sync: {
                  label: "Status på WooCommerce-ordre som skal synkroniseres",
                  value: "behandles"
                },
                mark_completed_orders: {
                  label: "Merk ordre som «Fullført» i WooCommerce når den er ferdig plukket i Suppli"
                }
              },
              buttons: {
                activate: "Aktiver integrasjon"
              }
            }
          },
          shopify: {
            integrationModal: {
              heading: "Shopify",
              connection: {
                shop_url: {
                  label: "Butikk-URL",
                  placeholder: "Skriv inn butikk-URL"
                },
                client_id: {
                  label: "Klient-ID",
                  placeholder: "Skriv inn klient-ID"
                },
                client_secret: {
                  label: "Klienthemmelighet",
                  placeholder: "Skriv inn klienthemmelighet"
                },
              },
              buttons: {
                connect: "Koble til"
              }
            }
          }
        }
      }
    }
  },
  purchaseOrder: {
    main: {
      table: {
        columns: [
          "Ordrenummer",
          "Leverandør",
          "Dato",
          "Motta",
          "Totalt",
          "Dokumenter",
          "Handling"
        ]
      },
      subtable: {
        columns: [
          "Varenummer",
          "Produkt",
          "Antall",
          "Enhetspris",
          "Rabatt",
          "MVA",
          "Totalt"
        ],
        groupBadges: [
          "Collection",
          "BOM"
        ]
      },
      actions: {
        receive: "Motta",
        details: "Se detaljer",
        duplicate: "Dupliser",
        edit: "Endre",
        // [+] Changed
        editingNotAllowed: "Redigering er ikke tillatt når ordren er mottatt",
        delete: "Slett",
        deletingNotAllowed: "Sletting er ikke tillatt når bestillingen er mottatt",
        cancel: "Kanseller ordre",
        cancellationNotAllowed: {
          alreadyCancelled: "Bestillingen er allerede kansellert",
          alreadyCompleted: "Bestillingen er allerede kansellert"
        }
      },
      filters: {
        supplier: {
          label: "Leverandør"
        },
        category: {
          label: "Kategori"
        },
        product: {
          label: "Produkt"
        },
        receive: {
          label: "Motta",
          options: {
            received: "Mottatt",
            inProgress: "Under behandling",
            notReceived: "Ikke mottatt"
          }
        },
        deliveryDate: {
          label: "Leveringsdato",
          placeholder: "Velg periode"
        },
        status: {
          label: "Status"
        }
      }
    },
    // [+] Changed
    language: {
      label: "Velg dokumentspråk",
      placeholder: "Velg språk"
    },
    general: {
      categories: {
        shipping: "Fraktkostnad",
        invoices: "Fakturaer"
      },
      fields: {
        preferredDeliveryDate: {
          label: "Ønsket leveringsdato",
          placeholder: "Velg dato"
        },
        purchaseDate: {
          label: "Innkjøpsdato",
          placeholder: "Velg dato"
        },
        // [+] Changed
        shippingCost: {
          label: "Fraktkostnad",
          checkboxes: {
            splitByProducts: "Del på produkter"
          }
        },
        // [+] Changed
        billingAddress: {
          label: "Fakturaadresse",
          placeholderWhenUndefined: "Ingen fakturaadresse lagt til",
          buttons: {
            create: "Opprett"
          },
          checkboxes: {
            useForDelivery: "Bruk denne adressen for levering"
          },
          modalCreation: {
            heading: "Opprett fakturaadresse",
            fields: {
              name: "Navn",
              street: "Gateadresse",
              street2: "Gateadresse 2",
              zipCode: "Postnummer",
              city: "Poststed",
              email: "E-post",
              phone: "Telefon",
              contactName: "Kontaktperson"
            },
            dropdowns: {
              country: {
                label: "Land",
                placeholder: "Velg land"
              }
            },
            buttons: {
              save: "Lagre"
            },
            responses: {
              success: "Fakturaadresse er opprettet!",
              error: "Det oppstod en feil under opprettelse av fakturaadresse..."
            }
          }
        },
        exchangeRate: {
          label: "Valutakurs",
          placeholder: "Skriv inn valutakurs",
          lockWarning: "Kursen er låst og gjenspeiler ikke gjeldende valutakurser."
        }
      },
      accentFields: {
        status: {
          label: "Status",
          variants: {
            notReceived: "Ikke mottatt",
            inProgress: "Under behandling",
            received: "Mottatt"
          }
        },
        orderDate: {
          label: "Ordredato"
        },
        receivedAt: {
          label: "Mottatt den",
          variants: {
            notReceived: "Ikke mottatt",
            partiallyReceived: "Delvis mottatt",
            received: "Mottatt"
          }
        }
      },
      // [+] Changed
      dropdowns: {
        supplier: {
          label: "Leverandør",
          placeholder: "Velg leverandør",
          buttons: {
            create: "Opprett"
          }
        },
        ourReference: {
          label: "Vår referanse",
          placeholder: "Velg referanse",
          buttons: {
            create: "Opprett"
          }
        },
        theirReference: {
          label: "Deres referanse",
          placeholder: "Velg referanse",
          buttons: {
            create: "Opprett"
          },
          blockedBeforeSupplier: "Velg leverandør først"
        },
        paymentTerms: {
          label: "Betalingsbetingelser",
          placeholder: "Velg betalingsbetingelse"
        },
        deliveryTerms: {
          label: "Leveringsbetingelser",
          placeholder: "Velg leveringsbetingelse"
        },
        documentLanguage: {
          label: "Dokuementspråk",
          placeholder: "Velg språk"
        },
        currency: {
          label: "Valuta",
          placeholder: "Velg valuta",
          base: "Base"
        },
        deliveryMethod: {
          label: "Leveringsmetode",
          placeholder: "Velg leveringsmetode"
        },
        deliveryAddress: {
          label: "Leveringsadresse",
          placeholder: "Velg leveringsadresse",
          // [+] Changed
          buttons: {
            create: "Opprett"
          },
          creationModal: {
            heading: "Opprett leveringsadresse",
            fields: {
              name: "Navn",
              street: "Gateadresse",
              street2: "Gateadresse 2",
              zipCode: "Postnummer",
              city: "Poststed",
              email: "E-post",
              contactName: "Kontaktperson",
              phone: "Telefon"
            },
            dropdowns: {
              country: {
                label: "Land",
                placeholder: "Velg land"
              }
            },
            buttons: {
              save: "Lagre"
            },
            responses: {
              success: "Leveringsadresse er opprettet!",
              error: "Noe gikk galt!"
            }
          }
        }
      },
      orders: {
        heading: "Produkter",
        // [+] Changed
        columns: [
          "Varenummer",
          "Produkt",
          "Antall",
          "Enhetspris",
          "Rabatt",
          "MVA",
          "Totalt",
          "Handling"
        ],
        groups: {
          types: {
            collection: "Samling",
            bom: "BOM"
          },
          emptyBanner: "Denne samlingen er tom. Legg noen produkter her.."
        },
        tip: {
          minPurchaseQTY: "Valgt antall er mindre enn minste kjøpsantall"
        },
        buttons: {
          addProduct: "Legg til produkt",
          addCollection: "Legg til samling"
        },
        summary: {
          subtotal: "Subtotal",
          taxes: "MVA",
          shipping: "Fraktkostnad",
          total: "Totalt"
        },
        noProducts: "Ingen produkter",
        // [+] Changed
        modals: {
          createProduct: {
            heading: "Opprett nytt produkt",
            responses: {
              success: "Produkt er opprettet!",
              duplicate: "This product ID has already been taken.",
              error: "An error occurred while creating the product..."
            },
            fields: {
              productName: "Produktnavn",
              productCode: "ID",
              purchasePrice: "Innkjøpspris",
              sellingPrice: "Salgspris"
            },
            dropdowns: {
              category: {
                label: "Kategori",
                placeholder: "Velg kategori"
              },
              unit: {
                label: "Enhet",
                placeholder: "Velg enhet"
              },
              currency: {
                label: "Valuta",
                placeholder: "Velg valuta"
              }
            },
            buttons: {
              create: "Opprett"
            }
          },
          addCollection: {
            heading: "Legg til samling",
            fields: {
              collection: {
                label: "Samling",
                placeholder: "Velg"
              },
              quantity: {
                label: "Antall",
                placeholder: "Skriv inn antall"
              }
            },
            buttons: {
              add: "Legg til"
            },
            selector: {
              buttons: {
                showMore: "Vis mer",
                hideDetails: "Skjul detaljer"
              },
              headers: [
                "ID",
                "Navn",
                "Antall",
                "Enhetspris",
                "Totalpris"
              ]
            }
          },
          editGroup: {
            heading: "Rediger gruppe",
            fields: {
              name: {
                label: "Navn",
                placeholder: "Skriv inn navn"
              },
              comment: {
                label: "Kommentar",
                placeholder: "Skriv inn kommentar"
              }
            },
            buttons: {
              add: "Oppdater"
            },
            selector: {
              buttons: {
                showMore: "Vis mer",
                hideDetails: "Skjul detaljer"
              },
              headers: [
                "ID",
                "Navn",
                "Antall",
                "Enhetspris",
                "Totalpris"
              ]
            }
          }
        }
      },
      buttons: {
        create: "Opprett",
        save: "Lagre",
        sendToSupplier: "Send til leverandør"
      },
      toasts: {
        noProductsAdded: "Du må minst velge ett produkt!"
      },
      modals: {
        // [+] Changed
        createSupplier: {
          heading: "Opprett ny leverandør",
          categories: {
            address: "Adresse"
          },
          fields: {
            supplierName: "Supplier name",
            supplierCode: "Supplier ID",
            name: "Navn",
            street: "Gateadresse",
            street2: "Gateadresse 2",
            zipcode: "Postnummer",
            city: "Poststed",
            email: "Epost",
            phone: "Telefon"
          },
          dropdowns: {
            country: {
              label: "Land",
              placeholder: "Velg"
            }
          },
          responses: {
            success: "Leverandør er opprettet!",
            error: "Det oppsto en feil under opprettelse av leverandøren..."
          },
          buttons: {
            create: "Opprett"
          }
        },
        createOurReference: {
          heading: "Opprett ny «Vår referanse»",
          fields: {
            name: "Navn",
            code: "ID",
            jobTitle: "Jobbtittel",
            phone: "Telefon",
            email: "Epost"
          },
          dropdowns: {
            language: {
              label: "Språk",
              placeholder: "Velg språk"
            }
          },
          buttons: {
            create: "Opprett"
          },
          responses: {
            success: "«Vår referanse» er opprettet!",
            error: "Det oppsto en feil under oppretting av referansen vår..."
          }
        },
        createTheirReference: {
          heading: "Opprett ny «Deres referanse»",
          fields: {
            name: "Navn",
            phone: "Telefon",
            email: "Epost"
          },
          buttons: {
            create: "Opprett"
          },
          responses: {
            success: "«Deres referanse» er opprettet!",
            error: "Det oppsto en feil under oppretting av referansen deres..."
          }
        },
        receive: {
          heading: "Motta innkjøpsordre",
          subheading: [
            "Vennligst velg",
            "Delvis",
            "(tillater å velge hvilke produkter kan mottas)",
            "eller",
            "Hurtigmottak",
            "(motta alle produkter automatisk)"
          ],
          buttons: {
            partial: "Delvis motta",
            quick: "Hurtigmottak"
          },
          responses: {
            error: "En feil oppstod ved hurtigmottak!",
            success: "Innkjøpsordre er mottatt!"
          }
        },
        deletion: {
          heading: "Bekreft sletting",
          subheading: "Er du sikker på at du vil slette",
          purchaseOrderDeletionItem: "Innkjøpsordre",
          buttons: {
            cancel: "Avbryt",
            delete: "Slett"
          },
          responses: {
            error: "En feil oppstod ved sletting av innkjøpsordre!",
            success: "Innkjøpsordre er slettet!"
          }
          // [+] Changed
        },
        cancellation: {
          heading: "Kanseller inkjøpspordre",
          subheading: "Når denne bestillingen er kansellert, kan den ikke endres eller aktiveres på nytt",
          fields: {
            reason: {
              label: "Årsak",
              placeholder: "Skriv inn årsak til kansellering"
            }
          },
          buttons: {
            close: "Lukk",
            confirm: "Bekreft kansellering"
          },
          responses: {
            error: "Det oppsto en feil under forsøk på å kansellere salgsordren!",
            success: "Innkjøpsordren er kansellert!"
          }
        },
        addProduct: {
          heading: "Legg til produkt",
          fields: {
            product: {
              label: "Produkt",
              placeholder: "Velg produkt"
            },
            quantity: {
              label: "Antall",
              placeholder: "Skriv inn antall"
            },
            unitPrice: {
              label: "Enhetspris",
              placeholder: "Skriv inn enhetspris"
            },
            discount: {
              label: "Rabatt",
              placeholder: "Skriv inn rabatt"
            },
            tax: {
              label: "MVA",
              placeholder: "Skriv inn MVA-sats"
            }
          },
          bom: {
            label: "Velg som stykkliste",
            whatIsBOM: "Bill of Materials (BOM) er en liste over komponentene og mengdene av hver som trengs for å produsere et sluttprodukt. Du kan konfigurere dem i den tilhørende modulen.",
            table: {
              columns: [
                "Navn",
                "Totalpris"
              ],
              subtable: {
                columns: [
                  "Komponent navn",
                  "Antall",
                  "Innkjøpspris",
                  "Totalpris",
                  "På lager"
                ]
              },
              actions: {
                select: {
                  idle: "Velg",
                  selected: "Valgte"
                }
              }
            },
            validation: {
              noBOMSelected: "Velg minst én stykkliste!"
            }
          },
          addMore: "Legg til flere",
          buttons: {
            add: "Legg til",
            save: "Lagre"
          }
        },
        addInvoice: {
          heading: "Legg til ekstern faktura",
          date: {
            label: "Datoperiode",
            placeholder: "Datoperiode for å søke etter fakturaer"
          },
          externalInvoice: {
            label: "Ekstern faktura",
            placeholder: "Velg ekstern faktura",
            disabilityReason: "Velg datoperioden først"
          },
          buttons: {
            add: "Legg til"
          },
          responses: {
            error: "Det oppsto en feil under forsøk på å koble fakturaen!",
            success: "Fakturaen er koblet!"
          }
        },
        unlinkInvoice: {
          heading: "Fjern kobling til faktura",
          subheading: "Er du sikker på at du vil fjerne koblingen til fakturaen",
          buttons: {
            cancel: "Angre",
            unlink: "Fjern kobling"
          },
          responses: {
            error: "Det oppsto en feil under forsøk på å fjerne tilknytningen til fakturaen!",
            success: "Koblingen til fakturaen er fjernet!"
          }
        },
        setReadyForPayment: {
          heading: "Sett klar for betaling",
          subheading: "Er du sikker på at du vil sette fakturaen <invoice/> som «Klar for betaling»?",
          buttons: {
            cancel: "Angre",
            unlink: "Bekreft"
          },
          responses: {
            error: "Det oppstod en feil ved oppdatering av fakturastatus!",
            success: "Fakturaen er oppdatert!"
          }
        }
      },
      invoices: {
        heading: "Fakturaer",
        statuses: {
          pending: "Avventer",
          readyForPayment: "Klar for betaling"
        },
        noInvoices: "Ingen tilknyttede fakturaer",
        menu: {
          unlink: {
            label: "Fjern kobling"
          },
          readyForPayment: {
            label: "Klar til betaling",
            tooltip: "Suppli behandler dette <b>automatically</b>, men du kan merke din faktura manuelt som \"klar til betaling\" on nødvendig."
          }
        }
      }
    },
    mutations: {
      creation: {
        heading: "Ny innkjøpsordre",
        responses: {
          success: "Innkjøpsordre er opprettet!",
          error: "En feil oppstod oppretting av innkjøpsordre!"
        }
      },
      editing: {
        heading: "Innkjøp",
        notFoundText: "Du kan ikke redigere denne innkjøpsordren",
        responses: {
          success: "Innkjøpsordre ble oppdatert!",
          error: "Det oppstod en feil ved oppdatering av innkjøpsordre!"
        }
      },
      details: {
        heading: "Innkjøp",
        // [+] Changed
        receiptsSection: {
          heading: "Kvitteringer",
          noReceiptsFoundTooltip: "Denne ordren er ikke mottatt ennå",
          columns: [
            "Kvitterings ID",
            "Status",
            "Dato",
            "Medarbeider"
          ],
          receiveStatus: [
            "Delvis mottatt",
            "Fullført"
          ]
        },
        actions: {
          edit: "Rediger",
          editingNotAllowed: "Redigering er ikke tillatt når ordren er mottatt",
          delete: "Slett",
          deletingNotAllowed: "Deleting is not allowed when order is received",
          cancel: "Kanseller ordren",
          cancellationNotAllowed: {
            alreadyCancelled: "Ordren er allerede kansellert",
            alreadyCompleted: "Ordren er allerede fullført"
          }
        }
      }
    }
  },
  receive: {
    main: {
      table: {
        columns: [
          "Mottaks ID",
          "Innkjøpsordre",
          "Leverandør",
          "Dato",
          "Handling"
        ]
      },
      subtable: {
        columns: [
          "Produkt-ID",
          "Produkt",
          "Lokasjon",
          "Seksjon",
          "Antall"
        ]
      },
      filters: {
        supplier: {
          label: "Leverandør"
        },
        date: {
          label: "Dato",
          placeholder: "Velg periode"
        }
      }
    },
    general: {
      of_part: "av",
      modals: {
        deletion: {
          heading: "Bekreft sletting",
          subheading: "Er du sikker på at du vil slette",
          buttons: {
            cancel: "Angre",
            delete: "Slett"
          },
          responses: {
            error: "Det oppstod en feil ved forsøk på å slette varemottaket!",
            success: "Varemottak er slettet!"
          }
        }
      }
    },
    mutation: {
      headings: {
        creation: "Nytt varemottak"
      },
      fields: {
        supplier: {
          label: "Leverandør",
          placeholder: "Velg leverandør"
        },
        purchaseOrder: {
          label: "Innkjøpsordre",
          placeholder: "Velg innkjøpsordre",
          status: {
            completed: "Denne ordren er fullført",
            cancelled: "Denne ordren er kansellert"
          }
        },
        receiveDate: {
          label: "Mottaksdato"
        }
      },
      products: {
        heading: "Produkter",
        columns: [
          "ID",
          "Produkt",
          "Lokasjon",
          "Antall",
          "Handling"
        ],
        noProducts: "Ingen produkter ennå",
        receivedQuantityOf: "av",
        alreadyReceived: "Denne innkjøpsordren er allerede mottatt",
        buttons: {
          addSerialNumbers: "Legg til serienumre",
          addBatchNumbers: "Legg til batchnumre"
        },
        errors: {
          fillAllSerialNumbers: "Vennligst fyll ut alle serienumre!",
          fillAllBatchNumbers: "Vennligst fyll ut alle batchnumre!"
        }
      },
      alerts: {
        incompleteSerialNumbers: "Ufullstendige serienumre. Vennligst fyll ut alle serienumre.",
        incompleteBatchNumbers: "Ufullstendige batchnumre. Vennligst fyll ut alle batchnumre."
      },
      buttons: {
        save: "Lagre"
      },
      responses: {
        creation: {
          success: "Kvittering opprettet!",
          error: "Noe gikk galt..."
        }
      },
      groups: {
        modules: {
          collection: "Samling",
          bom: "BOM"
        }
      },
      validation: {
        receivedNoGreaterThanAvailable: "Mottatt mengde kan ikke overstige tilgjengelig mengde",
        receiveAtLeastOneProduct: "Du må motta minst én vare",
        serialNumbersFilledIncorrectly: "Serienumre er registrert feil",
        batchNumbersFilledIncorrectly: "Batchnumre er registrert feil",
      }
    },
    modals: {
      serialNumbers: {
        field: {
          placeholder: "Serienummer"
        },
        buttons: {
          attach: "Legg til",
          cancel: "Angre",
          addSerialNumber: "Legg til serienummer"
        },
        noProductsPicked: "Ingen produkter med serienumre valgt",
        validation: {
          serialsCannotBeGreaterThanReceivedQuantity: "Antall serienumre kan ikke overstige mottatt mengde",
          serialNumberDuplicate: "Dupliserte serienumre",
          serialNumberAlreadyExists: "Serienummeret er allerede i bruk"
        }
      },
      batchNumbers: {
        fields: {
          batchNumber: {
            placeholder: "Batchnummer"
          },
          expirationDate: {
            placeholder: "Utløpsdato"
          }
        },
        buttons: {
          attach: "Legg til",
          cancel: "Angre",
          addBatchNumber: "Legg til batchnummer"
        },
        noProductsPicked: "Ingen produkter med plukket batchnummer",
        validation: {
          batchesCannotBeGreaterThanReceivedQuantity: "Antall batchnummer kan ikke overstige plukket mengde",
        }
      }
    },
    details: {
      heading: "Motta",
      fields: {
        supplier: "Leverandør",
        purchaseOrder: "Innkjøpsordre",
        receiveDate: "Mottaksdato"
      },
      products: {
        heading: "Produkter",
        columns: [
          "ID",
          "Produkt",
          "Lokasjon",
          "Antall",
          "Handling"
        ],
        noProducts: "Ingen produkter ennå",
        modalReferences: {
          serialNumbers: "Serienumre",
          batchNumbers: "Batchnumre"
        }
      },
      groups: {
        modules: {
          collection: "Samling",
          bom: "BOM"
        }
      }
    }
  },
  sales: {
    orders: {
      main: {
        table: {
          columns: {
            orderId: "Ordrenummer",
            reference: "Referanse",
            customer: "Kunde",
            date: "Dato",
            total: "Totalt",
            actions: "Handling",
            project: "Prosjekt",
          },
          has_reservations: "Denne ordren har aktive produktreservasjoner",
        },
        subtable: {
          columns: [
            "Varenummer",
            "Produkt",
            "Antall",
            "Enhetspris",
            "Rabatt",
            "MVA",
            "Totalt"
          ],
          // [+] Changed
          groupBadges: [
            "samling"
          ]
        },
        warnings: {
          createPOFailed: "Kan ikke hente lagerverdier for ordrelinjer, standard bestilt antall.",
          createPOAllInStock: "Alle produkter er på lager, ingen innkjøpsordre vil bli opprettet."
        },
        actions: {
          addToPurchaseOrder: "Legg til i innkjøpsordre",
          details: "Se detaljer",
          duplicate: "Duplikat",
          edit: "Endre",
          editingNotAllowed: "Redigering er ikke tillatt når ordren er plukket",
          delete: "Slett",
          deletingNotAllowed: "Sletting er ikke tillatt når ordren er plukket",
          cancel: "Kanseller ordre",
          cancellationNotAllowed: {
            alreadyCancelled: "Bestillingen er allerede kansellert",
            alreadyCompleted: "Bestillingen er allerede fullført"
          },
          createPO: "Opprett innkjøpsordre",
          picking: "Opprett plukk",
          pickingNotAllowed: {
            offer: "Aktiver dette tilbudet før du starter plukking"
          }
        },
        filters: {
          customer: {
            label: "Kunder"
          },
          category: {
            label: "Kategori"
          },
          product: {
            label: "Produkt"
          },
          date: {
            label: "Dato",
            placeholder: "Velg dato"
          },
          shipped: {
            label: "Sendt",
            options: {
              shipped: "Sendt",
              ready: "Klar",
              notShipped: "Ikke sendt"
            }
          },
          invoiced: {
            label: "Fakturert",
            options: {
              invoiced: "Fakturert",
              notInvoiced: "Ikke fakturert"
            }
          },
          // [+] Changed
          status: {
            label: "Status"
          },
          reservations: {
            label: "Reservasjoner",
            options: {
              no_reservations: "Uten reservasjoner",
              has_reservations: "Med reservasjoner"
            }
          }
        }
      },
      general: {
        categories: {
        },
        fields: {
          preferredDeliveryDate: {
            label: "Ønsket leveringsdato",
            placeholder: "Velg dato"
          },
          orderDate: {
            label: "Ordredato",
            placeholder: "Velg dato"
          },
          reference: {
            label: "Referanse"
          },
          comment: {
            label: "Kommentar",
            placeholder: "Skriv inn kommentar",
            pdfVisibilityNote: "Synlig på alle relaterte genererte PDF-er, inkludert pakksedler."
          },
          billingAddress: {
            label: "Fakturaadresse",
            blockedBeforeCustomers: "Velg kunde først",
            // [+] Changed
            placeholderWhenUndefined: "Ingen fakturaadresse lagt til",
            checkboxes: {
              useForDelivery: "Bruk denne adressen for levering"
            },
            buttons: {
              create: "Opprett"
            },
            creationModal: {
              heading: "Opprett fakturaadresse",
              responses: {
                success: "Faktureringsadressen er opprettet!",
                error: "Noe gikk galt!"
              },
              fields: {
                name: "Navn",
                street: "Gateadresse",
                street2: "Gateadresse 2",
                zipcode: "Poststed",
                city: "Poststed",
                email: "Epost",
                phone: "Telefon"
              },
              dropdowns: {
                country: {
                  label: "Land",
                  placeholder: "Velg land"
                }
              },
              buttons: {
                create: "Opprett"
              }
            }
          }
        },
        accentFields: {
          deliveryStatus: {
            label: "Status",
            variants: {
              // [+] Changed
              not_shipped: "Ikke levert",
              partially_delivered: "Delvis levert",
              delivered: "Levert"
            }
          },
          orderDate: {
            label: "Ordredato"
          },
          deliveryDate: {
            label: "Leveringsdato"
          }
        },
        dropdowns: {
          customer: {
            label: "Kunde",
            placeholder: "Velg kunde",
            // [+] Changed
            buttons: {
              create: "Opprett"
            },
            creationModal: {
              heading: "Opprett ny kunde",
              responses: {
                success: "Kunde er opprettet!",
                error: "Det oppsto en feil under oppretting av kunden..."
              },
              subheading: "Fakturaadresse",
              fields: {
                customerName: "Kundenavn",
                customerCode: "KundeID",
                name: "Navn",
                street: "Gateadresse",
                street2: "Gateadresse 2",
                zipcode: "Postnummer",
                city: "Poststed",
                email: "Epost",
                phone: "Telefon"
              },
              dropdowns: {
                country: {
                  label: "Land",
                  placeholder: "Velg land"
                }
              },
              checkboxes: {
                isCompany: "Firma",
                isPerson: "Person"
              },
              buttons: {
                create: "Opprett"
              }
            }
          },
          ourReference: {
            label: "Vår referanse",
            placeholder: "Velg referanse",
            buttons: {
              create: "Opprett"
            },
            creationModal: {
              heading: "Opprett ny «Vår referanse»",
              fields: {
                name: "Navn",
                code: "ID",
                jobTitle: "Jobb tittel",
                phone: "Telefon",
                email: "Epost"
              },
              dropdowns: {
                language: {
                  label: "Språk",
                  placeholder: "Velg språk"
                }
              },
              buttons: {
                create: "Opprett"
              },
              responses: {
                success: "«Vår referanse» er opprettet!",
                error: "Det oppsto en feil under oppretting av referansen vår..."
              }
            }
          },
          // [+] Changed
          theirReference: {
            label: "Deres referanse",
            placeholder: "Velg eller skriv referanse",
            blockedBeforeCustomers: "Velg kunde først",
            buttons: {
              create: "Opprett"
            },
            creationModal: {
              heading: "Opprett ny «Deres referanse»",
              fields: {
                name: "Navn",
                phone: "Telefon",
                email: "Epost"
              },
              buttons: {
                create: "Opprett"
              },
              responses: {
                success: "«Deres referanse» er opprettet!",
                error: "Det oppsto en feil under oppretting av referansen deres..."
              }
            }
          },
          paymentTerms: {
            label: "Betalingsbetingelser",
            placeholder: "Velg betalingsbetingelse"
          },
          deliveryTerms: {
            label: "Leveringsbetingelser",
            placeholder: "Velg leveringsbetingelse"
          },
          // [+] Changed
          documentLanguage: {
            label: "Dokumentspråk",
            placeholder: "Velg språk"
          },
          currency: {
            label: "Valuta",
            placeholder: "Velg valuta"
          },
          deliveryMethod: {
            label: "Leveringsmetode",
            placeholder: "Velg leveringsmetode"
          },
          deliveryAddress: {
            label: "Leveringsadresse",
            placeholder: "Velg adresse",
            // [+] Changed
            blockedBeforeCustomers: "Velg kunde først",
            creationModal: {
              heading: "Opprett leveringsadresse",
              fields: {
                name: "Navn",
                street: "Gateadresse",
                street2: "Gateadresse 2",
                zipcode: "Postnummer",
                city: "Poststed",
                email: "Epost",
                contactName: "Kontaktperson",
                phone: "Telefon"
              },
              dropdowns: {
                country: {
                  label: "Land",
                  placeholder: "Velg land"
                }
              },
              buttons: {
                create: "Opprett"
              },
              responses: {
                success: "Leveringsadresse er opprettet!",
                error: "Noe gikk galt!"
              }
            }
          },
          status: {
            label: "Status",
            placeholder: "Velg status"
          }
        },
        orders: {
          heading: "Produkter",
          // [+] Changed
          lowStockWarning: "Lagerbeholdningen er for lav for enkelte produkter. Et forslag til bestilling vil bli tilbudt for å fullføre bestillingen..",
          tip: {
            minSaleQTY: "Valgt antall er mindre enn minste salgsantall"
          },
          columns: [
            "Varenummer",
            "Produkt",
            "Antall",
            "Enhetspris",
            "Rabatt",
            "MVA",
            "Totalt",
            "Handling"
          ],
          groups: {
            types: {
              collection: "Samling",
              bom: "BOM"
            },
            emptyBanner: "Denne samlingen er tom. Legg noen produkter her.."
          },
          buttons: {
            addProduct: "Legg til produkt",
            addCollection: "Legg til samling"
          },
          nameCell: {
            originalName: "Originalt navn: <b>{{name}}</b>"
          },
          quantityCell: {
            lowStockWarning: "{{inStock}} på lager"
          },
          summary: {
            subtotal: "Subtotal",
            taxes: "MVA",
            total: "Totalt"
          },
          noProducts: "Ingen produkter",
          // [+] Changed
          modals: {
            addProduct: {
              heading: "Legg til produkt",
              cards: {
                titles: {
                  pricesAndDiscounts: "Priser og rabatter",
                  generalCustomerDiscount: "Generell kunderabatt",
                  customerGroup: "Kundegrupper"
                },
                fields: {
                  discount: {
                    label: "Rabatt"
                  },
                  minQuantity: {
                    label: "Min.antall",
                    tooltip: "Minimum produktantall for å bruke denne rabatten er {{minQuantity}}"
                  },
                  salePrice: {
                    label: "Enhetspris"
                  },
                  calculatedPrice: {
                    label: "Kalkulert pris"
                  },
                  validFrom: {
                    label: "Gyldig fra",
                    tooltip: "Denne rabatten vil være tilgjengelig fra {{validFrom}}"
                  },
                  validTo: {
                    label: "Gyldig til",
                    noExpiration: "Ingen utløpsdato"
                  }
                }
              },
              fields: {
                product: {
                  label: "Produkt",
                  placeholder: "Velg",
                  alternative_name: {
                    tooltip: "Angi alternativt navn",
                    placeholder: "Skriv inn alternativt navn"
                  }
                },
                quantity: {
                  label: "Antall",
                  placeholder: "Skriv inn antall"
                },
                unitPrice: {
                  label: "Enhetspris",
                  placeholder: "Skriv inn enhetspris"
                },
                discount: {
                  label: "Discount",
                  placeholder: "Skriv inn rabatt"
                },
                tax: {
                  label: "MVA",
                  placeholder: "Skriv inn avgift"
                },
                comment: {
                  label: "Kommentar",
                  placeholder: "Skriv inn kommentar",
                  whatIsComment: "Spesifiser her eventuell tilleggsinformasjon, som kun vil være synlig for lagerarbeideren"
                }
              },
              bom: {
                label: "Velg som stykkliste",
                whatIsBOM: "Bill of Materials (BOM) er en liste over komponentene og mengdene av hver som trengs for å produsere et sluttprodukt. Du kan konfigurere dem i den tilhørende modulen.",
                table: {
                  columns: [
                    "Navn",
                    "Totalpris"
                  ],
                  subtable: {
                    columns: [
                      "Komponentnavn",
                      "Antall",
                      "Salgspris",
                      "Totalpris",
                      "På lager"
                    ]
                  },
                  actions: {
                    select: {
                      idle: "Velg",
                      selected: "Valgte"
                    }
                  }
                },
                validation: {
                  noBOMSelected: "Velg minst én stykkliste!"
                }
              },
              addMore: "Legg til flere",
              responses: {
                errorExtendedLoad: "Kan ikke laste inn ytterligere produktinformasjon!"
              },
              buttons: {
                add: "Legg til",
                save: "Lagre"
              }
            },
            addCollection: {
              heading: "Legg til samling",
              fields: {
                collection: {
                  label: "Samling",
                  placeholder: "Velg"
                },
                quantity: {
                  label: "Antall",
                  placeholder: "Skriv inn antall"
                }
              },
              buttons: {
                add: "Legg til"
              },
              selector: {
                buttons: {
                  showMore: "Vis mer",
                  hideDetails: "Skjul detaljer"
                },
                headers: [
                  "ID",
                  "Navn",
                  "Antall",
                  "Enhetspris",
                  "Totalpris"
                ]
              }
            },
            editGroup: {
              heading: "Rediger samling",
              fields: {
                name: {
                  label: "Navn",
                  placeholder: "Skriv inn navn"
                },
                comment: {
                  label: "Kommentar",
                  placeholder: "Skriv inn kommentar"
                }
              },
              buttons: {
                add: "Oppdater"
              },
              selector: {
                buttons: {
                  showMore: "Vis mer",
                  hideDetails: "Skjul detaljer"
                },
                headers: [
                  "ID",
                  "Navn",
                  "Antall",
                  "Enhetspris",
                  "Totalpris"
                ]
              }
            }
          }
        },
        pickingsSection: {
          heading: "Plukk",
          noPickingsFoundTooltip: "Denne ordren er ikke plukket ennå",
          columns: [
            "Plukk-ID",
            "Status",
            "Fakturering",
            "Leveringsstatus",
            "Dato",
            "Medarbeider"
          ],
          pickingStatus: [
            "Delvis plukket",
            "Plukket"
          ],
          invoicing: {
            status: [
              "Ikke fakturert",
              "Fakturert"
            ]
          },
          delivery: {
            status: {
              not_shipped: "Ikke sendt",
              in_progress: "In progress",
              delivered: "Delivered"
            }
          }
        },
        buttons: {
          create: "Opprett",
          save: "Lagre",
          saveOrder: "Lagre ordre",
          saveAsOffer: "Lagre som tilbud",
          saveAsOfferDescription: "Kan ikke plukkes før det er konvertert til en aktiv ordre",
          saveAndStartPickingOrder: "Lagre og start plukkingen",
          openSaveOptions: "Åpne alternative lagringsvalg",
          sendToSupplier: "Send til kunde"
        },
        saveAndPick: {
          label: "Start plukkingen umiddelbart etter lagring",
        },
        toasts: {
          noProductsAdded: "Du må velge minst ett produkt!"
        },
        modals: {
          deletion: {
            heading: "Bekreft sletting",
            subheading: "Er du sikker på at du vil slette",
            orderDeletionItem: "Ordre",
            buttons: {
              cancel: "Avbryt",
              delete: "Slett"
            },
            responses: {
              error: "En feil oppstod ved sletting av salgsordre!",
              success: "Salgsordre er slettet!"
            }
          },
          // [+] Changed
          cancellation: {
            heading: "Kanseller salgsordre",
            subheading: "Når denne bestillingen er kansellert, kan den ikke endres eller aktiveres på nytt",
            fields: {
              reason: {
                label: "Årsak",
                placeholder: "Skriv inn årsak til kansellering"
              }
            },
            buttons: {
              close: "Lukk",
              confirm: "Bekreft kansellering"
            },
            responses: {
              error: "Det oppsto en feil under forsøk på å kansellere salgsordren!",
              success: "Salgsordre er kansellert!"
            }
          },
          offerActivation: {
            heading: "Aktiver tilbud",
            fields: {
              customer: "Kunde",
              paymentTerms: "Betalingsbetingelser",
              deliveryTerms: "Leveringsbetingelser"
            },
            buttons: {
              cancel: "Avbryt",
              activate: "Aktiver"
            },
            responses: {
              success: "Tilbudet ble aktivert!",
              error: "Det oppsto en feil under aktivering av tilbudet!"
            }
          }
        },
        reservations: {
          heading: "Produktreservasjoner",
          expirationDate: "Utløpsdato"
        }
      },
      // [+] Changed
      language: {
        label: "Velg dokumentspråk",
        placeholder: "Velg språk"
      },
      integrations: {
        fields: {
          project: {
            label: "Prosjekt",
            placeholder: "Velg prosjekt"
          }
        }
      },
      mutations: {
        creation: {
          heading: "Ny salgsordre",
          responses: {
            success: "Salgsordre er opprettet!",
            error: "Kunne ikke opprette salgsordre!"
          },
          // [+] Changed
          lowStockOffer: {
            heading: "Vil du opprette en innkjøpsordre??",
            subheading: "Noen av produktene dine er for lite på lager til å oppfylle salgsordren. <br/> Vil du opprette en bestillingsordre for å fullføre salgsordren??",
            columns: [
              "ID",
              "Produktnavn",
              "Bestilt antall",
              "Antall på lager"
            ],
            buttons: {
              create: "Opprett",
              cancel: "Angre"
            },
            modals: {
              refill: {
                heading: "Konfigurer påfylling ved lav lagerbeholdning",
                smartRefill: {
                  label: "Bruk smart påfylling av komponenter",
                  tooltip: "Beregn automatisk det nødvendige antallet komponenter basert på gjeldende lagerbeholdning."
                },
                mode: {
                  lowStock: {
                    label: "Lav lagerbeholdning",
                    tooltip: "Etterfyll kun produkter som er lav lagerbeholdning."
                  },
                  resupply: {
                    label: "Resupply",
                    tooltip: "Etterfyll produkter basert på bestilt antall."
                  }
                },
                selector: {
                  keywords: [
                    "Fylle på",
                    "as"
                  ],
                  refillTypeOptions: {
                    product: "Produkt",
                    bom: "BOM"
                  }
                },
                bom: {
                  table: {
                    columns: [
                      "Navn",
                      "Pris for en",
                      "Totalpris"
                    ],
                    subtable: {
                      columns: [
                        "Komponentnavn",
                        "Antall",
                        "Innkjøpspris",
                        "Totalpris",
                        "På lager"
                      ]
                    },
                    actions: {
                      select: {
                        idle: "Velg",
                        selected: "Valgte"
                      }
                    }
                  }
                },
                buttons: {
                  cancel: "Angre",
                  refill: "Bestille"
                },
                validation: {
                  noBOMSelected: "Velg én stykkliste!"
                },
                responses: {
                  unableToLoadProductsData: "Kan ikke laste inn produktdata!"
                }
              }
            }
          }
        },
        editing: {
          heading: "Salgsordre",
          notFoundText: "Du kan ikke redigere denne salgsordren",
          responses: {
            success: "Salgsordre ble oppdatert!",
            error: "Det oppstod en feil ved oppdatering av salgsordre!"
          }
        },
        // [+] Changed
        details: {
          heading: "Salgsordre",
          actions: {
            edit: "Rediger",
            editingNotAllowed: "Redigering er ikke tillatt når ordren er plukket",
            delete: "Slett",
            deletingNotAllowed: "Sletting er ikke tillatt når ordren er plukket",
            cancel: "Kanseller ordren",
            cancellationNotAllowed: {
              alreadyCancelled: "Bestillingen er allerede kansellert",
              alreadyCompleted: "Bestillingen er allerede fullført"
            },
            pickingNotAllowed: {
              offer: "Aktiver dette tilbudet før du starter plukking"
            }
          },
          offerBanner: {
            inactive: "Dette tilbudet er ikke aktivt ennå",
            hint: "Aktiver for å tillate plukking og levering",
            buttons: {
              activate: "Aktiver tilbud"
            },
            responses: {
              success: "Tilbudet ble aktivert!",
              error: "Det oppsto en feil under aktivering av tilbudet!"
            }
          }
        }
      }
    },
    // [+] Changed
    picking: {
      main: {
        table: {
          columns: [
            "Plukk-ID",
            "Salgsordre ID",
            "Kunde",
            "Fakturert",
            "Leveringsstatus",
            "Dato",
            "Handling"
          ]
        },
        subtable: {
          columns: [
            "Produkt-ID",
            "Produkt",
            "Bestilt antall",
            "Plukket antall"
          ]
        },
        invoicing: {
          status: [
            "Ikke fakturert",
            "Fakturert"
          ]
        },
        delivery: {
          status: {
            not_shipped: [
              "Ikke sendt",
              "Produkter pakket"
            ],
            in_progress: "Pågår",
            delivered: "Levert"
          }
        },
        actions: {
          startPicking: "Start plukking",
          continuePicking: "Fortsett plukking",
          viewDetails: "View details"
        },
        filters: {
          customer: {
            label: "Kunde",
            placeholder: "Velg kunde"
          },
          date: {
            label: "Dato",
            placeholder: "Velg periode"
          },
          invoicing: {
            label: "Faktureringsstatus"
          }
        },
        status: [
          "Ny",
          "Delvis plukket",
          "Plukket"
        ],
        responses: {
          deliveryNoteFetchError: "Kan ikke laste ned en pakkseddel!"
        }
      },
      mutation: {
        heading: "Nytt plukkoppdrag",
        responses: {
          success: "Plukklisten er oppdatert!",
          error: "Noe gikk galt..."
        },
        validation: {
          pickedQuantityCannotBeGreaterThanInStock: "Plukket mengde kan ikke overstige lagerbeholdningen",
          pickedQuantityCannotBeGreaterThanAvailableQuantity: "Plukket mengde kan ikke overstige tilgjengelig mengde",
          pickedQuantityIsRequiredWithLocation: "Plukket mengde må angis når en lokasjon er valgt",
          outgoingLocationIsRequired: "Utgående lokasjon må angis når en mengde er plukket",
          pickAtLeastOneProduct: "Du må plukke minst én vare",
          totalPickedCannotExceed: "Total plukket mengde kan ikke overstige varens gjenværende mengde",
          serialsFilledIncorrectly: "Serienumre er registrert feil",
          batchNumbersFilledIncorrectly: "Batchnumre er registrert feil",
        }
      },
      modals: {
        packaging: {
          heading: "Emballasje",
          dropdowns: {
            shippingBox: {
              label: "Forsendelsesboks",
              placeholder: "Velg forsendelsesboks",
              actionButton: "Opprett",
              temporaryPackageTooltip: "Midlertidig pakke som slettes etter at plukkingen er fullført"
            }
          },
          fields: {
            weight: {
              label: "Vekt",
              units: "kg"
            }
          },
          buttons: {
            save: "Lagre"
          }
        },
        packagingCreation: {
          heading: "Pakkeoppretting",
          fields: {
            name: {
              label: "Navn",
              placeholder: "Skriv inn pakkenavn..."
            },
            width: {
              label: "Bredde",
              placeholder: "Skriv inn bredde..."
            },
            height: {
              label: "Høyde",
              placeholder: "Skriv inn høyde..."
            },
            length: {
              label: "Lengde",
              placeholder: "Skriv inn lengde..."
            },
            shouldPersist: {
              label: "Ta vare på denne pakken til senere plukkinger"
            }
          },
          dimensionUnit: "cm",
          responses: {
            success: "Pakke er opprettet!"
          },
          buttons: {
            add: "Legg til",
            saveAndAdd: "Lagre og legg til"
          }
        },
        serialNumbers: {
          field: {
            placeholder: "Serienummer"
          },
          buttons: {
            attach: "Legg til",
            cancel: "Angre",
            addSerialNumber: "Legg til serienummer"
          },
          validation: {
            serialNumberDuplicate: "Dupliser serienumre",
          },
          noProductsPicked: "Ingen produkter med serienumre valgt"
        },
        batchNumbers: {
          fields: {
            batchNumber: {
              placeholder: "Batchnummer"
            },
            expirationDate: {
              placeholder: "Utløpsdato"
            }
          },
          buttons: {
            attach: "Legg til",
            cancel: "Angre",
            addBatchNumber: "Legg til batchnummer"
          },
          validation: {
            batchNumberDuplicate: "Kopier batchnummer",
            cannotBeGreaterThanPickedQuantity: "Antall batchnummer kan ikke overstige plukket mengde"
          },
          noProductsPicked: "Ingen produkter med plukket batchnummer"
        },
        locations: {
          columns: [
            "Utgående lokasjon",
            "Antall"
          ],
          buttons: {
            close: "Lukk"
          }
        }
      },
      details: {
        heading: "Plukkliste"
      },
      general: {
        fields: {
          customer: {
            label: "Kunde",
            placeholder: "Velg kunde"
          },
          saleOrder: {
            label: "Salgsordre",
            placeholder: "Velg ordre",
            status: {
              offer: "Denne ordren er fortsatt et tilbud",
              completed: "Denne ordren er fullført",
              cancelled: "Denne ordren er kansellert"
            }
          },
          invoicing: {
            label: "Faktureringsstatus"
          },
          delivery: {
            label: "Leveringsstatus"
          },
          date: {
            label: "Dato"
          },
          pickingDate: {
            label: "Dato for plukking",
            placeholder: "Velg dato"
          },
          packaging: {
            label: "Emballasje",
            placeholder: "Velg forsendelsesboks",
            validation: {
              shipmondoRequirement: "Minst én pakke er påkrevd for Shipmondo"
            },
            temporaryPackage: {
              label: "Midlertidig pakke"
            },
            notSelected: "Ingen emballasje valgt",
            noWeightWarning: "Noen av pakkene dine mangler vekt. Vennligst legg den til for å aktivere forsendelsesintegrasjoner.",
            units: {
              one: "kg",
              few: "kg",
              many: "kg"
            }
          }
        },
        invoicing: {
          status: [
            "Ikke fakturert",
            "Fakturert"
          ]
        },
        isService: "Tjeneste",
        delivery: {
          status: {
            not_shipped: [
              "Ikke sendt",
              "Produkter pakket"
            ],
            in_progress: "Pågår",
            delivered: "Levert"
          }
        },
        products: {
          heading: "Produkter",
          columns: [
            "Produkt ID",
            "Produkt",
            "Bestilt antall",
            "Outgoing location",
            "Antall",
            "Handling",
            "Plukket antall",
            "Status",
            "Locations"
          ],
          showLocations: "vis",
          noProducts: "Ingen produkter ennå",
          quantityPartialPickingWarningTooltip: "Delvis plukk: {{picked}} av {{remaining}}",
          quantityLeftPostfix: "mangler",
          quantityPickedPostfix: "plukket",
          weightUnit: "kg",
          summary: {
            ordered: "Totalt antall bestilt",
            picked: "Totalt antall plukket"
          },
          pickStatus: [
            "Ny",
            "Delvis",
            "Fullført"
          ],
          buttons: {
            addSerialNumbers: "Legg til serienumre",
            addBatchNumbers: "Legg til batchnumre"
          },
          modalReferences: {
            serialNumbers: "Serienumre",
            batchNumbers: "Batchnumre"
          },
          errors: {
            fillAllSerialNumbers: "Vennligst fyll ut alle serienumre!",
            fillAllBatchNumbers: "Vennligst fyll ut alle batchnumre!"
          }
        },
        responses: {
          unableToLoadExtendedSO: "Kan ikke laste inn informasjon om salgsordre!"
        },
        buttons: {
          addOutgoingLocation: "Legg til lokasjon",
          save: "Lagre"
        },
        groups: {
          modules: {
            collection: "Samling",
            bom: "BOM"
          }
        }
      },
      shipmondo: {
        heading: "Shipmondo",
        integrationBadge: "Integrasjon",
        shipmondoNotUsed: "Shipmondo brukes ikke for denne ordren",
        fields: {
          country: {
            label: "Avsenderland",
            placeholder: "Velg land"
          },
          destinationCountry: {
            label: "Destinasjonsland",
            placeholder: "Velg land",
            selectSaleOrderFirst: "Velg salgsordre først"
          },
          carrier: {
            label: "Transportør",
            placeholder: "Velg transportør"
          },
          product: {
            label: "Produkt",
            placeholder: "Velg produkt",
            selectCarrierFirst: "Velg transportør først"
          },
          service: {
            label: "Tjeneste",
            placeholder: "Velg tjeneste",
            selectProductFirst: "Velg produkt først"
          }
        },
        noServices: "Ingen tjenester valgt"
      },
      tripletex: {
        warnings: {
          autoInvoicing: {
            notEnabled: "Automatisk fakturering i Tripletex er deaktivert for alle bestillinger. For å aktivere den på nytt, gå til integrasjonsdelen under innstillingene i Suppli."
          }
        }
      }
    }
  },
  general: {
    search: {
      placeholder: "Søk"
    },
    filter: {
      title: "Filter"
    },
    export: {
      title: "Eksport"
    },
    import: {
      title: "Import",
      panelButton: "Import",
      action: "Velg fil",
      // [+] Changed
      invalidFileType: "Filen må være av filtypen: xlsx, xls, csv."
    },
    creation: {
      title: "Legg til ny"
    },
    dropdownAll: "Alle",
    nothingFound: {
      table: "INGEN RESULTAT",
      record: "INGEN TREFF",
      dropdown: "Ingen treff"
    },
    // [+] Changed
    accessDenied: {
      main: "Tilgang avvist",
      visitRoles: "Se siden <redirect>roller</redirect> for å gi tilgang"
    },
    inDevelopment: "I utvikling",
    components: {
      tax: {
        dropdown: {
          label: "MVA-sats",
          placeholder: "Velg MVA-sats",
          buttons: {
            create: "Opprett"
          }
        },
        modals: {
          creation: {
            heading: "Opprett ny MVA-sats",
            taxName: {
              label: "Navn"
            },
            taxRate: {
              label: "MVA-sats"
            },
            buttons: {
              create: "Opprett og lagre"
            },
            responses: {
              success: "MVA-sats ble opprettet!",
              error: "En feil oppstod ved opprettelse av MVA-sats..."
            }
          }
        }
      },
      country: {
        dropdown: {
          label: "Land",
          placeholder: "Velg land"
        }
      },
      currency: {
        dropdown: {
          label: "Valuta",
          placeholder: "Velg valuta",
          buttons: {
            create: "Opprett"
          }
        },
        modals: {
          creation: {
            heading: "Opprett ny valuta",
            currencyCode: {
              label: "Valutakode",
              placeholder: "Velg valutakode"
            },
            symbol: {
              label: "Symbol"
            },
            responses: {
              success: "Valuta ble opprettet",
              error: "En feil oppstod ved opprettelse av valuta"
            },
            buttons: {
              create: "Opprett og lagre"
            }
          }
        }
      },
      paymentTerms: {
        dropdown: {
          label: "Betalingsbetingelser",
          placeholder: "Velg betalingsbetingelse"
        }
      },
      reservedQuantityIndicator: {
        tooltip: "Reservert: {{count}}"
      },
      categoryCommandDropdown: {
        heading: {
          single: "Velg kategori",
          multiple: "Velg kategorier"
        },
        noResults: "Ingen kategorier funnet",
        serviceBadge: "Tjeneste"
      },
      command: {
        search: {
          placeholder: "Søk",
        },
        noResults: "Ingenting funnet",
        keys: {
          navigate: "Naviger",
          esc: "Esc",
          close: "Lukk",
          drill: "Neste nivå",
          select: "Velg",
          back: "Tilbake"
        }
      }
    },
    // [+] Changed
    integrations: {
      badge: "Integrasjon"
    },
    modals: {
      export: {
        heading: "Eksporter",
        fields: {
          records: {
            label: "Poster",
            options: {
              all: "Alle",
              selected: "Valgte"
            }
          },
          columns: {
            label: "Kolonner"
          },
          email: {
            label: "Epost",
            placeholder: "Skriv inn epostadresse for å sende eksportfilen"
          },
          amount: {
            label: "Eksporter",
            options: {
              all: "Alle",
              first: "Første",
              selected: "Valgte"
            }
          }
        },
        concurrencyWarning: "Du kan bare kjøre én eksport om gangen",
        filterInheritanceWarning: "Gjeldende filtre og sortering vil bli brukt",
        exportIsAlreadyInProgressAlert: "En annen eksport pågår allerede. Vent til den er ferdig..",
        buttons: {
          export: "Eksporter"
        }
      }
    },
    orders: {
      statuses: {
        base: {
          offer: "Tilbud",
          new: "Ny",
          in_progress: "Pågår",
          cancelled: "Kansellert",
          completed: "Fullført"
        }
      }
    },
    validation: {
      global: {
        noSpaces: "Mellomrom er ikke tillatt",
        nonNumeric: "Tall er ikke tillatt",
        domainName: "Ugyldig domenenavn",
        email: "Ugyldig epost",
        alphaNumeric: "Feltet må inneholde minst en bokstav",
        minCharacters: "Må være {{min}} eller flere tegn",
        numericRequired: "Feltet må inneholde minst ett tall",
        imageFormats: "Støttede bildeformater: jpeg, jpg, png, webp",
        fileSize: "Maks filstørrelse er {{size}}",
        required: "Påkrevd",
        positive: "Må være lik eller større enn 0",
        maxDecimalPrecision: "Max presisjon er {{maxPrecision}} sifre",
        invalidDate: "Ugyldig dato",
        boundedBy: "Må være mellom {{min}} og {{max}}",
        invalidRegistrationNumber: "Ugyldig format for organisasjonsnummer",
        compareDate: "Sluttdatoen må være senere enn startdatoen",
        noProductsAdded: "Du må legge til minst ett produkt",
        invalidPhoneNumber: "Ugyldig telefonnummer",
        invalidPhoneNumberLength: "Telefonnummeret er for kort",
        invalidPreferredDeliveryDate: "Foretrukket leveringsdato må være på eller etter bestillingsdatoen"
      },
      custom: {
        code: {
          unique: "Koden er allerede brukt"
        }
      }
    },
    responses: {
      somethingWentWrong: "Noe gikk galt..."
    },
    actions: {
      edit: "Rediger",
      delete: "Slett",
      details: "Vis detaljer",
      startPicking: "Start plukking",
      pdf: "PDF",
      purchaseOrder: "Innkjøpsordre",
      salesOrder: "Salgsordre",
      email: "E-post",
      startReceiving: "Start mottak",
      produce: "Produser",
      product: "Produkt",
      duplicate: "Dupliser",
      barcode: "Strekkode",
      copy: "Kopier",
      cancel: "Avbryt"
    }
  },
  imports: {
    importModal: {
      heading: "Import",
      subheading: "Data matching",
      importIsAlreadyInProgressAlert: "En annen import pågår allerede. Vent til den er ferdig..",
      updateExisting: "Oppdater eksisterende poster",
      validation: {
        requiredField: "Påkrevd felt må ha en overskrift"
      },
      tips: {
        boolean: "For boolske kolonner vil vi behandle verdier som \"true\" hvis verdien er \"true\" / \"yes\" / \"on\" / \"1\" og som \"false\" ellers",
        codeColumns: "Vær oppmerksom på kolonner som forventes å inneholde koder (merket med <badge><icon/></badge>). Hver verdi du oppgir må samsvare med en <b>kode</b> som <b>allerede</b> finnes i ditt WMS. Dette kobler importen din til riktige produkter, lokasjoner eller andre elementer. Hvis ingen treff finnes, vil du bli varslet via e-post"
      },
      responses: {
        success: "Importen er startet..."
      },
      optionalFields: {
        hide: "Skjul valgfrie felt",
        show: "Vis valgfrie felt"
      },
      codeColumn: "Verdiene i denne kolonnen vil være <b>matched</b> med <b>eksisterende koder</b> for å koble felter.",
      report_email: {
        label: "Send rapporten på epost",
        placeholder: "Skriv inn epostadresse for å sende rapporten når importen er fullført",
        tip: "In case of failure, the report will be sent to this email address"
      },
      buttons: {
        changeFile: "Velg annen fil",
        import: "Importer"
      }
    },
    modules: {
      tripletex: {
        states: {
          inProgress: "Importer data fra Tripletex",
          imported: "Tripletex-data er importert"
        },
        importModal: {
          heading: "Importer data fra Tripletex",
          importIsAlreadyInProgressAlert: "En annen import pågår allerede. Vent til den er ferdig.",
          importSelection: {
            label: "Velg hva som skal importeres:",
            customers: "Kunder",
            products: "Produkter",
            suppliers: "Leverandører",
            orders: "Ordrer"
          },
          rules: {
            label: "Regler for bruk av integrasjon",
            bankAccount: "Faktureringsfunksjonalitet aktiveres bare hvis en gyldig bankkonto er korrekt konfigurert i Tripletex",
            customers: "Suppli vil kun importere kunder/leverandører med utfylt navn, telefonnummer og epostadresse",
            sync: "Eventuelle oppdateringer som gjøres av produkter, kunder og leverandører i begge systemene, vil automatisk gjenspeiles i det andre, slik at datakonsistensen opprettholdes"
          },
          locationDropdown: {
            label: "Legg importe produkter til",
            placeholder: "Velg lokasjon"
          },
          buttons: {
            import: "Importer",
            cancel: "Angre"
          }
        },
        settingsModal: {
          heading: "Tripletex innstillinger",
          features: "Funksjoner",
          projectsSupport: {
            label: "Projekter",
            tip: "Aktiverer kobling mellom Tripletex-prosjekter og Suppli-lokasjoner for å overvåke prosjektspesifikke verdier"
          },
          autoInvoicing: {
            label: "Auto-invoicing",
            tip: "Aktiverer automatisk fakturering etter opprettelse av plukk"
          },
          buttons: {
            cancel: "Angre",
            save: "Lagre"
          }
        }
      },
      poweroffice: {
        states: {
          inProgress: "Importerer data fra PowerOffice GO",
          imported: "PowerOffice GO-data er importert"
        },
        importModal: {
          heading: "Importer data fra PowerOffice GO",
          importIsAlreadyInProgressAlert: "En annen import pågår allerede. Vent til den er ferdig..",
          whatWeImport: {
            label: "Følgende vil bli importert:",
            customers: "Kunder",
            suppliers: "Leverandører",
            products: "Produkter"
          },
          locationDropdown: {
            label: "Legg importerte produkter til",
            placeholder: "Velg lokasjon"
          },
          rules: {
            label: "Regler for bruk av integrasjon",
            sync: "Eventuelle oppdateringer gjort for kunder, leverandører eller produkter i Suppli vil automatisk gjenspeiles i PowerOffice GO, slik at dataene opprettholdes konsistent.",
            masterStock: "Suppli er masteren for lageret. Lagerbeholdningen synkroniseres hver <b>to timer</b> med PowerOffice GO, og oppdateringer kan ta noen minutter før de vises."
          },
          buttons: {
            import: "Importer",
            cancel: "Angre"
          }
        },
        settingsModal: {
          heading: "PowerOffice GO innstillinger",
          features: "Funksjoner",
          projectsSupport: {
            label: "Prosjekter",
            tip: "Aktiverer kobling mellom POGO-prosjekter og Suppli-lokasjoner for å overvåke prosjektspesifikke verdier"
          },
          buttons: {
            cancel: "Angre",
            save: "Lagre"
          }
        }
      },
      shopify: {
        states: {
          inProgress: "Importerer data fra Shopify",
          imported: "Shopify-data er importert",
        },
        importModal: {
          heading: "Importer fra Shopify",
          description: "Administrer lokasjoner og produktimport mellom Shopify og Suppli",
          importSelection: {
            label: "Velg hva som skal importeres"
          },
          entities: {
            products: "Produkter"
          },
          rules: {
            label: "Importregler",
            sync: "Integrasjonen vil automatisk synkronisere produkter, kunder og ordrer mellom systemene.",
            locationMapping: "Lokasjonskartlegging lar deg sikre at det ikke er duplikater av lokasjoner i Suppli. Det er valgfritt, men vi anbefaler å sette dette opp før du bruker integrasjonen og importerer enheter."
          },
          locationsDisplayer: {
            title: "Kartlagte lokasjoner",
            description: "Disse lokasjonene er allerede koblet sammen og kan ikke redigeres.",
            fields: {
              shopify: {
                placeholder: "Shopify-lokasjon",
                unknownValue: "Ukjent Shopify-lokasjon"
              },
              suppli: {
                placeholder: "Suppli-lokasjon",
                unknownValue: "Ukjent Suppli-lokasjon"
              }
            }
          },
          locationsMapper: {
            title: "Lokasjoner å kartlegge",
            description: "Velg hvordan Shopify-lokasjoner skal kartlegges til Suppli",
            sync: {
              button: "Synkroniser",
              responses: {
                success: "Lokasjonskartlegging synkronisert"
              }
            },
            fields: {
              shopify: {
                placeholder: "Shopify-lokasjon"
              },
              suppli: {
                placeholder: "Suppli-lokasjon"
              }
            }
          },
          buttons: {
            import: "Importer",
            cancel: "Angre"
          },
        },
      },
      product: {
        states: {
          inProgress: "Importerer produkter",
          imported: "Produkter er importert",
          error: {
            title: "Det oppsto en feil under import av produkter",
            message: "Rapporten er sendt til e-posten din"
          }
        },
        importModal: {
          heading: "Import produkter",
          tips: {
            location: "All lokasjonsdata kan utelates hvis produktet er en tjeneste"
          },
          options: {
            name: "Navn",
            productCode: "Produkt-ID",
            isService: "Er tjeneste",
            purchasePrice: "Innkjøpspris",
            sellingPrice: "Salgspris",
            defaultLocationCode: "Standard lokation ID",
            section: "Seksjons-ID",
            locationQuantity: "Location antall",
            minInventoryQuantity: "Min lagerbeholdning",
            categoryCode: "Kategori-ID",
            unitCode: "Enhets-ID",
            supplierCode: "Leverandør ID",
            taxCode: "Avgifts-ID",
            collectionCode: "Samling ID",
            currencyCode: "Valutakode",
            barcode: "Strekkode",
            hasRfid: "Har RFID",
            hasBatchNumber: "Har batch nummer",
            hasSerialNumber: "Har serial nummer",
            hasVariant: "Har variant",
            isComponent: "Er Komponent",
            hasPackageUnit: "Har emballasje enhet",
            description: "Beskrivelse",
            weight: "Vekt",
            CBM: "CBM",
            width: "Bredde",
            height: "Høyde",
            length: "Lengde",
            minPurchaseQuantity: "Minste kjøpsantall",
            minSaleQuantity: "Minste salgsantall",
            extraCost: "Ekstrakostnad"
          }
        }
      },
      twenty_four_seven_office: {
        states: {
          inProgress: "Importerer data fra 24SevenOffice",
          imported: "24SevenOffice-data er importert"
        },
        importModal: {
          heading: "Importer data fra 24SevenOffice",
          importIsAlreadyInProgressAlert: "En annen import pågår allerede. Vent til den er ferdig..",
          importSelection: {
            label: "Velg hva som skal importeres:",
            customers: "Kunder",
            products: "Produkter",
            suppliers: "Leverandører",
            orders: "Ordrer",
            categories: "Kategorier"
          },
          rules: {
            label: "Regler for bruk av integrasjon",
            sync: "Eventuelle oppdateringer av bestillinger, produkter, kunder og leverandører i Suppli vil automatisk gjenspeiles i 24SevenOffice, slik at dataene blir konsistente.y",
            backSync: "Oppdateringer gjort i 24SevenOffice vil <bold>ikke</bold> bli reflektert automatisk i Suppli",
            onlyProductsWithCategories: "I henhold til 24SevenOffices regler vil produkter uten kategorier <bold>ikke</bold> synkroniseres",
            invoicesGeneration: "Fakturaer i 24SevenOffice genereres først etter at plukk for den tilhørende ordren er opprettet i Suppli"
          },
          locationDropdown: {
            label: "Legg importerte produkter til",
            placeholder: "Velg lokasjon"
          },
          buttons: {
            import: "Importer",
            cancel: "Angre"
          }
        }
      },
      stock: {
        states: {
          inProgress: "Importerer lagerbeholdning",
          imported: "Lagerbeholdningen er importert",
          error: {
            title: "Det oppsto en feil under import av lagerbeholdning",
            message: "Rapporten er sendt til eposten din"
          }
        },
        importModal: {
          heading: "Importer lagerbeholdning",
          options: {
            name: "Navn",
            productCode: "Produkt-ID",
            isService: "Er tjeneste",
            purchasePrice: "Innkjøpspris",
            sellingPrice: "Salgspris",
            defaultLocationCode: "Standard lokasjon ID",
            section: "Seksjons-ID",
            locationQuantity: "Lokasjon antall",
            minInventoryQuantity: "Min lagerbeholdning",
            categoryCode: "Kategori-ID",
            unitCode: "Enhets-ID",
            supplierCode: "Leverandør ID",
            taxCode: "Avgifts-ID",
            collectionCode: "Samling ID",
            currencyCode: "Valutakode",
            barcode: "Strekkode",
            hasRfid: "Har RFID",
            hasBatchNumber: "Har batchnummer",
            hasSerialNumber: "Har serienummer",
            hasVariant: "Har variant",
            isComponent: "Er komponent",
            hasPackageUnit: "Har emballasje enhet",
            description: "Beskrivelse",
            weight: "Vekt",
            CBM: "CBM",
            width: "Bredde",
            height: "Høyde",
            length: "Lengde",
            minPurchaseQuantity: "Minste kjøpsantall",
            minSaleQuantity: "Minste salgsantall",
            extraCost: "Ekstrakostnad"
          }
        }
      },
      susoft: {
        states: {
          inProgress: "Importerer data fra Susoft POS",
          imported: "Susoft POS-data er importert",
        },
        importModal: {
          heading: "Importer data fra Susoft POS",
          importIsAlreadyInProgressAlert: "En annen import pågår allerede. Vent til den er ferdig.",
          whatWeImport: {
            label: "Vi vil importere:",
            products: "Produkter",
          },
          locationDropdown: {
            label: "Legg importerte produkter til",
            placeholder: "Velg lokasjon",
          },
          buttons: {
            import: "Importer",
            cancel: "Angre",
          },
        },
      },
    }
  },
  exports: {
    modules: {
      product: {
        states: {
          inProgress: "Eksporterer produkter"
        }
      },
      stock: {
        states: {
          inProgress: "Eksporterer lagernivåer"
        }
      },
      transfer: {
        states: {
          inProgress: "Eksporterer overføringer"
        }
      },
      sale_order: {
        states: {
          inProgress: "Eksporterer salgsordre"
        }
      },
      purchase_order: {
        states: {
          inProgress: "Eksporterer innkjøpsordre"
        }
      },
      susoft: {
        states: {
          inProgress: "Eksporterer data til Susoft POS",
        },
        exportModal: {
          heading: "Eksporter data til Susoft POS",
          exportIsAlreadyInProgressAlert: "En annen eksport pågår allerede. Vent til den er ferdig.",
          description: "Produkter fra Suppli vil bli eksportert til Susoft POS.",
          buttons: {
            export: "Eksporter",
            cancel: "Angre",
          },
        },
      },
    }
  },
  help: {
    changelog: {
      listTitle: "Siste oppdateringer",
      noUpdates: "Ingen oppdateringer tilgjengelig"
    }
  }
};

export default translationEN;
